{
  "madsrdf": "http://www.loc.gov/mads/rdf/v1#",
  "bflc": "http://id.loc.gov/ontologies/bflc/",
  "foaf": "http://xmlns.com/foaf/0.1/",
  "rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  "dbo": "http://dbpedia.org/ontology/",
  "rdfs": "http://www.w3.org/2000/01/rdf-schema#",
  "yago": "http://yago-knowledge.org/resource/",
  "dc": "http://purl.org/dc/elements/1.1/",
  "dbp": "http://dbpedia.org/property/",
  "owl": "http://www.w3.org/2002/07/owl#",
  "skos": "http://www.w3.org/2004/02/skos/core#",
  "gr": "http://purl.org/goodrelations/v1#",
  "geo": "http://www.opengis.net/ont/geosparql#",
  "spacerel": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "xsd": "http://www.w3.org/2001/XMLSchema#",
  "org": "http://www.w3.org/ns/org#",
  "dcat": "http://www.w3.org/ns/dcat#",
  "dct": "http://purl.org/dc/terms/",
  "ex": "http://example.org/",
  "dcterms": "http://purl.org/dc/terms/",
  "qb": "http://purl.org/linked-data/cube#",
  "prov": "http://www.w3.org/ns/prov#",
  "sioc": "http://rdfs.org/sioc/ns#",
  "xtypes": "http://purl.org/xtypes/",
  "dbpedia": "http://dbpedia.org/resource/",
  "void": "http://rdfs.org/ns/void#",
  "ont": "http://purl.org/net/ns/ontology-annot#",
  "onto": "http://www.ontotext.com/",
  "sio": "http://semanticscience.org/resource/",
  "obo": "http://purl.obolibrary.org/obo/",
  "dcterm": "http://purl.org/dc/terms/",
  "schema": "http://schema.org/",
  "ttp": "http://eample.com/test#",
  "bf": "http://id.loc.gov/ontologies/bibframe/",
  "search": "http://sindice.com/vocab/search#",
  "sd": "http://www.w3.org/ns/sparql-service-description#",
  "urn": "http://fliqz.com/",
  "frbr": "http://purl.org/vocab/frbr/core#",
  "stat": "http://www.w3.org/ns/posix/stat#",
  "vcard": "http://www.w3.org/2006/vcard/ns#",
  "tag": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "dbr": "http://dbpedia.org/resource/",
  "commerce": "http://purl.org/commerce#",
  "bibo": "http://purl.org/ontology/bibo/",
  "pto": "http://www.productontology.org/id/",
  "rss": "http://purl.org/rss/1.0/",
  "oo": "http://purl.org/openorg/",
  "gldp": "http://www.w3.org/ns/people#",
  "vann": "http://purl.org/vocab/vann/",
  "content": "http://purl.org/rss/1.0/modules/content/",
  "geonames": "http://www.geonames.org/ontology#",
  "fb": "http://rdf.freebase.com/ns/",
  "event": "http://purl.org/NET/c4dm/event.owl#",
  "gen": "http://purl.org/gen/0.1#",
  "wd": "http://www.wikidata.org/entity/",
  "dcmit": "http://purl.org/dc/dcmitype/",
  "cc": "http://creativecommons.org/ns#",
  "dbpprop": "http://dbpedia.org/property/",
  "http": "http://www.w3.org/2011/http#",
  "doap": "http://usefulinc.com/ns/doap#",
  "rr": "http://www.w3.org/ns/r2rml#",
  "swrc": "http://swrc.ontoware.org/ontology#",
  "as": "https://www.w3.org/ns/activitystreams#",
  "nie": "http://www.semanticdesktop.org/ontologies/2007/01/19/nie#",
  "leaks": "https://cuzin.com/",
  "sc": "https://schema.org/",
  "md": "http://www.w3.org/ns/md#",
  "drugbank": "http://www4.wiwiss.fu-berlin.de/drugbank/resource/drugbank/",
  "fn": "http://www.w3.org/2005/xpath-functions#",
  "cv": "http://rdfs.org/resume-rdf/",
  "wot": "http://xmlns.com/wot/0.1/",
  "prog": "http://purl.org/prog/",
  "aiiso": "http://purl.org/vocab/aiiso/schema#",
  "ma": "http://www.w3.org/ns/ma-ont#",
  "uniprot": "http://purl.uniprot.org/uniprot/",
  "tl": "http://purl.org/NET/c4dm/timeline.owl#",
  "daia": "http://purl.org/ontology/daia/",
  "swc": "http://data.semanticweb.org/ns/swc/ontology#",
  "akt": "http://www.aktors.org/ontology/portal#",
  "ical": "http://www.w3.org/2002/12/cal/ical#",
  "xhtml": "http://www.w3.org/1999/xhtml#",
  "rel": "http://purl.org/vocab/relationship/",
  "crm": "http://www.cidoc-crm.org/cidoc-crm/",
  "bio": "http://purl.org/vocab/bio/0.1/",
  "earl": "http://www.w3.org/ns/earl#",
  "unit": "http://qudt.org/vocab/unit/",
  "dv": "http://rdf.data-vocabulary.org/#",
  "mo": "http://purl.org/ontology/mo/",
  "marcrel": "http://id.loc.gov/vocabulary/relators/",
  "ov": "http://open.vocab.org/terms/",
  "rdfg": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "xhv": "http://www.w3.org/1999/xhtml/vocab#",
  "cs": "http://purl.org/vocab/changeset/schema#",
  "afn": "http://jena.apache.org/ARQ/function#",
  "ad": "http://schemas.talis.com/2005/address/schema#",
  "co": "http://purl.org/ontology/co/core#",
  "vs": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "dc11": "http://purl.org/dc/elements/1.1/",
  "og": "http://opengraphprotocol.org/schema/",
  "xs": "http://www.w3.org/2001/XMLSchema#",
  "air": "http://dig.csail.mit.edu/TAMI/2007/amord/air#",
  "mu": "http://mu.semte.ch/vocabularies/core/",
  "bill": "http://www.rdfabout.com/rdf/schema/usbill/",
  "test2": "http://this.invalid/test2#",
  "xfn": "http://gmpg.org/xfn/11#",
  "book": "http://purl.org/NET/book/vocab#",
  "log": "http://www.w3.org/2000/10/swap/log#",
  "musim": "http://purl.org/ontology/similarity/",
  "factbook": "http://wifo5-04.informatik.uni-mannheim.de/factbook/ns#",
  "media": "http://search.yahoo.com/searchmonkey/media/",
  "dcq": "http://purl.org/dc/qualifiers/1.0/",
  "ome": "http://purl.org/ontomedia/core/expression#",
  "xf": "http://www.w3.org/2002/xforms/",
  "cld": "http://purl.org/cld/terms/",
  "d2rq": "http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#",
  "qudt": "http://qudt.org/schema/qudt/",
  "cal": "http://www.w3.org/2002/12/cal/ical#",
  "prop": "http://dbpedia.org/property/",
  "ir": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "biblio": "http://purl.org/net/biblio#",
  "rev": "http://purl.org/stuff/rev#",
  "reco": "http://purl.org/reco#",
  "sism": "http://purl.oclc.org/NET/sism/0.1/",
  "osag": "http://www.ordnancesurvey.co.uk/ontology/AdministrativeGeography/v2.0/AdministrativeGeography.rdf#",
  "days": "http://ontologi.es/days#",
  "botany": "http://purl.org/NET/biol/botany#",
  "dbowl": "http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#",
  "af": "http://purl.org/ontology/af/",
  "rif": "http://www.w3.org/2007/rif#",
  "ctag": "http://commontag.org/ns#",
  "dir": "http://schemas.talis.com/2005/dir/schema#",
  "ok": "http://okkam.org/terms#",
  "cmp": "http://www.ontologydesignpatterns.org/cp/owl/componency.owl#",
  "sr": "http://www.openrdf.org/config/repository/sail#",
  "tzont": "http://www.w3.org/2006/timezone#",
  "math": "http://www.w3.org/2000/10/swap/math#",
  "pc": "http://purl.org/procurement/public-contracts#",
  "admin": "http://webns.net/mvcb/",
  "memo": "http://ontologies.smile.deri.ie/2009/02/27/memo#",
  "giving": "http://ontologi.es/giving#",
  "sdmx": "http://purl.org/linked-data/sdmx#",
  "myspace": "http://purl.org/ontology/myspace#",
  "lomvoc": "http://ltsc.ieee.org/rdf/lomv1p0/vocabulary#",
  "cfp": "http://sw.deri.org/2005/08/conf/cfp.owl#",
  "dcn": "http://www.w3.org/2007/uwa/context/deliverycontext.owl#",
  "lyou": "http://purl.org/linkingyou/",
  "xmp": "http://ns.adobe.com/xap/1.0/",
  "swanq": "http://purl.org/swan/1.2/qualifiers/",
  "jdbc": "http://d2rq.org/terms/jdbc/",
  "time": "http://www.w3.org/2006/time#",
  "owlim": "http://www.ontotext.com/trree/owlim#",
  "omn": "http://open-multinet.info/ontology/omn#",
  "swande": "http://purl.org/swan/1.2/discourse-elements/",
  "dcam": "http://purl.org/dc/dcam/",
  "gn": "http://www.geonames.org/ontology#",
  "nif": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#",
  "skosxl": "http://www.w3.org/2008/05/skos-xl#",
  "con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "cyc": "http://sw.opencyc.org/concept/",
  "adms": "http://www.w3.org/ns/adms#",
  "oa": "http://www.w3.org/ns/oa#",
  "cdm": "http://publications.europa.eu/ontology/cdm#",
  "gvp": "http://vocab.getty.edu/ontology#",
  "ontology": "http://dbpedia.org/ontology/",
  "openlinks": "http://www.openlinksw.com/schemas/virtrdf#",
  "sh": "http://www.w3.org/ns/shacl#",
  "db": "http://dbpedia.org/",
  "sdmxdim": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "type": "http://teste.com/teste/",
  "isbd": "http://iflastandards.info/ns/isbd/elements/",
  "om": "http://opendata.caceres.es/def/ontomunicipio#",
  "eat": "http://www.eat.rl.ac.uk/#",
  "lemon": "http://lemon-model.net/lemon#",
  "photoshop": "http://ns.adobe.com/photoshop/1.0/",
  "aat": "http://vocab.getty.edu/aat/",
  "wfs": "http://schemas.opengis.net/wfs/",
  "room": "http://vocab.deri.ie/rooms#",
  "wdt": "http://www.wikidata.org/prop/direct/",
  "tgn": "http://vocab.getty.edu/tgn/",
  "exif": "http://www.w3.org/2003/12/exif/ns#",
  "ulan": "http://vocab.getty.edu/ulan/",
  "fabio": "http://purl.org/spar/fabio/",
  "ac": "http://umbel.org/umbel/ac/",
  "core": "http://vivoweb.org/ontology/core#",
  "test": "https://test4.example.com/",
  "ore": "http://www.openarchives.org/ore/terms/",
  "xsi": "http://www.w3.org/2001/XMLSchema-instance#",
  "prism": "http://prismstandard.org/namespaces/basic/2.0/",
  "cert": "http://www.w3.org/ns/auth/cert#",
  "sdmxa": "http://purl.org/linked-data/sdmx/2009/attribute#",
  "itsrdf": "http://www.w3.org/2005/11/its/rdf#",
  "fise": "http://fise.iks-project.eu/ontology/",
  "nsogi": "http://prefix.cc/nsogi:",
  "cnt": "http://www.w3.org/2011/content#",
  "sf": "http://www.opengis.net/ont/sf#",
  "dul": "http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#",
  "lv": "http://purl.org/lobid/lv#",
  "voaf": "http://purl.org/vocommons/voaf#",
  "swrcfe": "http://www.morelab.deusto.es/ontologies/swrcfe#",
  "edm": "http://www.europeana.eu/schemas/edm/",
  "eg": "http://www.example.org/",
  "swrl": "http://www.w3.org/2003/11/swrl#",
  "gndo": "http://d-nb.info/standards/elementset/gnd#",
  "gtfs": "http://vocab.gtfs.org/terms#",
  "ssn": "http://www.w3.org/ns/ssn/",
  "dbc": "http://dbpedia.org/resource/Category:",
  "ro": "http://purl.org/wf4ever/ro#",
  "xml": "http://www.w3.org/XML/1998/namespace/",
  "nfo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#",
  "swrlb": "http://www.w3.org/2003/11/swrlb#",
  "music": "http://musicontology.com/",
  "movie": "http://data.linkedmdb.org/resource/movie/",
  "bif": "http://www.openlinksw.com/schemas/bif#",
  "wikidata": "http://www.wikidata.org/entity/",
  "leak": "http://maco.com/",
  "go": "http://purl.obolibrary.org/obo/GO_",
  "dbprop": "http://dbpedia.org/property/",
  "wp": "http://vocabularies.wikipathways.org/",
  "cco": "http://www.ontologyrepository.com/CommonCoreOntologies/",
  "pat": "http://purl.org/hpi/patchr#",
  "ceo": "https://linkeddata.cultureelerfgoed.nl/def/ceo#",
  "penn": "http://purl.org/olia/penn.owl#",
  "dbkwik": "http://dbkwik.webdatacommons.org/",
  "ping": "https://namso-gen.com/",
  "loc": "http://id.loc.gov/",
  "am": "http://vocab.deri.ie/am#",
  "st": "http://ns.inria.fr/sparql-template/",
  "sp": "http://spinrdf.org/sp#",
  "ldp": "http://www.w3.org/ns/ldp#",
  "dblp": "http://dblp.uni-trier.de/rdf/schema-2015-01-26#",
  "lexinfo": "http://www.lexinfo.net/ontology/3.0/lexinfo#",
  "mods": "http://www.loc.gov/mods/v3#",
  "nmo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nmo#",
  "sec": "https://w3id.org/security#",
  "bd": "http://www.bigdata.com/rdf#",
  "dce": "http://purl.org/dc/elements/1.1/",
  "sdo": "https://schema.org/",
  "chebi": "http://purl.obolibrary.org/obo/CHEBI_",
  "nao": "http://www.semanticdesktop.org/ontologies/2007/08/15/nao#",
  "product": "http://purl.org/commerce/product#",
  "example": "http://www.example.org/rdf#",
  "imm": "http://schemas.microsoft.com/imm/",
  "euvoc": "http://publications.europa.eu/ontology/euvoc#",
  "siocserv": "http://rdfs.org/sioc/services#",
  "up": "http://purl.uniprot.org/core/",
  "geoes": "http://geo.linkeddata.es/ontology/",
  "sparql": "http://www.w3.org/ns/sparql#",
  "gnd": "http://d-nb.info/gnd/",
  "sioct": "http://rdfs.org/sioc/types#",
  "cerif": "http://spi-fm.uca.es/neologism/cerif#",
  "rec": "http://purl.org/ontology/rec/core#",
  "list": "http://www.w3.org/2000/10/swap/list#",
  "ptr": "http://www.w3.org/2009/pointers#",
  "gd": "http://rdf.data-vocabulary.org/#",
  "mf": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "coref": "http://www.rkbexplorer.com/ontologies/coref#",
  "whois": "http://www.kanzaki.com/ns/whois#",
  "scovo": "http://purl.org/NET/scovo#",
  "api": "http://purl.org/linked-data/api/vocab#",
  "olia": "http://purl.org/olia/olia.owl#",
  "java": "http://www.w3.org/2007/uwa/context/java.owl#",
  "acc": "http://purl.org/NET/acc#",
  "spin": "http://spinrdf.org/spin#",
  "sirext": "http://t.me/sirextt/247:",
  "doc": "http://www.w3.org/2000/10/swap/pim/doc#",
  "wiki": "http://en.wikipedia.org/wiki/",
  "space": "http://www.w3.org/ns/pim/space#",
  "cube": "https://cube.link/",
  "ms": "http://purl.org/obo/owl/MS#",
  "opm": "https://w3id.org/opm#",
  "geof": "http://www.opengis.net/def/function/geosparql/",
  "meta": "https://krr.triply.cc/krr/sameas-meta/def/",
  "pmlj": "http://inference-web.org/2.0/pml-justification.owl#",
  "gold": "http://purl.org/linguistics/gold/",
  "dbnary": "http://kaiko.getalp.org/dbnary#",
  "xlink": "https://es.scribd.com/doc/79794476/05-Ejercicios-Resueltos-Caja-Negra-y-Recapitulacion/",
  "ti": "http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#",
  "cro": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "bing": "http://bing.com/schema/media/",
  "lgd": "http://linkedgeodata.org/triplify/",
  "rdfsharp": "https://rdfsharp.codeplex.com/",
  "iot": "http://iotschema.org/",
  "pext": "http://www.ontotext.com/proton/protonext#",
  "vivo": "http://vivoweb.org/ontology/core#",
  "sim": "http://www.w3id.org/simulation/ontology/",
  "hg": "http://rdf.histograph.io/",
  "nco": "http://www.semanticdesktop.org/ontologies/2007/03/22/nco#",
  "bp": "http://www.biopax.org/release/biopax-level3.owl#",
  "rsa": "http://www.w3.org/ns/auth/rsa#",
  "po": "http://purl.obolibrary.org/obo/PO_",
  "akts": "http://www.aktors.org/ontology/support#",
  "lu": "http://www.ontologydesignpatterns.org/ont/framenet/abox/lu/",
  "pim": "http://www.w3.org/ns/pim/space#",
  "geosparql": "http://www.opengis.net/ont/geosparql#",
  "kb": "http://deductions.sf.net/ontology/knowledge_base.owl#",
  "georss": "http://www.georss.org/georss/",
  "cgov": "http://reference.data.gov.uk/def/central-government/",
  "acl": "http://www.w3.org/ns/auth/acl#",
  "nt": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "resource": "http://dbpedia.org/resource/",
  "cito": "http://purl.org/spar/cito/",
  "video": "http://purl.org/ontology/video#",
  "sosa": "http://www.w3.org/ns/sosa/",
  "name": "http://example.org/name#",
  "wgs": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "gist": "https://ontologies.semanticarts.com/o/gistCore#",
  "xl": "http://langegger.at/xlwrap/vocab#",
  "seas": "https://w3id.org/seas/",
  "pr": "http://purl.org/ontology/prv/core#",
  "ontolex": "http://www.w3.org/ns/lemon/ontolex#",
  "dbpediaowl": "http://dbpedia.org/owl/",
  "wikipedia": "https://en.wikipedia.org/wiki/",
  "cidoc": "http://www.cidoc-crm.org/cidoc-crm/",
  "postcode": "http://data.ordnancesurvey.co.uk/id/postcodeunit/",
  "stanford": "http://purl.org/olia/stanford.owl#",
  "pav": "http://purl.org/pav/",
  "web": "http://www.w3.org/2007/uwa/context/web.owl#",
  "ean": "http://openean.kaufkauf.net/id/",
  "role": "https://w3id.org/role/",
  "acm": "http://www.rkbexplorer.com/ontologies/acm#",
  "bag": "https://bag2.basisregistraties.overheid.nl/bag/def/",
  "eu": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "exterms": "http://www.example.org/terms/",
  "dco": "http://info.deepcarbon.net/schema#",
  "dcm": "http://purl.org/dc/dcmitype/",
  "httph": "http://www.w3.org/2007/ont/httph#",
  "ps": "https://w3id.org/payswarm#",
  "saref": "https://saref.etsi.org/core/",
  "wn": "http://xmlns.com/wordnet/1.6/",
  "prv": "http://purl.org/net/provenance/ns#",
  "pgterms": "http://www.gutenberg.org/2009/pgterms/",
  "iso": "http://purl.org/iso25964/skos-thes#",
  "purl": "http://purl.org/dc/terms/",
  "overheid": "http://standaarden.overheid.nl/owms/",
  "ero": "http://purl.obolibrary.org/obo/",
  "dcatapit": "http://dati.gov.it/onto/dcatapit#",
  "inno": "http://purl.org/innovation/ns#",
  "formats": "http://www.w3.org/ns/formats/",
  "wo": "http://purl.org/ontology/wo/",
  "service": "http://purl.org/ontology/service#",
  "greg": "http://www.w3.org/ns/time/gregorian/",
  "admingeo": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "lime": "http://www.w3.org/ns/lemon/lime#",
  "ass": "http://uptheasset.org/ontology#",
  "wdrs": "http://www.w3.org/2007/05/powder-s#",
  "bmo": "http://collection.britishmuseum.org/id/ontology/",
  "ocd": "http://dati.camera.it/ocd/",
  "atom": "http://www.w3.org/2005/Atom/",
  "sider": "http://www4.wiwiss.fu-berlin.de/sider/resource/sider/",
  "smf": "http://topbraid.org/sparqlmotionfunctions#",
  "es": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "rdfdf": "http://www.openlinksw.com/virtrdf-data-formats#",
  "wn20schema": "http://www.w3.org/2006/03/wn/wn20/schema/",
  "premis": "http://www.loc.gov/premis/rdf/v3/",
  "ndl": "http://schemas.ogf.org/nml/2013/05/base#",
  "iao": "http://purl.obolibrary.org/obo/IAO_",
  "zoology": "http://purl.org/NET/biol/zoology#",
  "mm": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/function#",
  "daml": "http://www.daml.org/2001/03/daml+oil#",
  "abc": "http://www.metadata.net/harmony/ABCSchemaV5Commented.rdf#",
  "xkos": "http://rdf-vocabulary.ddialliance.org/xkos#",
  "food": "http://purl.org/foodontology#",
  "hydra": "http://www.w3.org/ns/hydra/core#",
  "won": "https://w3id.org/won/core#",
  "edam": "http://edamontology.org/",
  "res": "http://dbpedia.org/resource/",
  "cpa": "http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#",
  "gsp": "http://www.opengis.net/ont/geosparql#",
  "myspo": "http://purl.org/ontology/myspace#",
  "lode": "http://linkedevents.org/ontology/",
  "irw": "http://www.ontologydesignpatterns.org/ont/web/irw.owl#",
  "so": "http://schema.org/",
  "hp": "http://pictogram.tokyo/vocabulary#",
  "dt": "http://w3id.org/dt#",
  "swid": "http://semanticweb.org/id/",
  "cheminf": "http://www.semanticweb.org/ontologies/cheminf.owl#",
  "scot": "http://rdfs.org/scot/ns#",
  "blt": "http://www.bl.uk/schemas/bibliographic/blterms#",
  "spl": "http://spinrdf.org/spl#",
  "agg": "http://purl.org/twc/health/vocab/aggregate/",
  "bfo": "http://purl.obolibrary.org/obo/",
  "resist": "http://www.rkbexplorer.com/ontologies/resist#",
  "site": "http://ns.ontowiki.net/SysOnt/Site/",
  "label": "http://purl.org/net/vocab/2004/03/label#",
  "sdl": "http://purl.org/vocab/riro/sdl#",
  "omp": "http://purl.org/ontomedia/ext/common/profession#",
  "omt": "http://purl.org/ontomedia/ext/common/trait#",
  "faldo": "http://biohackathon.org/resource/faldo#",
  "orges": "http://datos.gob.es/def/sector-publico/organizacion#",
  "tmo": "http://www.semanticdesktop.org/ontologies/2008/05/20/tmo#",
  "ignf": "http://data.ign.fr/def/ignf#",
  "fed": "http://www.openrdf.org/config/sail/federation#",
  "pmt": "http://tipsy.googlecode.com/svn/trunk/vocab/pmt#",
  "bibframe": "http://id.loc.gov/ontologies/bibframe/",
  "sml": "https://w3id.org/sml/def#",
  "oad": "http://lod.xdams.org/reload/oad/",
  "cpm": "http://catalogus-professorum.org/cpm/2/",
  "rov": "http://www.w3.org/ns/regorg#",
  "ref": "http://purl.org/vocab/relationship/",
  "isothes": "http://purl.org/iso25964/skos-thes#",
  "rdau": "http://rdaregistry.info/Elements/u/",
  "eco": "http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#",
  "act": "http://www.w3.org/2007/rif-builtin-action#",
  "ses": "http://lod.taxonconcept.org/ses/",
  "user": "http://schemas.talis.com/2005/user/schema#",
  "cordis": "http://cordis.europa.eu/projects/",
  "wordnet": "http://wordnet-rdf.princeton.edu/ontology#",
  "airport": "http://www.daml.org/2001/10/html/airport-ont#",
  "ya": "http://blogs.yandex.ru/schema/foaf/",
  "ecs": "http://rdf.ecs.soton.ac.uk/ontology/ecs#",
  "phil": "http://philosurfical.open.ac.uk/ontology/philosurfical.owl#",
  "rnews": "http://iptc.org/std/rNews/2011-10-07#",
  "link": "http://www.w3.org/2007/ont/link#",
  "taxon": "http://purl.uniprot.org/taxonomy/",
  "prj": "http://purl.org/stuff/project/",
  "ub": "http://www.lehigh.edu/~zhp2/2004/0401/univ-bench.owl#",
  "library": "http://purl.org/library/",
  "audio": "http://purl.org/media/audio#",
  "fe": "http://www.ontologydesignpatterns.org/ont/framenet/abox/fe/",
  "city": "http://datos.localidata.com/def/City#",
  "opensearch": "http://a9.com/-/spec/opensearch/1.1/",
  "ludo": "http://ns.inria.fr/ludo/v1#",
  "awol": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "frame": "http://www.ontologydesignpatterns.org/ont/framenet/abox/frame/",
  "biocore": "http://bio2rdf.org/core#",
  "fresnel": "http://www.w3.org/2004/09/fresnel#",
  "rs": "http://rightsstatements.org/vocab/",
  "taxo": "http://purl.org/rss/1.0/modules/taxonomy/",
  "sit": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "meteo": "http://purl.org/ns/meteo#",
  "linkedmdb": "http://data.linkedmdb.org/",
  "npg": "http://ns.nature.com/terms/",
  "net": "http://www.w3.org/2007/uwa/context/network.owl#",
  "sport": "http://purl.org/ontology/sport/",
  "wv": "http://vocab.org/waiver/terms/",
  "swp": "http://www.w3.org/2004/03/trix/swp-2/",
  "granatum": "http://chem.deri.ie/granatum/",
  "sesame": "http://www.openrdf.org/schema/sesame#",
  "asn": "http://purl.org/ASN/schema/core/",
  "os": "http://www.w3.org/2000/10/swap/os#",
  "bl": "https://w3id.org/biolink/vocab/",
  "cmo": "http://purl.org/twc/ontologies/cmo.owl#",
  "arg": "http://spinrdf.org/arg#",
  "efo": "http://www.ebi.ac.uk/efo/",
  "vra": "http://purl.org/vra/",
  "fbgeo": "http://rdf.freebase.com/ns/location/geocode/",
  "bio2rdf": "http://bio2rdf.org/",
  "uco": "http://purl.org/uco/ns#",
  "conv": "http://purl.org/twc/vocab/conversion/",
  "xhe": "http://buzzword.org.uk/rdf/xhtml-elements#",
  "organism": "http://eulersharp.sourceforge.net/2003/03swap/organism#",
  "mime": "https://www.iana.org/assignments/media-types/",
  "lom": "http://ltsc.ieee.org/rdf/lomv1p0/lom#",
  "vocab": "http://rdf.ontology2.com/vocab#",
  "umbelrc": "http://umbel.org/umbel/rc/",
  "tdb": "http://jena.hpl.hp.com/2008/tdb#",
  "rail": "http://ontologi.es/rail/vocab#",
  "acco": "http://purl.org/acco/ns#",
  "bne": "http://datos.bne.es/resource/",
  "worldbank": "http://worldbank.270a.info/dataset/",
  "ao": "http://purl.org/ontology/ao/core#",
  "conversion": "http://purl.org/twc/vocab/conversion/",
  "disco": "http://rdf-vocabulary.ddialliance.org/discovery#",
  "cdt": "https://w3id.org/cdt/",
  "rep": "http://www.openrdf.org/config/repository#",
  "doac": "http://ramonantonio.net/doac/0.1/#",
  "lgdo": "http://linkedgeodata.org/ontology/",
  "pbo": "http://purl.org/ontology/pbo/core#",
  "txn": "http://lod.taxonconcept.org/ontology/txn.owl#",
  "dctype": "http://purl.org/dc/dcmitype/",
  "money": "http://purl.org/net/rdf-money/",
  "compass": "http://purl.org/net/compass#",
  "oc": "http://opencoinage.org/rdf/",
  "umbel": "http://umbel.org/umbel#",
  "lx": "http://purl.org/NET/lx#",
  "spc": "http://purl.org/ontomedia/core/space#",
  "dwc": "http://rs.tdwg.org/dwc/terms/",
  "protege": "http://protege.stanford.edu/system#",
  "crypto": "http://www.w3.org/2000/10/swap/crypto#",
  "omb": "http://purl.org/ontomedia/ext/common/being#",
  "ct": "http://data.linkedct.org/resource/linkedct/",
  "lfm": "http://purl.org/ontology/last-fm/",
  "wgs84": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "powder": "http://www.w3.org/2007/05/powder#",
  "code": "http://telegraphis.net/ontology/measurement/code#",
  "frir": "http://purl.org/twc/ontology/frir.owl#",
  "nrl": "http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#",
  "custom": "http://www.openrdf.org/config/sail/custom#",
  "ic": "http://imi.go.jp/ns/core/rdf#",
  "rdrel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "lang": "http://ontologi.es/lang/core#",
  "omm": "http://purl.org/ontomedia/core/media#",
  "affy": "http://www.affymetrix.com/community/publications/affymetrix/tmsplice#",
  "sco": "http://purl.org/ontology/sco#",
  "obj": "http://www.openrdf.org/rdf/2009/object#",
  "atomix": "http://buzzword.org.uk/rdf/atomix#",
  "bibtex": "http://purl.org/net/nknouf/ns/bibtex#",
  "fec": "http://www.rdfabout.com/rdf/schema/usfec/",
  "ire": "http://www.ontologydesignpatterns.org/cpont/ire.owl#",
  "pom": "http://maven.apache.org/POM/4.0.0#",
  "pay": "http://reference.data.gov.uk/def/payment#",
  "muto": "http://purl.org/muto/core#",
  "bbc": "http://www.bbc.co.uk/ontologies/news/",
  "arch": "http://purl.org/archival/vocab/arch#",
  "pro": "http://purl.org/hpi/patchr#",
  "ddc": "http://purl.org/NET/decimalised#",
  "soc": "http://purl.org/net/hdlipcores/ontology/soc#",
  "coo": "http://purl.org/coo/ns#",
  "isq": "http://purl.org/ontology/is/quality/",
  "gml": "http://www.opengis.net/ont/gml#",
  "person": "http://www.w3.org/ns/person#",
  "mp": "http://jicamaro.info/mp#",
  "yoda": "http://purl.org/NET/yoda#",
  "mysql": "http://web-semantics.org/ns/mysql/",
  "r2rml": "http://www.w3.org/ns/r2rml#",
  "apivc": "http://purl.org/linked-data/api/vocab#",
  "biol": "http://purl.org/NET/biol/ns#",
  "rei": "http://www.w3.org/2004/06/rei#",
  "contact": "http://www.w3.org/2000/10/swap/pim/contact#",
  "vsr": "http://purl.org/twc/vocab/vsr#",
  "rdac": "http://rdaregistry.info/Elements/c/",
  "mit": "http://purl.org/ontology/mo/mit#",
  "ppo": "http://vocab.deri.ie/ppo#",
  "locn": "http://www.w3.org/ns/locn#",
  "deo": "http://purl.org/spar/deo/",
  "aos": "http://rdf.muninn-project.org/ontologies/appearances#",
  "swh": "http://plugin.org.uk/swh-plugins/",
  "pmlr": "http://inference-web.org/2.0/pml-relation.owl#",
  "xds": "http://www.w3.org/2001/XMLSchema#",
  "eli": "http://data.europa.eu/eli/ontology#",
  "interval": "http://reference.data.gov.uk/def/intervals/",
  "gso": "http://www.w3.org/2006/gen/ont#",
  "rv": "https://data.elsevier.com/research/schema/rv/",
  "freebase": "http://rdf.freebase.com/ns/",
  "rlog": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#",
  "gpt": "http://purl.org/vocab/riro/gpt#",
  "ngeo": "http://geovocab.org/geometry#",
  "usgov": "http://www.rdfabout.com/rdf/schema/usgovt/",
  "zem": "http://s.zemanta.com/ns#",
  "provone": "http://purl.org/provone#",
  "hard": "http://www.w3.org/2007/uwa/context/hardware.owl#",
  "courseware": "http://courseware.rkbexplorer.com/ontologies/courseware#",
  "bib": "http://zeitkunst.org/bibtex/0.1/bibtex.owl#",
  "oac": "https://w3id.org/oac#",
  "nexif": "http://www.semanticdesktop.org/ontologies/2007/05/10/nexif#",
  "ui": "http://www.w3.org/ns/ui#",
  "odrl": "http://www.w3.org/ns/odrl/2/",
  "aifb": "http://www.aifb.kit.edu/id/",
  "is": "http://purl.org/ontology/is/core#",
  "cpv": "http://purl.org/weso/cpv/",
  "payment": "http://reference.data.gov.uk/def/payment#",
  "meetup": "http://www.lotico.com/meetup/",
  "viaf": "http://viaf.org/viaf/",
  "vso": "http://purl.org/vso/ns#",
  "xro": "http://purl.org/xro/ns#",
  "sem": "http://semanticweb.cs.vu.nl/2009/11/sem/",
  "address": "http://schemas.talis.com/2005/address/schema#",
  "pos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "bridge": "http://purl.org/vocommons/bridge#",
  "climb": "http://climb.dataincubator.org/vocabs/climb/",
  "states": "http://www.w3.org/2005/07/aaa#",
  "article": "http://ogp.me/ns/article#",
  "nuts": "http://dd.eionet.europa.eu/vocabulary/common/nuts/",
  "sdm": "https://w3id.org/okn/o/sdm#",
  "bsb": "http://opacplus.bsb-muenchen.de/title/",
  "cdc": "https://w3id.org/cdc#",
  "wnschema": "http://www.cogsci.princeton.edu/~wn/schema/",
  "cycann": "http://sw.cyc.com/CycAnnotations_v1#",
  "cex": "http://purl.org/weso/ontology/computex#",
  "psys": "http://proton.semanticweb.org/protonsys#",
  "gob": "http://purl.org/ontology/last-fm/",
  "pdo": "http://ontologies.smile.deri.ie/pdo#",
  "game": "http://data.totl.net/game/",
  "kwijibo": "http://kwijibo.talis.com/",
  "oboinowl": "http://www.geneontology.org/formats/oboInOwl#",
  "doclist": "http://www.junkwork.net/xml/DocumentList#",
  "teach": "http://linkedscience.org/teach/ns#",
  "dso": "http://purl.org/ontology/dso#",
  "dbpp": "http://dbpedia.org/property/",
  "dcmitype": "http://purl.org/dc/dcmitype/",
  "xen": "http://buzzword.org.uk/rdf/xen#",
  "omc": "http://purl.org/ontomedia/ext/common/bestiary#",
  "vote": "http://www.rdfabout.com/rdf/schema/vote/",
  "vaem": "http://www.linkedmodel.org/schema/vaem#",
  "prot": "http://www.proteinontology.info/po.owl#",
  "uri": "http://purl.org/NET/uri#",
  "agro": "http://purl.obolibrary.org/obo/agro.owl#",
  "ebucore": "http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#",
  "com": "http://purl.org/commerce#",
  "swanco": "http://purl.org/swan/1.2/swan-commons/",
  "muo": "http://purl.oclc.org/NET/muo/muo#",
  "xforms": "http://www.w3.org/2002/xforms/",
  "ttl": "http://www.w3.org/2008/turtle#",
  "oboe": "http://ecoinformatics.org/oboe/oboe.1.0/oboe-core.owl#",
  "wi": "http://purl.org/ontology/wi/core#",
  "conserv": "http://conserv.deri.ie/ontology#",
  "politico": "http://www.rdfabout.com/rdf/schema/politico/",
  "soft": "http://www.w3.org/2007/uwa/context/software.owl#",
  "lp": "http://launchpad.net/rdf/launchpad#",
  "voag": "http://voag.linkedmodel.org/schema/voag#",
  "meb": "http://rdf.myexperiment.org/ontologies/base/",
  "rdapo": "http://rdaregistry.info/Elements/p/object/",
  "rda": "http://www.rdaregistry.info/",
  "chord": "http://purl.org/ontology/chord/",
  "oauth": "http://demiblog.org/vocab/oauth#",
  "biopax": "http://www.biopax.org/release/biopax-level3.owl#",
  "coin": "http://purl.org/court/def/2009/coin#",
  "fea": "http://vocab.data.gov/def/fea#",
  "recipe": "http://linkedrecipes.org/schema/",
  "eclap": "http://www.eclap.eu/schema/eclap/",
  "rooms": "http://vocab.deri.ie/rooms#",
  "vitro": "http://vitro.mannlib.cornell.edu/ns/vitro/public#",
  "string": "http://www.w3.org/2000/10/swap/string#",
  "bsbm": "http://www4.wiwiss.fu-berlin.de/bizer/bsbm/v01/vocabulary/",
  "swanqs": "http://purl.org/swan/1.2/qualifiers/",
  "fo": "http://www.w3.org/1999/XSL/Format#",
  "lfn": "http://www.dotnetrdf.org/leviathan#",
  "ext": "http://mu.semte.ch/vocabularies/ext/",
  "oslc": "http://open-services.net/ns/core#",
  "lifecycle": "http://purl.org/vocab/lifecycle/schema#",
  "dailymed": "http://www4.wiwiss.fu-berlin.de/dailymed/resource/dailymed/",
  "csvw": "http://www.w3.org/ns/csvw#",
  "card": "http://www.ashutosh.com/test/",
  "dcr": "http://www.isocat.org/ns/dcr.rdf#",
  "mygrid": "http://www.mygrid.org.uk/ontology#",
  "countries": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
  "html": "http://www.w3.org/1999/xhtml/",
  "wgspos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "sv": "http://schemas.talis.com/2005/service/schema#",
  "isi": "http://purl.org/ontology/is/inst/",
  "posh": "http://poshrdf.org/ns/posh/",
  "osn": "http://spatial.ucd.ie/lod/osn/",
  "push": "http://www.w3.org/2007/uwa/context/push.owl#",
  "moat": "http://moat-project.org/ns#",
  "sail": "http://www.openrdf.org/config/sail#",
  "cogs": "http://vocab.deri.ie/cogs#",
  "pubmed": "http://bio2rdf.org/pubmed_vocabulary:",
  "scv": "http://purl.org/NET/scovo#",
  "fd": "http://foodable.co/ns/",
  "puc": "http://purl.org/NET/puc#",
  "dnr": "http://www.dotnetrdf.org/configuration#",
  "br": "http://vocab.deri.ie/br#",
  "grddl": "http://www.w3.org/2003/g/data-view#",
  "h5": "http://buzzword.org.uk/rdf/h5#",
  "wdr": "http://www.w3.org/2007/05/powder#",
  "b2bo": "http://purl.org/b2bo#",
  "spatial": "http://geovocab.org/spatial#",
  "exo": "https://w3id.org/example#",
  "fno": "https://w3id.org/function/ontology#",
  "opo": "http://online-presence.net/opo/ns#",
  "lastfm": "http://purl.org/ontology/last-fm/",
  "lotico": "http://www.lotico.com/resource/",
  "dady": "http://purl.org/NET/dady#",
  "fls": "http://lukasblaho.sk/football_league_schema#",
  "tarot": "http://data.totl.net/tarot/card/",
  "ops": "https://w3id.org/ops#",
  "lvont": "http://lexvo.org/ontology#",
  "rdaa": "http://rdaregistry.info/Elements/a/",
  "enc": "http://www.w3.org/2001/04/xmlenc#",
  "ldap": "http://purl.org/net/ldap/",
  "play": "http://uriplay.org/spec/ontology/#",
  "wbp": "http://worldbank.270a.info/property/",
  "toby": "http://tobyinkster.co.uk/#",
  "rdfa": "http://www.w3.org/ns/rdfa#",
  "care": "http://eulersharp.sourceforge.net/2003/03swap/care#",
  "hospital": "http://www.agfa.com/w3c/2009/hospital#",
  "ncbitaxon": "http://purl.obolibrary.org/obo/NCBITaxon_",
  "geospecies": "http://rdf.geospecies.org/ont/geospecies#",
  "evset": "http://dsnotify.org/vocab/eventset/0.1/",
  "parl": "https://id.parliament.uk/schema/",
  "swandr": "http://purl.org/swan/1.2/discourse-relationships/",
  "wai": "http://purl.org/wai#",
  "marl": "http://www.gsi.dit.upm.es/ontologies/marl/ns#",
  "bte": "http://purl.org/twc/vocab/between-the-edges/",
  "ec": "http://eulergui.sourceforge.net/contacts.owl.n3#",
  "wlp": "http://weblab-project.org/core/model/property/processing/",
  "irrl": "http://www.ontologydesignpatterns.org/cp/owl/informationobjectsandrepresentationlanguages.owl#",
  "foo": "http://filmontology.org/ontology/1.0/",
  "uni": "http://purl.org/weso/uni/uni.html#",
  "lingvoj": "http://www.lingvoj.org/ontology#",
  "data": "http://data.odw.tw/",
  "resex": "http://resex.rkbexplorer.com/ontologies/resex#",
  "lark1": "http://users.utcluj.ro/~raluca/ontology/Ontology1279614123500.owl#",
  "lex": "http://purl.org/lex#",
  "sede": "http://eventography.org/sede/0.1/",
  "gs1": "https://ref.gs1.org/voc/",
  "cmd": "https://w3id.org/cmd#",
  "hlisting": "http://sindice.com/hlisting/0.1/",
  "icaltzd": "http://www.w3.org/2002/12/cal/icaltzd#",
  "p3p": "http://www.w3.org/2002/01/p3prdfv1#",
  "nex": "http://www.nexml.org/2009/",
  "okkam": "http://models.okkam.org/ENS-core-vocabulary#",
  "hcterms": "http://purl.org/uF/hCard/terms/",
  "archdesc": "http://archdesc.info/archEvent#",
  "ist": "http://purl.org/ontology/is/types/",
  "sioca": "http://rdfs.org/sioc/actions#",
  "shv": "http://ns.aksw.org/spatialHierarchy/",
  "calli": "http://callimachusproject.org/rdf/2009/framework#",
  "tr": "http://www.thomsonreuters.com/",
  "ann": "http://www.w3.org/2000/10/annotation-ns#",
  "psh": "http://ns.inria.fr/probabilistic-shacl/",
  "remus": "http://www.semanticweb.org/ontologies/2010/6/Ontology1279614123500.owl#",
  "pobo": "http://purl.obolibrary.org/obo/",
  "wsc": "http://www.openk.org/wscaim.owl#",
  "xmls": "http://www.w3.org/2001/XMLSchema#",
  "oat": "http://openlinksw.com/schemas/oat/",
  "td": "https://www.w3.org/2019/wot/td#",
  "anca": "http://users.utcluj.ro/~raluca/rdf_ontologies_ralu/ralu_modified_ontology_pizzas2_0#",
  "identity": "http://purl.org/twc/ontologies/identity.owl#",
  "like": "http://ontologi.es/like#",
  "algo": "http://securitytoolbox.appspot.com/securityAlgorithms#",
  "wl": "http://www.wsmo.org/ns/wsmo-lite#",
  "places": "http://purl.org/ontology/places#",
  "cos": "http://www.inria.fr/acacia/corese#",
  "pol": "http://escience.rpi.edu/ontology/semanteco/2/0/pollution.owl#",
  "profiling": "http://ontologi.es/profiling#",
  "opwn": "http://www.ontologyportal.org/WordNet.owl#",
  "infosys": "http://www.infosys.com/",
  "httpvoc": "http://www.w3.org/2006/http#",
  "geom": "http://data.ign.fr/def/geometrie#",
  "osr": "http://dati.senato.it/osr/",
  "cb": "http://cbasewrap.ontologycentral.com/vocab#",
  "ecos": "http://purl.org/ecos#",
  "ecc": "https://ns.eccenca.com/",
  "swivt": "http://semantic-mediawiki.org/swivt/1.0#",
  "ogp": "http://ogp.me/ns#",
  "phss": "http://ns.poundhill.com/phss/1.0/",
  "wisski": "http://wiss-ki.eu/",
  "ddl": "http://purl.org/vocab/riro/ddl#",
  "sawsdl": "http://www.w3.org/ns/sawsdl#",
  "dbpedia2": "http://dbpedia.org/property/",
  "psych": "http://purl.org/vocab/psychometric-profile/",
  "tp": "https://triplydb.com/Triply/tp/def/",
  "drug": "http://www.agfa.com/w3c/2009/drugTherapy#",
  "esd": "http://def.esd.org.uk/",
  "gridworks": "http://purl.org/net/opmv/types/gridworks#",
  "scsv": "http://purl.org/NET/schema-org-csv#",
  "dnb": "http://d-nb.info/gnd/",
  "tio": "http://purl.org/tio/ns#",
  "units": "http://eulersharp.sourceforge.net/2003/03swap/units#",
  "esdir": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/direccion-postal#",
  "prissma": "http://ns.inria.fr/prissma/v1#",
  "san": "http://www.irit.fr/recherches/MELODI/ontologies/SAN#",
  "xt": "http://purl.org/twc/vocab/cross-topix#",
  "geographis": "http://telegraphis.net/ontology/geography/geography#",
  "prf": "http://www.openmobilealliance.org/tech/profiles/UAPROF/ccppschema-20021212#",
  "imreg": "http://www.w3.org/2004/02/image-regions#",
  "datafaqs": "http://purl.org/twc/vocab/datafaqs#",
  "dbt": "http://dbpedia.org/resource/Template:",
  "grel": "http://users.ugent.be/~bjdmeest/function/grel.ttl#",
  "dita": "http://purl.org/dita/ns#",
  "wfm": "http://purl.org/net/wf-motifs#",
  "quantity": "http://qudt.org/schema/quantity#",
  "copyright": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "ple": "http://pleiades.stoa.org/places/",
  "pccz": "http://purl.org/procurement/public-contracts-czech#",
  "fowl": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/food#",
  "fab": "http://purl.org/fab/ns#",
  "pam": "http://prismstandard.org/namespaces/pam/2.0/",
  "visit": "http://purl.org/net/vocab/2004/07/visit#",
  "nsa": "http://multimedialab.elis.ugent.be/organon/ontologies/ninsuna#",
  "ezcontext": "http://ontologies.ezweb.morfeo-project.org/ezcontext/ns#",
  "admssw": "http://purl.org/adms/sw/",
  "provenir": "http://knoesis.wright.edu/provenir/provenir.owl#",
  "session": "http://redfoot.net/2005/session#",
  "status": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "mesh": "http://id.nlm.nih.gov/mesh/",
  "elog": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "hgnc": "http://bio2rdf.org/hgnc:",
  "ecb": "http://ecb.270a.info/class/1.0/",
  "sl": "http://www.semanlink.net/2001/00/semanlink-schema#",
  "vf": "https://w3id.org/valueflows/ont/vf#",
  "common": "http://www.w3.org/2007/uwa/context/common.owl#",
  "agent": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
  "span": "http://www.ifomis.org/bfo/1.1/span#",
  "pmlp": "http://inference-web.org/2.0/pml-provenance.owl#",
  "osoc": "http://web-semantics.org/ns/opensocial#",
  "pml": "http://provenanceweb.org/ns/pml#",
  "rulz": "http://purl.org/NET/rulz#",
  "eprints": "http://eprints.org/ontology/",
  "sindice": "http://vocab.sindice.net/",
  "tags": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "smiley": "http://www.smileyontology.com/ns#",
  "timeline": "http://purl.org/NET/c4dm/timeline.owl#",
  "lr": "http://linkedrecipes.org/schema/",
  "cl": "http://advene.org/ns/cinelab/",
  "visko": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
  "wbc": "http://worldbank.270a.info/classification/",
  "odp": "http://ontologydesignpatterns.org/",
  "hxl": "http://hxl.humanitarianresponse.info/ns/#",
  "ling": "http://purl.org/voc/ling/",
  "nxp": "http://purl.org/nxp/schema/v1/",
  "xsl": "http://www.w3.org/1999/XSL/Transform#",
  "geofla": "http://data.ign.fr/ontologies/geofla#",
  "sysont": "http://ns.ontowiki.net/SysOnt/",
  "cao": "http://purl.org/makolab/caont/",
  "json": "https://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf#",
  "un": "http://www.w3.org/2007/ont/unit#",
  "soap": "http://www.w3.org/2003/05/soap-envelope/",
  "dis": "http://stanbol.apache.org/ontology/disambiguation/disambiguation#",
  "skip": "http://skipforward.net/skipforward/resource/",
  "ipad": "http://www.padinthecity.com/",
  "luc": "http://www.ontotext.com/owlim/lucene#",
  "pimo": "http://www.semanticdesktop.org/ontologies/2007/11/01/pimo#",
  "ecpo": "http://purl.org/ontology/ecpo#",
  "reve": "http://data.eurecom.fr/ontology/reve#",
  "doco": "http://purl.org/spar/doco/",
  "pns": "http://data.press.net/ontology/stuff/",
  "dsp": "http://purl.org/metainfo/terms/dsp#",
  "eztag": "http://ontologies.ezweb.morfeo-project.org/eztag/ns#",
  "sm": "http://topbraid.org/sparqlmotion#",
  "np": "http://www.nanopub.org/nschema#",
  "c4n": "http://vocab.deri.ie/c4n#",
  "geop": "http://aims.fao.org/aos/geopolitical.owl#",
  "prvtypes": "http://purl.org/net/provenance/types#",
  "human": "http://eulersharp.sourceforge.net/2003/03swap/human#",
  "carfo": "http://purl.org/carfo#",
  "orca": "http://geni-orca.renci.org/owl/topology.owl#",
  "zbwext": "http://zbw.eu/namespaces/zbw-extensions/",
  "wordmap": "http://purl.org/net/ns/wordmap#",
  "dossier": "https://data.omgeving.vlaanderen.be/ns/dossier#",
  "iswc": "http://annotation.semanticweb.org/2004/iswc#",
  "gazetteer": "http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/",
  "func": "http://www.w3.org/2007/rif-builtin-function#",
  "swanci": "http://purl.org/swan/1.2/citations/",
  "omv": "http://omv.ontoware.org/2005/05/ontology#",
  "sor": "http://purl.org/net/soron/",
  "nytimes": "http://data.nytimes.com/elements/",
  "myprefix": "http://myprefix.org/",
  "rdo": "http://purl.org/rdo/ns#",
  "gelo": "http://krauthammerlab.med.yale.edu/ontologies/gelo#",
  "sw": "http://linkedwidgets.org/statisticalwidget/ontology/",
  "gv": "http://rdf.data-vocabulary.org/#",
  "ibis": "http://purl.org/ibis#",
  "dqv": "http://www.w3.org/ns/dqv#",
  "sql": "http://ns.inria.fr/ast/sql#",
  "out": "http://ontologies.hypios.com/out#",
  "spif": "http://spinrdf.org/spif#",
  "olo": "http://purl.org/ontology/olo/core#",
  "ncal": "http://www.semanticdesktop.org/ontologies/2007/04/02/ncal#",
  "ls": "http://linkedspending.aksw.org/instance/",
  "atomowl": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "nsl": "http://purl.org/ontology/storyline/",
  "lt": "http://diplomski.nelakolundzija.org/LTontology.rdf#",
  "dpd": "http://www.kanzaki.com/ns/dpd#",
  "swanpav": "http://purl.org/swan/1.2/pav/",
  "eye": "http://jena.hpl.hp.com/Eyeball#",
  "set": "http://www.w3.org/2000/10/swap/set#",
  "osgb": "http://data.ordnancesurvey.co.uk/id/",
  "muni": "http://vocab.linkeddata.es/urbanismo-infraestructuras/territorio#",
  "mei": "http://www.music-encoding.org/ns/mei/",
  "ne": "http://umbel.org/umbel/ne/",
  "dgfoaf": "http://west.uni-koblenz.de/ontologies/2010/07/dgfoaf.owl#",
  "gc": "http://www.oegov.org/core/owl/gc#",
  "cidoccrm": "http://purl.org/NET/cidoc-crm/core#",
  "aigp": "http://swat.cse.lehigh.edu/resources/onto/aigp.owl#",
  "decl": "http://www.linkedmodel.org/1.0/schema/decl#",
  "wikibase": "http://wikiba.se/ontology#",
  "fcm": "http://eulersharp.sourceforge.net/2006/02swap/fcm#",
  "pne": "http://data.press.net/ontology/event/",
  "enhancer": "http://stanbol.apache.org/ontology/enhancer/enhancer#",
  "aapi": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
  "rkd": "http://data.rkd.nl/def#",
  "trackback": "http://madskills.com/public/xml/rss/module/trackback/",
  "dtype": "http://www.linkedmodel.org/schema/dtype#",
  "prefix": "http://prefix.cc/",
  "arpfo": "http://vocab.ouls.ox.ac.uk/projectfunding#",
  "prolog": "http://eulersharp.sourceforge.net/2003/03swap/prolog#",
  "opus": "http://lsdis.cs.uga.edu/projects/semdis/opus#",
  "rlno": "http://rdflivenews.aksw.org/ontology/",
  "rdagr1": "http://rdvocab.info/Elements/",
  "govtrackus": "http://www.rdfabout.com/rdf/usgov/geo/us/",
  "semtweet": "http://semantictweet.com/",
  "fl": "http://eulersharp.sourceforge.net/2003/03swap/fl-rules#",
  "plo": "http://purl.org/net/po#",
  "life": "http://life.deri.ie/schema/",
  "agrelon": "http://d-nb.info/standards/elementset/agrelon#",
  "evopat": "http://ns.aksw.org/Evolution/",
  "ifc": "http://ifcowl.openbimstandards.org/IFC2X3_Final#",
  "sdgp": "http://stats.data-gov.ie/property/",
  "commons": "http://commons.psi.enakting.org/def/",
  "xhtmlvocab": "http://www.w3.org/1999/xhtml/vocab/",
  "pmlt": "http://inference-web.org/2.0/pml-trust.owl#",
  "oboro": "http://obofoundry.org/ro/ro.owl#",
  "comm": "http://vocab.resc.info/communication#",
  "steel": "https://w3id.org/steel/ProcessOntology/",
  "bioskos": "http://eulersharp.sourceforge.net/2003/03swap/bioSKOSSchemes#",
  "rdam": "http://rdaregistry.info/Elements/m/",
  "agents": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
  "organiz": "http://eulersharp.sourceforge.net/2003/03swap/organization#",
  "dummy": "http://hello.com/",
  "wairole": "http://www.w3.org/2005/01/wai-rdf/GUIRoleTaxonomy#",
  "rad": "http://www.w3.org/ns/rad#",
  "abs": "http://abs.270a.info/dataset/",
  "r2r": "http://www4.wiwiss.fu-berlin.de/bizer/r2r/",
  "opl": "http://openlinksw.com/schema/attribution#",
  "xbrli": "http://www.xbrl.org/2003/instance#",
  "nid3": "http://www.semanticdesktop.org/ontologies/2007/05/10/nid3#",
  "wf": "http://www.w3.org/2005/01/wf/flow#",
  "sad": "http://vocab.deri.ie/sad#",
  "req": "http://purl.org/req/",
  "linkedct": "http://data.linkedct.org/vocab/",
  "rso": "http://www.researchspace.org/ontology/",
  "w3p": "http://prov4j.org/w3p/",
  "vcardx": "http://buzzword.org.uk/rdf/vcardx#",
  "owltime": "http://www.w3.org/TR/owl-time#",
  "va": "http://code-research.eu/ontology/visual-analytics#",
  "ianarel": "https://www.w3.org/ns/iana/link-relations/relation#",
  "wao": "http://webtlab.it.uc3m.es/2010/10/WebAppsOntology#",
  "hemogram": "http://www.agfa.com/w3c/2009/hemogram#",
  "plink": "http://buzzword.org.uk/rdf/personal-link-types#",
  "qa": "http://www.mit.jyu.fi/ai/TRUST_Ontologies/QA.owl#",
  "tripfs": "http://purl.org/tripfs/2010/02#",
  "derecho": "http://purl.org/derecho#",
  "httpm": "http://www.w3.org/2011/http-methods#",
  "pf": "http://jena.hpl.hp.com/ARQ/property#",
  "oax": "http://www.w3.org/ns/openannotation/extensions/",
  "webtlab": "http://webtlab.it.uc3m.es/",
  "rml": "http://w3id.org/rml/",
  "moby": "http://www.mygrid.org.uk/mygrid-moby-service#",
  "transit": "http://vocab.org/transit/terms/",
  "ens": "http://models.okkam.org/ENS-core-vocabulary.owl#",
  "aneo": "http://akonadi-project.org/ontologies/aneo#",
  "open": "http://open.vocab.org/terms/",
  "nyt": "http://data.nytimes.com/",
  "dl": "http://ontology.ip.rm.cnr.it/ontologies/DOLCE-Lite#",
  "xesam": "http://freedesktop.org/standards/xesam/1.0/core#",
  "tvc": "http://www.essepuntato.it/2012/04/tvc/",
  "lindt": "http://purl.org/NET/lindt#",
  "dgtwc": "http://data-gov.tw.rpi.edu/2009/data-gov-twc.rdf#",
  "aersv": "http://aers.data2semantics.org/vocab/",
  "gxa": "http://www.ebi.ac.uk/gxa/",
  "qdoslf": "http://foaf.qdos.com/lastfm/schema/",
  "fc": "http://www.freeclass.eu/freeclass_v1#",
  "htir": "http://www.w3.org/2011/http#",
  "no": "http://km.aifb.kit.edu/projects/numbers/number#",
  "rdaw": "http://rdaregistry.info/Elements/w/",
  "pna": "http://data.press.net/ontology/asset/",
  "wapp": "http://ns.rww.io/wapp#",
  "oecd": "http://oecd.270a.info/dataset/",
  "agetec": "http://www.agetec.org/",
  "frbrcore": "http://purl.org/vocab/frbr/core#",
  "italy": "http://data.kasabi.com/dataset/italy/schema/",
  "theatre": "http://purl.org/theatre#",
  "rpubl": "http://rinfo.lagrummet.se/ns/2008/11/rinfo/publ#",
  "estrn": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/transporte#",
  "eseduc": "http://www.purl.org/ontologia/eseduc#",
  "intervals": "http://reference.data.gov.uk/def/intervals/",
  "geodata": "http://sws.geonames.org/",
  "kw": "http://kwantu.net/kw/",
  "sro": "http://salt.semanticauthoring.org/ontologies/sro#",
  "oj": "http://ontojob.at/",
  "ospost": "http://data.ordnancesurvey.co.uk/ontology/postcode/",
  "mmo": "http://purl.org/momayo/mmo/",
  "owls": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
  "frbre": "http://purl.org/vocab/frbr/extended#",
  "solid": "http://www.w3.org/ns/solid/terms#",
  "protons": "http://proton.semanticweb.org/2005/04/protons#",
  "dbpo": "http://dbpedia.org/ontology/",
  "swpo": "http://sw-portal.deri.org/ontologies/swportal#",
  "tcga": "http://purl.org/tcga/core#",
  "scowt": "http://purl.org/weso/ontologies/scowt#",
  "metalex": "http://www.metalex.eu/schema/1.0#",
  "xfnv": "http://vocab.sindice.com/xfn#",
  "aims": "http://aims.fao.org/aos/common/",
  "shex": "http://www.w3.org/ns/shex#",
  "wfdesc": "http://purl.org/wf4ever/wfdesc#",
  "crtv": "http://open-services.net/ns/crtv#",
  "quak": "http://dev.w3.org/cvsweb/2000/quacken/vocab#",
  "emotion": "http://ns.inria.fr/emoca#",
  "swo": "http://www.ebi.ac.uk/swo/",
  "health": "http://purl.org/twc/health/vocab/",
  "bdd": "https://api.bloomberg.com/eap/catalogs/bbg/fields/",
  "ncit": "http://purl.obolibrary.org/obo/NCIT_",
  "flow": "http://www.w3.org/2005/01/wf/flow#",
  "rich": "http://rdf.data-vocabulary.org/",
  "atlas": "http://rdf.ebi.ac.uk/resource/atlas/",
  "dctypes": "http://purl.org/dc/dcmitype/",
  "npgd": "http://ns.nature.com/datasets/",
  "oper": "http://sweet.jpl.nasa.gov/2.0/mathOperation.owl#",
  "ldr": "http://purl.oclc.org/NET/ldr/ns#",
  "crmdig": "http://www.ics.forth.gr/isl/CRMdig/",
  "tripfs2": "http://purl.org/tripfs/2010/06#",
  "opmv": "http://purl.org/net/opmv/ns#",
  "iron": "http://purl.org/ontology/iron#",
  "languages": "http://eulersharp.sourceforge.net/2003/03swap/languages#",
  "ogorg": "http://opengraph.org/schema/",
  "qu": "http://purl.oclc.org/NET/ssnx/qu/qu#",
  "transmed": "http://www.w3.org/2001/sw/hcls/ns/transmed/",
  "lgv": "http://linkedgeodata.org/ontology/",
  "fct": "http://openlinksw.com/services/facets/1.0/",
  "wm": "http://ns.inria.fr/webmarks#",
  "ru": "http://purl.org/imbi/ru-meta.owl#",
  "swanag": "http://purl.org/swan/1.2/agents/",
  "opmw": "http://www.opmw.org/ontology/",
  "gbv": "http://purl.org/ontology/gbv/",
  "daq": "http://purl.org/eis/vocab/daq#",
  "c4o": "http://purl.org/spar/c4o/",
  "oboso": "http://purl.org/obo/owl/SO#",
  "cf": "http://mmisw.org/ont/cf/parameter/",
  "jita": "http://aims.fao.org/aos/jita/",
  "rating": "http://www.tvblob.com/ratings/#",
  "hartigprov": "http://purl.org/net/provenance/ns#",
  "igeo": "http://rdf.insee.fr/def/geo#",
  "humanbody": "http://eulersharp.sourceforge.net/2003/03swap/humanBody#",
  "xch": "http://oanda2rdf.appspot.com/xch/",
  "govwild": "http://govwild.org/0.6/GWOntology.rdf/",
  "dssn": "http://purl.org/net/dssn/",
  "re": "http://www.w3.org/2000/10/swap/reason#",
  "date": "http://contextus.net/ontology/ontomedia/misc/date#",
  "skiresort": "http://www.openlinksw.com/ski_resorts/schema#",
  "fingal": "http://vocab.deri.ie/fingal#",
  "telix": "http://purl.org/telix#",
  "gfo": "http://www.onto-med.de/ontologies/gfo.owl#",
  "openskos": "http://openskos.org/xmlns#",
  "environ": "http://eulersharp.sourceforge.net/2003/03swap/environment#",
  "bm": "http://bio2rdf.org/",
  "bco": "http://purl.obolibrary.org/obo/bco.owl#",
  "wro": "http://purl.org/net/wf4ever/ro#",
  "coeus": "http://bioinformatics.ua.pt/coeus/",
  "clineva": "http://www.agfa.com/w3c/2009/clinicalEvaluation#",
  "ev": "http://www.w3.org/2001/xml-events/",
  "kdo": "http://kdo.render-project.eu/kdo#",
  "adr": "http://kg.artsdata.ca/resource/",
  "ufmedia": "http://purl.org/microformat/hmedia/",
  "goef": "http://purl.org/twc/vocab/goef#",
  "osmsemnet": "http://spatial.ucd.ie/2012/08/osmsemnet/",
  "events": "http://eulersharp.sourceforge.net/2003/03swap/event#",
  "ccard": "http://purl.org/commerce/creditcard#",
  "occult": "http://galoes.org/ontologies/occult.owl#",
  "ipo": "http://purl.org/ipo/core#",
  "sgv": "http://www.w3.org/TR/SVG/",
  "clinic": "http://example.com/clinic#",
  "emp": "http://purl.org/ctic/empleo/oferta#",
  "rankrage": "https://rankrage.de/",
  "cdtype": "http://purl.org/cld/cdtype/",
  "artstor": "http://simile.mit.edu/2003/10/ontologies/artstor#",
  "decision": "https://decision-ontology.googlecode.com/svn/trunk/decision.owl#",
  "kontakt": "http://richard.cyganiak.de/",
  "mohammad": "http://manesht.ir/",
  "aair": "http://xmlns.notu.be/aair#",
  "cold": "http://purl.org/configurationontology#",
  "property": "http://fr.dbpedia.org/property/",
  "nndsr": "http://semanticdiet.com/schema/usda/nndsr/",
  "ost": "http://w3id.org/ost/ns#",
  "loticoowl": "http://www.lotico.com/ontology/",
  "wno": "http://wordnet-rdf.princeton.edu/ontology#",
  "tao": "http://pubannotation.org/ontology/tao.owl#",
  "coun": "http://www.daml.org/2001/09/countries/iso-3166-ont#",
  "marshall": "http://sites.google.com/site/xgmaitc/",
  "d2r": "http://sites.wiwiss.fu-berlin.de/suhl/bizer/d2r-server/config.rdf#",
  "ccom": "http://purl.org/ontology/cco/mappings#",
  "s2s": "http://escience.rpi.edu/ontology/sesf/s2s/4/0/",
  "pso": "http://purl.org/spar/pso/",
  "lso": "http://linkedspending.aksw.org/ontology/",
  "pco": "http://purl.org/procurement/public-contracts#",
  "bk": "http://www.provbook.org/ns/#",
  "wscaim": "http://www.openk.org/wscaim.owl#",
  "dayta": "http://dayta.me/resource#",
  "sig": "http://purl.org/signature#",
  "mod": "http://www.isibang.ac.in/ns/mod#",
  "hcard": "http://purl.org/uF/hCard/terms/",
  "dannet": "http://www.wordnet.dk/owl/instance/2009/03/instances/",
  "frapo": "http://purl.org/cerif/frapo/",
  "npgg": "http://ns.nature.com/graphs/",
  "daiaserv": "http://purl.org/ontology/daia/Service/",
  "tmpl": "http://purl.org/restdesc/http-template#",
  "bookmark": "http://www.w3.org/2002/01/bookmark#",
  "grs": "http://www.georss.org/georss/",
  "prism21": "http://prismstandard.org/namespaces/basic/2.1/",
  "bcncon": "http://datos.bcn.cl/ontologies/bcn-congress#",
  "paia": "http://purl.org/ontology/paia#",
  "dive": "http://scubadive.networld.to/dive.rdf#",
  "frad": "http://iflastandards.info/ns/fr/frad/",
  "fma": "http://sig.uw.edu/fma#",
  "kbp": "http://tackbp.org/2013/ontology#",
  "osukdt": "http://www.ordnancesurvey.co.uk/ontology/Datatypes.owl#",
  "shacl": "http://www.w3.org/ns/shacl#",
  "kupkb": "http://www.e-lico.eu/data/kupkb/",
  "odo": "http://ocean-data.org/schema/",
  "tei": "http://www.tei-c.org/ns/1.0/",
  "arecipe": "http://purl.org/amicroformat/arecipe/",
  "skos08": "http://www.w3.org/2008/05/skos#",
  "protegedc": "http://protege.stanford.edu/plugins/owl/dc/protege-dc.owl#",
  "lod2": "http://lod2.eu/schema/",
  "harrisons": "http://harrisons.cc/",
  "penis": "http://penis.to/#",
  "wsl": "http://www.wsmo.org/ns/wsmo-lite#",
  "stac": "http://securitytoolbox.appspot.com/stac#",
  "curr": "https://w3id.org/cc#",
  "pizza": "http://www.co-ode.org/ontologies/pizza/pizza.owl#",
  "p20": "http://zbw.eu/beta/p20/vocab/",
  "l4a": "http://labels4all.info/ns/",
  "genab": "http://eulersharp.sourceforge.net/2003/03swap/genomeAbnormality#",
  "csm": "http://purl.org/csm/1.0#",
  "doas": "http://deductions.github.io/doas.owl.ttl#",
  "verb": "https://w3id.org/verb/",
  "hasco": "http://hadatac.org/ont/hasco/",
  "mads": "http://www.loc.gov/mads/rdf/v1#",
  "art": "http://w3id.org/art/terms/1.0/",
  "oslo": "http://purl.org/oslo/ns/localgov#",
  "tac": "http://ns.bergnet.org/tac/0.1/triple-access-control#",
  "atomrdf": "http://atomowl.org/ontologies/atomrdf#",
  "mte": "http://nl.ijs.si/ME/owl/",
  "scor": "http://purl.org/eis/vocab/scor#",
  "diseasome": "http://www4.wiwiss.fu-berlin.de/diseasome/resource/diseasome/",
  "vgo": "http://purl.org/net/VideoGameOntology#",
  "lio": "http://purl.org/net/lio#",
  "str": "http://nlp2rdf.lod2.eu/schema/string/",
  "ends": "http://labs.mondeca.com/vocab/endpointStatus#",
  "sci": "http://data.scientology.org/ns/",
  "sbench": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
  "opllic": "http://www.openlinksw.com/ontology/licenses#",
  "wfprov": "http://purl.org/wf4ever/wfprov#",
  "dpc": "http://hospee.org/ontologies/dpc/",
  "rdacarrier": "http://rdvocab.info/termList/RDACarrierType/",
  "pod": "https://project-open-data.cio.gov/v1.1/schema/#",
  "of": "http://owlrep.eu01.aws.af.cm/fridge#",
  "ds": "http://purl.org/ctic/dcat#",
  "gesis": "http://lod.gesis.org/lodpilot/ALLBUS/vocab.rdf#",
  "smg": "http://ns.cerise-project.nl/energy/def/cim-smartgrid#",
  "sam": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling#",
  "b2rpubchem": "http://bio2rdf.org/ns/ns/ns/pubchem#",
  "cpsv": "http://purl.org/vocab/cpsv#",
  "lc": "http://semweb.mmlab.be/ns/linkedconnections#",
  "scms": "http://ns.aksw.org/scms/annotations/",
  "genea": "http://www.owl-ontologies.com/generations.owl#",
  "poder": "http://poderopedia.com/vocab/",
  "omnlife": "http://open-multinet.info/ontology/omn-lifecycle#",
  "camelot": "http://vocab.ox.ac.uk/camelot#",
  "opencyc": "http://sw.opencyc.org/concept/",
  "biordf": "http://purl.org/net/biordfmicroarray/ns#",
  "dpl": "http://dbpedialite.org/things/",
  "thors": "http://resource.geosciml.org/ontology/timescale/thors#",
  "jpo": "http://rdf.jpostdb.org/ontology/jpost.owl#",
  "nocal": "http://vocab.deri.ie/nocal#",
  "faq": "http://www.openlinksw.com/ontology/faq#",
  "shoah": "http://dati.cdec.it/lod/shoah/",
  "bv": "http://purl.org/vocommons/bv#",
  "cart": "http://purl.org/net/cartCoord#",
  "latitude": "https://www.w3.org/2006/vcard/ns#",
  "ptop": "http://www.ontotext.com/proton/protontop#",
  "insdc": "http://ddbj.nig.ac.jp/ontologies/sequence#",
  "guo": "http://purl.org/hpi/guo#",
  "mmd": "http://musicbrainz.org/ns/mmd-1.0#",
  "dn": "http://purl.org/datanode/ns/",
  "itsmo": "http://ontology.it/itsmo/v1#",
  "prvt": "http://purl.org/net/provenance/types#",
  "prvr": "http://purl.org/ontology/prv/rules#",
  "osp": "http://data.lirmm.fr/ontologies/osp#",
  "mpeg7": "http://rhizomik.net/ontologies/2005/03/Mpeg7-2001.owl#",
  "campsite": "http://www.openlinksw.com/campsites/schema#",
  "shw": "http://paul.staroch.name/thesis/SmartHomeWeather.owl#",
  "clinproc": "http://www.agfa.com/w3c/2009/clinicalProcedure#",
  "healthcare": "http://www.agfa.com/w3c/2009/healthCare#",
  "chembl": "http://rdf.ebi.ac.uk/terms/chembl#",
  "sso": "http://nlp2rdf.lod2.eu/schema/sso/",
  "dash": "http://datashapes.org/dash#",
  "ssso": "http://purl.org/ontology/ssso#",
  "tisc": "http://observedchange.com/tisc/ns#",
  "stream": "http://dbpedia.org/ontology/Stream/",
  "security": "http://securitytoolbox.appspot.com/securityMain#",
  "iol": "http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl#",
  "centrifuge": "http://purl.org/twc/vocab/centrifuge#",
  "sao": "http://salt.semanticauthoring.org/ontologies/sao#",
  "refe": "http://orion.tw.rpi.edu/~xgmatwc/refe/",
  "te": "http://www.w3.org/2006/time-entry#",
  "sioctypes": "http://rdfs.org/sioc/types#",
  "gov": "http://gov.genealogy.net/ontology.owl#",
  "hifm": "http://purl.org/net/hifm/data#",
  "dbyago": "http://dbpedia.org/class/yago/",
  "ottr": "http://ns.ottr.xyz/templates#",
  "category": "http://dbpedia.org/resource/Category:",
  "lh": "http://vocab.inf.ed.ac.uk/library/holdings#",
  "dpv": "http://www.w3.org/ns/dpv#",
  "aerols": "http://xmlns.com/aerols/0.1/",
  "oml": "http://def.seegrid.csiro.au/ontology/om/om-lite#",
  "vsto": "http://escience.rpi.edu/ontology/vsto/2/0/vsto.owl#",
  "ecrm": "http://erlangen-crm.org/current/",
  "alchemy": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
  "ql": "http://www.w3.org/2004/ql#",
  "ebu": "http://semantic.eurobau.com/eurobau-utility.owl#",
  "rdamt": "http://rdaregistry.info/termList/RDAMediaType/",
  "trait": "http://contextus.net/ontology/ontomedia/ext/common/trait#",
  "cosmo": "http://purl.org/ontology/cosmo#",
  "xrd": "http://docs.oasis-open.org/ns/xri/xrd-1.0#",
  "xlime": "http://xlime-project.org/vocab/",
  "tw": "http://tw.rpi.edu/schema/",
  "pronom": "http://reference.data.gov.uk/technical-registry/",
  "qrl": "http://www.aifb.kit.edu/project/ld-retriever/qrl#",
  "twaapi": "http://purl.org/twc/vocab/aapi-schema#",
  "yo": "http://yovisto.com/",
  "onssprel": "http://www.ordnancesurvey.co.uk/ontology/SpatialRelations/v0.2/SpatialRelations.owl#",
  "bgdbp": "http://bg.dbpedia.org/property/",
  "ngeoi": "http://vocab.lenka.no/geo-deling#",
  "odcs": "http://opendata.cz/infrastructure/odcleanstore/",
  "rdafr": "http://rdaregistry.info/termList/frequency/",
  "cpant": "http://purl.org/NET/cpan-uri/terms#",
  "zoomaterms": "http://rdf.ebi.ac.uk/vocabulary/zooma/",
  "fao": "http://fao.270a.info/dataset/",
  "oarj": "http://opendepot.org/reference/linked/1.0/",
  "w3con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "rec54": "http://www.w3.org/2001/02pd/rec54.rdf#",
  "li": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage#",
  "obsm": "http://rdf.geospecies.org/methods/observationMethod#",
  "okg": "http://openknowledgegraph.org/ontology/",
  "mtecore": "http://purl.org/olia/mte/multext-east.owl#",
  "lctr": "http://data.linkedct.org/vocab/resource/",
  "saxon": "http://saxon.sf.net/",
  "tm": "http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal#",
  "germplasm": "http://purl.org/germplasm/terms#",
  "vin": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine#",
  "pv": "https://piveau.eu/ns/voc#",
  "idemo": "http://rdf.insee.fr/def/demo#",
  "lsc": "http://linkedscience.org/lsc/ns#",
  "vartrans": "http://www.w3.org/ns/lemon/vartrans#",
  "cts2": "http://schema.omg.org/spec/CTS2/1.0/",
  "rmo": "http://eatld.et.tu-dresden.de/rmo#",
  "malignneo": "http://www.agfa.com/w3c/2009/malignantNeoplasm#",
  "raul": "http://vocab.deri.ie/raul#",
  "msr": "http://www.telegraphis.net/ontology/measurement/measurement#",
  "wlo": "http://purl.org/ontology/wo/",
  "odrs": "http://schema.theodi.org/odrs#",
  "lsmap": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
  "brick": "https://brickschema.org/schema/Brick#",
  "osgeom": "http://data.ordnancesurvey.co.uk/ontology/geometry/",
  "oplcert": "http://www.openlinksw.com/schemas/cert#",
  "who": "http://www.who.int/vocab/ontology#",
  "scoro": "http://purl.org/spar/scoro/",
  "bihap": "http://bihap.kb.gov.tr/ontology/",
  "bcnnorms": "http://datos.bcn.cl/ontologies/bcn-norms#",
  "cis": "http://purl.org/NET/cloudisus#",
  "antenne": "https://data.zendantennes.omgeving.vlaanderen.be/ns/zendantenne#",
  "strdf": "http://strdf.di.uoa.gr/ontology#",
  "gf": "http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature#",
  "oae": "http://www.ics.forth.gr/isl/oae/core#",
  "pnt": "http://data.press.net/ontology/tag/",
  "crv": "http://purl.org/twc/vocab/datacarver#",
  "part": "http://purl.org/vocab/participation/schema#",
  "emtr": "http://purl.org/NET/ssnext/electricmeters#",
  "ccrel": "http://creativecommons.org/ns#",
  "mico": "http://www.mico-project.eu/ns/platform/1.0/schema#",
  "goog": "http://schema.googleapis.com/",
  "rdafnm": "http://rdaregistry.info/termList/FormNoteMus/",
  "ekaw": "http://data.semanticweb.org/conference/ekaw/2012/complete/",
  "pkmn": "http://pokedex.dataincubator.org/pkm/",
  "crml": "http://semweb.mmlab.be/ns/rml/condition#",
  "hints2005": "http://purl.org/twc/cabig/model/HINTS2005-1.owl#",
  "conf": "http://richard.cyganiak.de/2007/pubby/config.rdf#",
  "qud": "http://qudt.org/1.1/schema/qudt#",
  "rdasoi": "http://rdaregistry.info/termList/statIdentification/",
  "op": "http://environment.data.gov.au/def/op#",
  "dr": "http://purl.org/swan/2.0/discourse-relationships/",
  "rdarel2": "http://metadataregistry.org/uri/schema/RDARelationshipsGR2/",
  "stories": "http://purl.org/ontology/stories/",
  "mmf": "http://linkedmultimedia.org/sparql-mm/ns/1.0.0/function#",
  "esco": "http://data.europa.eu/esco/model#",
  "d2d": "http://rdfns.org/d2d/",
  "dcs": "http://ontologi.es/doap-changeset#",
  "geovocab": "http://geovocab.org/",
  "bn": "http://babelnet.org/rdf/",
  "ep": "http://eprints.org/ontology/",
  "oan": "http://data.lirmm.fr/ontologies/oan/",
  "dbcat": "http://dbpedia.org/resource/Category:",
  "seokoeln": "http://rankrage.de/",
  "activity": "https://www.w3.org/TR/activitystreams-vocabulary/",
  "kbv": "https://id.kb.se/vocab/",
  "bgt": "https://bgt.basisregistraties.overheid.nl/bgt/def/",
  "sdmxd": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "rdae": "http://rdaregistry.info/Elements/e/",
  "lcy": "http://purl.org/vocab/lifecycle/schema#",
  "l4lod": "http://ns.inria.fr/l4lod/v2/",
  "ccp": "http://cookingbigdata.com/linkeddata/ccpricing#",
  "vsso": "http://automotive.eurecom.fr/vsso#",
  "semio": "http://www.lingvoj.org/semio#",
  "c4dm": "http://purl.org/NET/c4dm/event.owl#",
  "namespaces": "https://vg.no/",
  "lsqv": "http://lsq.aksw.org/vocab#",
  "cwrc": "http://sparql.cwrc.ca/ontology/cwrc#",
  "wb": "http://data.worldbank.org/",
  "ll": "http://lodlaundromat.org/resource/",
  "sg": "http://name.scigraph.com/ontologies/core/",
  "cbo": "http://comicmeta.org/cbo/",
  "rssynd": "http://web.resource.org/rss/1.0/modules/syndication/",
  "wikterms": "http://wiktionary.dbpedia.org/terms/",
  "xapi": "https://w3id.org/xapi/ontology#",
  "bgn": "http://bibliograph.net/schemas/",
  "seq": "http://www.ontologydesignpatterns.org/cp/owl/sequence.owl#",
  "mb": "http://dbtune.org/musicbrainz/resource/instrument/",
  "s4ac": "http://ns.inria.fr/s4ac/v2#",
  "allot": "https://w3id.org/akn/ontology/allot#",
  "kees": "http://linkeddata.center/kees/v1#",
  "gl": "http://schema.geolink.org/",
  "holding": "http://purl.org/ontology/holding#",
  "mv": "http://schema.mobivoc.org/",
  "dawgt": "http://www.w3.org/2001/sw/DataAccess/tests/test-dawg#",
  "pnc": "http://data.press.net/ontology/classification/",
  "auto": "http://auto.schema.org/",
  "webbox": "http://webbox.ecs.soton.ac.uk/ns#",
  "ljkl": "http://teste.com/",
  "puelia": "http://kwijibo.talis.com/vocabs/puelia#",
  "gastro": "http://www.ebsemantics.net/gastro#",
  "prof": "http://www.w3.org/ns/dx/prof/",
  "rdacontent": "http://rdvocab.info/termList/RDAContentType/",
  "im": "http://imgpedia.dcc.uchile.cl/resource/",
  "rdacct": "http://rdaregistry.info/termList/CollTitle/",
  "rdatc": "http://rdaregistry.info/termList/trackConfig/",
  "tg": "https://triplydb.com/Triply/tg/def/",
  "saws": "http://purl.org/saws/ontology#",
  "lsweb": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
  "nidm": "http://nidm.nidash.org/",
  "vsws": "http://verticalsearchworks.com/ontology/synset#",
  "my": "http://www.mobile.com/model/",
  "pni": "http://data.press.net/ontology/identifier/",
  "scip": "http://lod.taxonconcept.org/ontology/sci_people.owl#",
  "pattern": "http://www.essepuntato.it/2008/12/pattern#",
  "deps": "http://ontologi.es/doap-deps#",
  "ox": "http://vocab.ox.ac.uk/projectfunding#",
  "mged": "http://mged.sourceforge.net/ontologies/MGEDOntology.owl#",
  "disease": "http://www.agfa.com/w3c/2009/humanDisorder#",
  "quantities": "http://eulersharp.sourceforge.net/2003/03swap/quantitiesExtension#",
  "ogc": "http://www.opengis.net/def/",
  "lodac": "http://lod.ac/ns/lodac#",
  "finlaw": "http://purl.org/finlex/schema/laki/",
  "omapi": "http://purl.org/omapi/0.2/#",
  "rvdata": "http://data.rvdata.us/",
  "affymetrix": "http://bio2rdf.org/affymetrix_vocabulary:",
  "pingback": "http://purl.org/net/pingback/",
  "gm": "http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry#",
  "dcndl": "http://ndl.go.jp/dcndl/terms/",
  "dqm": "http://purl.org/dqm-vocabulary/v1/dqm#",
  "dbrc": "http://dbpedia.org/resource/Category:",
  "xcql": "http://docs.oasis-open.org/ns/search-ws/xcql#",
  "spt": "http://spitfire-project.eu/ontology/ns/",
  "eui": "http://institutions.publicdata.eu/#",
  "mt": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "foam": "https://www.koerperfettwaage-test.de/",
  "bgcat": "http://bg.dbpedia.org/resource/?????????:",
  "delta": "http://www.w3.org/2004/delta#",
  "rdamedia": "http://rdvocab.info/termList/RDAMediaType/",
  "rdagd": "http://rdaregistry.info/termList/gender/",
  "tblcard": "http://www.w3.org/People/Berners-Lee/card#",
  "c9d": "http://purl.org/twc/vocab/conversion/",
  "mrel": "http://id.loc.gov/vocabulary/relators/",
  "tsioc": "http://rdfs.org/sioc/types#",
  "fog": "https://w3id.org/fog#",
  "cbase": "http://ontologycentral.com/2010/05/cb/vocab#",
  "laposte": "http://data.lirmm.fr/ontologies/laposte#",
  "onyx": "http://www.gsi.dit.upm.es/ontologies/onyx/ns#",
  "oss": "http://opendata.caceres.es/def/ontosemanasanta#",
  "doi": "https://doi.org/",
  "fos": "http://futurios.org/fos/spec/",
  "wkd": "http://schema.wolterskluwer.de/",
  "bot": "https://w3id.org/bot#",
  "friends": "http://www.openarchives.org/OAI/2.0/friends/",
  "stats": "http://purl.org/rdfstats/stats#",
  "dbpr": "http://dbpedia.org/resource/",
  "origins": "http://origins.link/",
  "app": "http://jmvanel.free.fr/ontology/software_applications.n3#",
  "cvbase": "http://purl.org/captsolo/resume-rdf/0.2/base#",
  "snarm": "http://rdf.myexperiment.org/ontologies/snarm/",
  "quty": "http://www.telegraphis.net/ontology/measurement/quantity#",
  "biro": "http://purl.org/spar/biro/",
  "employee": "http://www.employee.com/data#",
  "telmap": "http://purl.org/telmap/",
  "moac": "http://observedchange.com/moac/ns#",
  "bcnbio": "http://datos.bcn.cl/ontologies/bcn-biographies#",
  "lmo": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/ontology#",
  "accom": "http://purl.org/acco/ns#",
  "isocat": "http://www.isocat.org/datcat/",
  "pair": "http://virtual-assembly.org/ontologies/pair#",
  "orth": "http://purl.org/net/orth#",
  "lldr": "http://purl.oclc.org/NET/lldr/ns#",
  "fam": "http://vocab.fusepool.info/fam#",
  "ostop": "http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl#",
  "evident": "http://purl.org/net/evident#",
  "ftcontent": "http://www.ft.com/ontology/content/",
  "osspr": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "fincaselaw": "http://purl.org/finlex/schema/oikeus/",
  "spfood": "http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl#",
  "od": "http://purl.org/twc/vocab/opendap#",
  "dvia": "http://data.eurecom.fr/ontology/dvia#",
  "mml": "http://www.w3.org/1998/Math/MathML/",
  "daisy": "http://www.daisy.org/z3998/2012/vocab/",
  "rdami": "http://rdaregistry.info/termList/modeIssue/",
  "mvco": "http://purl.oclc.org/NET/mvco.owl#",
  "mtlo": "http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl#",
  "drm": "http://vocab.data.gov/def/drm#",
  "agls": "http://www.agls.gov.au/agls/terms/",
  "driver": "http://deductions.github.io/drivers.owl.ttl#",
  "wn31": "http://wordnet-rdf.princeton.edu/wn31/",
  "gcis": "http://data.globalchange.gov/gcis.owl#",
  "merge": "http://jazz.net/ns/lqe/merge/",
  "add": "https://mre.zcu.cz/ontology/stroke.owl#",
  "dbptmpl": "http://dbpedia.org/resource/Template:",
  "rdagw": "http://rdaregistry.info/termList/grooveWidth/",
  "lsd": "http://linkedwidgets.org/statisticaldata/ontology/",
  "pkm": "http://www.ontotext.com/proton/protonkm#",
  "turismo": "http://idi.fundacionctic.org/cruzar/turismo#",
  "mil": "http://rdf.muninn-project.org/ontologies/military#",
  "dao": "http://purl.org/dao#",
  "esaloj": "http://vocab.linkeddata.es/datosabiertos/def/turismo/alojamiento#",
  "call": "http://webofcode.org/wfn/call:",
  "salad": "https://w3id.org/cwl/salad#",
  "nerd": "http://nerd.eurecom.fr/ontology#",
  "viso": "http://purl.org/viso/",
  "eumida": "http://data.kasabi.com/dataset/eumida/terms/",
  "particip": "http://purl.org/vocab/participation/schema#",
  "onc": "http://www.ics.forth.gr/isl/oncm/core#",
  "swperson": "http://data.semanticweb.org/person/",
  "agr": "http://promsns.org/def/agr#",
  "pmd": "https://w3id.org/pmd/co/",
  "company": "http://intellimind.io/ns/company#",
  "gpml": "http://vocabularies.wikipathways.org/gpml#",
  "aers": "http://aers.data2semantics.org/resource/",
  "graffle": "http://purl.org/twc/vocab/vsr/graffle#",
  "sct": "http://snomed.info/id/",
  "gawd": "http://gawd.atlantides.org/terms/",
  "ws": "http://www.w3.org/ns/pim/space#",
  "odpart": "http://www.ontologydesignpatterns.org/cp/owl/participation.owl#",
  "pvcs": "http://purl.org/twc/vocab/pvcs#",
  "rdabm": "http://rdaregistry.info/termList/RDABaseMaterial/",
  "hto": "http://project-haystack.org/hto#",
  "radion": "http://www.w3.org/ns/radion#",
  "oh": "http://semweb.mmlab.be/ns/oh#",
  "dogont": "http://elite.polito.it/ontologies/dogont.owl#",
  "llo": "http://lodlaundromat.org/ontology/",
  "s4envi": "https://w3id.org/def/saref4envi#",
  "fcs": "http://clarin.eu/fcs/resource#",
  "webservice": "http://www.openlinksw.com/ontology/webservices#",
  "language": "http://id.loc.gov/vocabulary/iso639-1/",
  "ou": "https://opendata.unex.es/def/ontouniversidad#",
  "cdao": "http://purl.obolibrary.org/obo/",
  "lden": "http://www.linklion.org/lden/",
  "viskov": "http://trust.utep.edu/visko/ontology/visko-view-v3.owl#",
  "odapp": "http://vocab.deri.ie/odapp#",
  "qb4o": "http://purl.org/olap#",
  "pic": "http://www.ipaw.info/ns/picaso#",
  "rdarel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "ramon": "http://rdfdata.eionet.europa.eu/ramon/ontology/",
  "pato": "http://purl.obolibrary.org/obo/",
  "eurostat": "http://dd.eionet.europa.eu/vocabulary/eurostat/",
  "lpeu": "http://purl.org/linkedpolitics/vocabulary/eu/plenary/",
  "geojson": "https://purl.org/geojson/vocab#",
  "npgx": "http://ns.nature.com/extensions/",
  "uc": "http://ucuenca.edu.ec/ontology#",
  "w3po": "http://purl.org/provenance/w3p/w3po#",
  "infor": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "ids": "https://w3id.org/idsa/core/",
  "being": "http://purl.org/ontomedia/ext/common/being#",
  "cmdm": "http://infra.clarin.eu/cmd/",
  "voidp": "http://www.enakting.org/provenance/voidp/",
  "lmm1": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl#",
  "icane": "http://www.icane.es/opendata/vocab#",
  "ldt": "https://www.w3.org/ns/ldt#",
  "phdd": "http://rdf-vocabulary.ddialliance.org/phdd#",
  "esequip": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/equipamiento#",
  "samfl": "http://def.seegrid.csiro.au/ontology/om/sam-lite#",
  "step": "http://purl.org/net/step#",
  "ontopic": "http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl#",
  "ctorg": "http://purl.org/ctic/infraestructuras/organizacion#",
  "wfn": "http://webofcode.org/wfn/",
  "dot": "https://w3id.org/dot#",
  "lw": "http://linkedwidgets.org/ontologies/",
  "geos": "http://www.telegraphis.net/ontology/geography/geography#",
  "swpm": "http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0#",
  "bioc": "http://deductions.github.io/biological-collections.owl.ttl#",
  "dcx": "http://dublincore.org/dcx/",
  "sylld": "http://www.semanticweb.org/syllabus/data/",
  "imo": "http://imgpedia.dcc.uchile.cl/ontology#",
  "olad": "http://openlad.org/vocab#",
  "lexicon": "http://www.example.org/lexicon#",
  "s3db": "http://www.s3db.org/core#",
  "lexcz": "http://purl.org/lex/cz#",
  "rdact": "http://rdaregistry.info/termList/RDACarrierType/",
  "dcoid": "http://dx.deepcarbon.net/",
  "year": "http://www.w3.org/year/",
  "lda": "http://purl.org/linked-data/api/vocab#",
  "emoca": "http://ns.inria.fr/emoca#",
  "zr": "http://explain.z3950.org/dtd/2.0/",
  "pmc": "http://identifiers.org/pmc/",
  "qvoc": "http://mlode.nlp2rdf.org/quranvocab#",
  "dcite": "http://purl.org/spar/datacite/",
  "situ": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "waarde": "https://lod.milieuinfo.be/ns/waarde#",
  "bwb": "http://doc.metalex.eu/bwb/ontology/",
  "hico": "http://purl.org/emmedi/hico/",
  "d0": "http://ontologydesignpatterns.org/ont/wikipedia/d0.owl#",
  "rdl": "http://data.posccaesar.org/rdl/",
  "wikim": "http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0#",
  "roevo": "http://purl.org/wf4ever/roevo#",
  "gt": "https://vocab.eccenca.com/geniustex/",
  "fire": "http://tldp.org/HOWTO/XML-RPC-HOWTO/xmlrpc-howto-java.html#",
  "dio": "https://w3id.org/dio#",
  "ceterms": "http://purl.org/ctdl/terms/",
  "tddo": "http://databugger.aksw.org/ns/core#",
  "bgdbr": "http://bg.dbpedia.org/resource/",
  "ppn": "http://parliament.uk/ontologies/person-name/",
  "static": "http://vocab-ld.org/vocab/static-ld#",
  "ns1": "http://www.w3.org/1999/xhtml/vocab#",
  "gaf": "http://groundedannotationframework.org/",
  "dbtont": "http://dbtropes.org/ont/",
  "bbcprov": "http://www.bbc.co.uk/ontologies/provenance/",
  "vag": "http://www.essepuntato.it/2013/10/vagueness/",
  "puml": "http://plantuml.com/ontology#",
  "jp1": "http://rdf.muninn-project.org/ontologies/jp1/",
  "gnvc": "http://purl.org/gc/",
  "agrd": "http://agrinepaldata.com/",
  "galaksiya": "http://ontoloji.galaksiya.com/vocab/",
  "lmm2": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl#",
  "roar": "https://w3id.org/roar#",
  "dq": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality#",
  "msm": "http://iserve.kmi.open.ac.uk/ns/msm#",
  "olac": "http://www.language-archives.org/OLAC/1.0/",
  "amalgame": "http://purl.org/vocabularies/amalgame#",
  "lmdb": "http://data.linkedmdb.org/",
  "omnfed": "http://open-multinet.info/ontology/omn-federation#",
  "viskoo": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
  "si": "https://si-digital-framework.org/SI#",
  "graves": "http://rdf.muninn-project.org/ontologies/graves#",
  "jolux": "http://data.legilux.public.lu/resource/ontology/jolux#",
  "scufl2": "http://ns.taverna.org.uk/2010/scufl2#",
  "vvo": "http://purl.org/vvo/ns#",
  "airs": "https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#",
  "pois": "http://purl.oclc.org/POIS/vcblr#",
  "omdoc": "http://omdoc.org/ontology/",
  "eunis": "http://eunis.eea.europa.eu/rdf/species-schema.rdf#",
  "ldl": "https://w3id.org/ldpdl/ns#",
  "rut": "http://rdfunit.aksw.org/ns/core#",
  "locwd": "http://purl.org/locwd/schema#",
  "elec": "http://purl.org/ctic/sector-publico/elecciones#",
  "gadm": "http://gadm.geovocab.org/ontology#",
  "ecglview": "http://schema.geolink.org/view/",
  "rdafs": "http://rdaregistry.info/termList/fontSize/",
  "osadm": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "wf4ever": "http://purl.org/wf4ever/wf4ever#",
  "kai": "http://kai.uni-kiel.de/",
  "oplprod": "http://www.openlinksw.com/ontology/products#",
  "vmm": "http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0#",
  "vext": "http://ldf.fi/void-ext#",
  "pcdt": "http://purl.org/procurement/public-contracts-datatypes#",
  "trig": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "opengov": "http://www.w3.org/opengov#",
  "fred": "http://www.ontologydesignpatterns.org/ont/fred/domain.owl#",
  "gci": "http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl#",
  "vapour": "http://vapour.sourceforge.net/vocab.rdf#",
  "pid": "http://permid.org/ontology/organization/",
  "location": "http://sw.deri.org/2006/07/location/loc#",
  "vir": "http://w3id.org/vir#",
  "biotop": "http://purl.org/biotop/biotop.owl#",
  "poste": "http://data.lirmm.fr/ontologies/poste#",
  "aws": "http://purl.oclc.org/NET/ssnx/meteo/aws#",
  "npdv": "http://sws.ifi.uio.no/vocab/npd#",
  "owl2xml": "http://www.w3.org/2006/12/owl2-xml#",
  "uis": "http://uis.270a.info/dataset/",
  "moo": "http://www.movieontology.org/2009/11/09/movieontology.owl#",
  "rdagrp": "http://rdaregistry.info/termList/groovePitch/",
  "bnf": "http://www.w3.org/2000/10/swap/grammar/bnf#",
  "coll": "http://purl.org/co/",
  "rvz": "http://rdfvizler.dyreriket.xyz/vocabulary/core#",
  "regorg": "http://www.w3.org/ns/regorg#",
  "rdatr": "http://rdaregistry.info/termList/typeRec/",
  "ontosec": "http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl#",
  "mammal": "http://lod.taxonconcept.org/ontology/p01/Mammalia/index.owl#",
  "aktivesa": "http://sa.aktivespace.org/ontologies/aktivesa#",
  "teamwork": "http://topbraid.org/teamwork#",
  "vsw": "http://verticalsearchworks.com/ontology/",
  "odbc": "http://www.openlinksw.com/ontology/odbc#",
  "genre": "http://sparql.cwrc.ca/ontologies/genre#",
  "fuseki": "http://jena.apache.org/fuseki#",
  "lcdr": "http://ns.lucid-project.org/revision/",
  "fcp": "http://www.newmedialab.at/fcp/",
  "fnabox": "http://www.ontologydesignpatterns.org/ont/framenet/abox/",
  "mocanal": "http://www.semanticweb.org/asow/ontologies/2013/9/untitled-ontology-36#",
  "wn20": "http://www.w3.org/2006/03/wn/wn20/",
  "led": "http://led.kmi.open.ac.uk/term/",
  "llm": "http://lodlaundromat.org/metrics/ontology/",
  "frb": "http://frb.270a.info/dataset/",
  "rlnr": "http://rdflivenews.aksw.org/resource/",
  "incident": "http://vocab.resc.info/incident#",
  "crime": "http://purl.org/vocab/reloc/",
  "proms": "http://promsns.org/def/proms#",
  "mmoon": "http://mmoon.org/mmoon/",
  "prviv": "http://purl.org/net/provenance/integrity#",
  "pfeepsa": "https://w3id.org/pfeepsa#",
  "rdai": "http://rdaregistry.info/Elements/i/",
  "cpack": "http://cliopatria.swi-prolog.org/schema/cpack#",
  "dsn": "http://purl.org/dsnotify/vocab/eventset/",
  "bpo": "https://w3id.org/bpo#",
  "sx": "http://shex.io/ns/shex#",
  "pdf": "http://ns.adobe.com/pdf/1.3/",
  "jpost": "http://rdf.jpostdb.org/ontology/jpost.owl#",
  "acrt": "http://privatealpha.com/ontology/certification/1#",
  "eccauth": "https://vocab.eccenca.com/auth/",
  "geosp": "http://rdf.geospecies.org/ont/geospecies#",
  "rdf123": "http://rdf123.umbc.edu/ns/",
  "lido": "http://www.lido-schema.org/",
  "beth": "http://www.google.com/",
  "topo": "http://data.ign.fr/def/topo#",
  "opmo": "http://openprovenance.org/model/opmo#",
  "rdacc": "http://rdaregistry.info/termList/RDAColourContent/",
  "vrank": "http://purl.org/voc/vrank#",
  "limo": "http://www.purl.org/limo-ontology/limo#",
  "ecgl": "http://schema.geolink.org/",
  "saif": "http://wwwiti.cs.uni-magdeburg.de/~srahman/",
  "obeu": "http://data.openbudgets.eu/ontology/",
  "pkgsrc": "http://pkgsrc.co/schema#",
  "bner": "http://datos.bne.es/resource/",
  "afr": "http://purl.allotrope.org/ontologies/result#",
  "cd": "http://citydata.wu.ac.at/ns#",
  "geocontext": "http://www.geocontext.org/publ/2013/vocab#",
  "reg": "http://purl.org/linked-data/registry#",
  "pwo": "http://purl.org/spar/pwo/",
  "ssno": "http://www.w3.org/ns/ssn/",
  "oecc": "http://www.oegov.org/core/owl/cc#",
  "glview": "http://schema.geolink.org/dev/view/",
  "csv": "http://vocab.sindice.net/csv/",
  "reegle": "http://reegle.info/schema#",
  "output": "http://volt-name.space/vocab/output#",
  "frbrer": "http://iflastandards.info/ns/fr/frbr/frbrer/",
  "logies": "https://data.vlaanderen.be/ns/logies#",
  "cwlprov": "https://w3id.org/cwl/prov#",
  "sto": "https://w3id.org/i40/sto#",
  "ln": "https://w3id.org/ln#",
  "odv": "http://reference.data.gov.uk/def/organogram/",
  "omg": "https://w3id.org/omg#",
  "passim": "http://data.lirmm.fr/ontologies/passim#",
  "rdafmn": "http://rdaregistry.info/termList/MusNotation/",
  "condition": "http://www.kinjal.com/condition:",
  "text": "http://jena.apache.org/text#",
  "ali": "http://www.niso.org/schemas/ali/1.0/",
  "ldvm": "http://linked.opendata.cz/ontology/ldvm/",
  "hlygt": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "owlse": "http://www.daml.org/services/owl-s/1.2/generic/Expression.owl#",
  "locah": "http://data.archiveshub.ac.uk/def/",
  "r3d": "http://www.re3data.org/schema/3-0#",
  "tb": "https://w3id.org/timebank#",
  "studiop": "http://purl.org/resource/pilatesstudio/",
  "fhir": "http://hl7.org/fhir/",
  "rofch": "http://rdaregistry.info/termList/rofch/",
  "edgar": "http://edgarwrap.ontologycentral.com/vocab/edgar#",
  "oils": "http://lemon-model.net/oils#",
  "rdarm": "http://registry.info/termList/recMedium/",
  "eccrev": "https://vocab.eccenca.com/revision/",
  "kegg": "http://bio2rdf.org/ns/kegg#",
  "sru": "http://www.loc.gov/zing/srw/",
  "lawd": "http://lawd.info/ontology/",
  "rdaco": "http://rdaregistry.info/termList/RDAContentType/",
  "tis": "http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl#",
  "bcngeo": "http://datos.bcn.cl/ontologies/bcn-geographics#",
  "defns": "http://www.openarchives.org/OAI/2.0/",
  "orcid": "http://orcid.org/",
  "rdaftn": "http://rdaregistry.info/termList/TacNotation/",
  "cocoon": "https://w3id.org/cocoon/v1.0#",
  "eem": "http://purl.org/eem#",
  "limoo": "http://purl.org/LiMo/0.1/",
  "voc": "http://voc.odw.tw/",
  "iana": "http://www.iana.org/assignments/relation/",
  "roterms": "http://purl.org/wf4ever/roterms#",
  "sirene": "https://sireneld.io/vocab/sirene#",
  "babelnet": "http://babelnet.org/2.0/",
  "bevon": "http://rdfs.co/bevon/",
  "crowd": "http://purl.org/crowd/",
  "basic": "http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic#",
  "tui": "http://data.ifs.tuwien.ac.at/study/resource/",
  "webac": "http://fedora.info/definitions/v4/webac#",
  "rdarole": "http://rdvocab.info/roles/",
  "datacite": "http://purl.org/spar/datacite/",
  "gts": "http://resource.geosciml.org/ontology/timescale/gts#",
  "nxs": "http://www.neclimateus.org/",
  "imf": "http://imf.270a.info/dataset/",
  "plg": "http://parliament.uk/ontologies/legislation/",
  "rdaterm": "http://rdaregistry.info/termList/RDATerms/",
  "shui": "http://www.w3.org/ns/shacl-ui#",
  "citof": "http://www.essepuntato.it/2013/03/cito-functions#",
  "figigii": "http://www.omg.org/spec/FIGI/GlobalInstrumentIdentifiers/",
  "fntbox": "http://www.ontologydesignpatterns.org/ont/framenet/tbox/",
  "jjd": "http://www.joshuajeeson.com/",
  "caplibacl": "http://schemas.capita-libraries.co.uk/2015/acl/schema#",
  "frsad": "http://iflastandards.info/ns/fr/frsad/",
  "muldicat": "http://iflastandards.info/ns/muldicat#",
  "afm": "http://purl.allotrope.org/ontologies/material/",
  "form": "http://deductions-software.com/ontologies/forms.owl.ttl#",
  "ubiq": "http://server.ubiqore.com/ubiq/core#",
  "lyon": "http://dbpedia.org/resource/Lyon/",
  "customer": "http://www.valuelabs.com/",
  "task": "http://deductions.github.io/task-management.owl.ttl#",
  "ordf": "http://purl.org/NET/ordf/",
  "agrovoc": "http://aims.fao.org/aos/agrovoc/",
  "dicom": "http://purl.org/healthcarevocab/v1#",
  "meeting": "http://www.w3.org/2002/07/meeting#",
  "spdx": "http://spdx.org/rdf/terms#",
  "pproc": "http://contsem.unizar.es/def/sector-publico/pproc#",
  "lexvo": "http://lexvo.org/ontology#",
  "gq": "http://genomequest.com/",
  "laabs": "http://dbpedia.org/resource/",
  "eepsa": "https://w3id.org/eepsa#",
  "lswpm": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl#",
  "gdc": "https://portal.gdc.cancer.gov/cases/",
  "bbccms": "http://www.bbc.co.uk/ontologies/cms/",
  "oxi": "http://omerxi.com/ontologies/core.owl.ttl#",
  "oplecrm": "http://www.openlinksw.com/ontology/ecrm#",
  "sdmxcode": "http://purl.org/linked-data/sdmx/2009/code#",
  "open311": "http://ontology.eil.utoronto.ca/open311#",
  "nlon": "http://lod.nl.go.kr/ontology/",
  "lofv": "http://purl.org/legal_form/vocab#",
  "oplcb": "http://www.openlinksw.com/schemas/crunchbase#",
  "hva": "http://www.ebusiness-unibw.org/ontologies/hva/ontology#",
  "csp": "http://vocab.deri.ie/csp#",
  "bb": "http://www.snik.eu/ontology/bb/",
  "mdi": "http://w3id.org/multidimensional-interface/ontology#",
  "ruian": "https://data.cssz.cz/ontology/ruian/",
  "clirio": "http://clirio.kaerle.com/clirio.owl#",
  "iati": "http://purl.org/collections/iati/",
  "contsem": "http://contsem.unizar.es/def/sector-publico/contratacion#",
  "cbim": "http://www.coinsweb.nl/cbim-2.0.rdf#",
  "cim": "http://iec.ch/TC57/2013/CIM-schema-cim16#",
  "conference": "https://w3id.org/scholarlydata/ontology/conference-ontology.owl#",
  "lingvo": "http://www.lingvoj.org/ontology#",
  "roadmap": "http://mappings.roadmap.org/",
  "yd": "https://yodata.io/",
  "umls": "http://bioportal.bioontology.org/ontologies/umls/",
  "rls": "https://w3id.org/lovcube/ns/relovstats#",
  "rdalay": "http://rdaregistry.info/termList/layout/",
  "volt": "http://volt-name.space/ontology/",
  "tsn": "http://purl.org/net/tsn#",
  "voidext": "http://rdfs.org/ns/void-ext#",
  "owsom": "https://onlinesocialmeasures.wordpress.com/",
  "water": "http://escience.rpi.edu/ontology/semanteco/2/0/water.owl#",
  "hr": "http://iserve.kmi.open.ac.uk/ns/hrests#",
  "qms": "http://data.europa.eu/esco/qms#",
  "lswmo": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl#",
  "pep": "https://w3id.org/pep/",
  "eurlex": "http://eur-lex.publicdata.eu/ontology/",
  "bdc": "http://dbpedia.org/resource/Category:",
  "essglobal": "http://purl.org/essglobal/vocab/v1.0/",
  "videogame": "http://purl.org/net/vgo#",
  "tree": "https://w3id.org/tree#",
  "drk": "http://drakon.su/",
  "oprovo": "http://openprovenance.org/ontology#",
  "mls": "http://www.w3.org/ns/mls#",
  "asgv": "http://aims.fao.org/aos/agrovoc/",
  "county": "http://myexample.org/county#",
  "bsym": "http://bsym.bloomberg.com/sym/",
  "rofer": "http://rdaregistry.info/termList/rofer/",
  "fr": "https://w3id.org/fr/def/core#",
  "pp": "http://peoplesplaces.de/ontology#",
  "sfd": "http://semantic-forms.cc:9112/ldp/",
  "ago": "http://awesemantic-geo.link/ontology/",
  "mexv": "http://mex.aksw.org/mex-algo#",
  "infection": "http://www.agfa.com/w3c/2009/infectiousDisorder#",
  "trao": "http://linkeddata.finki.ukim.mk/lod/ontology/tao#",
  "organ": "http://www.univalle.edu.co/ontologies/Organ#",
  "rdarr": "http://rdaregistry.info/termList/RDAReductionRatio/",
  "scco": "http://rdf.ebi.ac.uk/terms/surechembl#",
  "ha": "http://sensormeasurement.appspot.com/ont/home/homeActivity#",
  "diag": "http://www.loc.gov/zing/srw/diagnostic/",
  "fun": "http://w3id.org/sparql-generate/fn/",
  "adf": "http://purl.allotrope.org/ontologies/datapackage#",
  "owms": "http://standaarden.overheid.nl/owms/terms/",
  "vdpp": "http://data.lirmm.fr/ontologies/vdpp#",
  "lmx": "http://www.w3.org/XML/1998/namespace/",
  "ja": "http://jena.hpl.hp.com/2005/11/Assembler#",
  "cwl": "https://w3id.org/cwl/cwl#",
  "keys": "http://purl.org/NET/c4dm/keys.owl#",
  "dsv": "https://w3id.org/dsv#",
  "itm": "http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0#",
  "rdag2": "http://rdvocab.info/ElementsGr2/",
  "uom": "http://www.opengis.net/def/uom/OGC/1.0/",
  "rdafrbr": "http://rdvocab.info/uri/schema/FRBRentitiesRDA/",
  "wdtn": "http://www.wikidata.org/prop/direct-normalized/",
  "dk": "http://www.data-knowledge.org/dk/schema/rdf/latest/",
  "cmdi": "http://www.clarin.eu/cmd/",
  "sakthi": "http://infotech.nitk.ac.in/research-scholars/sakthi-murugan-r/",
  "cwork": "http://www.bbc.co.uk/ontologies/creativework/",
  "lslife": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl#",
  "numbers": "http://km.aifb.kit.edu/projects/numbers/",
  "ruto": "http://rdfunit.aksw.org/ns/core#",
  "chear": "http://hadatac.org/ont/chear#",
  "swpatho": "http://swpatho.ag-nbi.de/context/meta.owl#",
  "opa": "https://w3id.org/laas-iot/adream#",
  "wimpo": "http://rdfex.org/withImports?uri=",
  "composer": "http://dbpedia.org/ontology/composer/",
  "demlab": "http://www.demcare.eu/ontologies/demlab.owl#",
  "lgdm": "http://linkedgeodata.org/meta/",
  "bob": "http://good.dad/meaning/bob#",
  "bblfish": "http://bblfish.net/people/henry/card#",
  "kml": "http://www.opengis.net/kml/2.2#",
  "ogbd": "http://www.ogbd.fr/2012/ontologie#",
  "td5": "http://td5.org/#",
  "mmt": "http://linkedmultimedia.org/sparql-mm/functions/temporal#",
  "one": "https://bioportal.bioontology.org/ontologies/ONE/",
  "bds": "http://www.bigdata.com/rdf/search#",
  "ndnp": "http://chroniclingamerica.loc.gov/terms#",
  "apf": "http://jena.apache.org/ARQ/property#",
  "audit": "http://fedora.info/definitions/v4/audit#",
  "csdbp": "http://cs.dbpedia.org/",
  "dpn": "http://purl.org/dpn#",
  "munc": "http://ns.inria.fr/munc#",
  "soch": "http://kulturarvsdata.se/ksamsok#",
  "crsw": "http://courseware.rkbexplorer.com/ontologies/courseware#",
  "vstoi": "http://hadatac.org/ont/vstoi#",
  "opllog": "http://www.openlinksw.com/ontology/logging#",
  "seeds": "http://deductions.github.io/seeds.owl.ttl#",
  "sdshare": "http://www.sdshare.org/2012/extension/",
  "door": "http://kannel.open.ac.uk/ontology#",
  "mds": "http://doc.metalex.eu/id/",
  "rofrr": "http://rdaregistry.info/termList/rofrr/",
  "az": "https://w3id.org/people/az/",
  "ecore": "http://www.eclipse.org/emf/2002/Ecore#",
  "cjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
  "navm": "https://w3id.org/navigation_menu#",
  "jerm": "http://jermontology.org/ontology/JERMOntology#",
  "dcosample": "http://info.deepcarbon.net/sample/schema#",
  "rdasco": "http://rdaregistry.info/termList/soundCont/",
  "amt": "http://academic-meta-tool.xyz/vocab#",
  "radar": "http://www.radar-projekt.org/display/",
  "doacc": "http://purl.org/net/bel-epa/doacc#",
  "aprov": "http://purl.org/a-proc#",
  "ctrl": "https://w3id.org/ibp/CTRLont#",
  "bis": "http://bis.270a.info/dataset/",
  "assoc": "https://w3id.org/associations/vocab#",
  "rofem": "http://rdaregistry.info/termList/rofem/",
  "svcs": "http://rdfs.org/sioc/services#",
  "rofid": "http://rdaregistry.info/termList/rofid/",
  "bld": "http://biglinkeddata.com/",
  "datex": "http://vocab.datex.org/terms#",
  "scho": "http://www.scholarlydata.org/ontology/conference-ontology.owl#",
  "markus": "http://www.markus.com/",
  "mandaat": "http://data.vlaanderen.be/ns/mandaat#",
  "rpath": "https://w3id.org/lodsight/rdf-path#",
  "mexalgo": "http://mex.aksw.org/mex-algo#",
  "frappe": "http://streamreasoning.org/ontologies/frappe#",
  "olca": "http://www.lingvoj.org/olca#",
  "hasneto": "http://hadatac.org/ont/hasneto#",
  "faostat": "http://reference.eionet.europa.eu/faostat/schema/",
  "whisky": "http://vocab.org/whisky/terms/",
  "lg": "https://purl.org/lg/",
  "bdo": "http://purl.bdrc.io/ontology/core/",
  "rofrt": "http://rdaregistry.info/termList/rofrt/",
  "oliasystem": "http://purl.org/olia/system.owl#",
  "its": "http://www.w3.org/2005/11/its/rdf#",
  "lheo": "http://www.conjecto.com/ontology/2015/lheo#",
  "emergelm": "http://purl.org/emergel/modules#",
  "ver": "https://w3id.org/version/ontology#",
  "fnom": "https://w3id.org/function/vocabulary/mapping#",
  "oplmkt": "http://www.openlinksw.com/ontology/market#",
  "osd": "http://a9.com/-/spec/opensearch/1.1/",
  "timex": "http://data.wu.ac.at/ns/timex#",
  "hello": "https://www.youtube.com/user/SuperTellAFriend/featured/",
  "edr": "https://w3id.org/laas-iot/edr#",
  "maso": "http://securitytoolbox.appspot.com/MASO#",
  "ofrd": "http://purl.org/opdm/refrigerator#",
  "lovc": "https://w3id.org/lovcube/ns/lovcube#",
  "bbccore": "http://www.bbc.co.uk/ontologies/coreconcepts/",
  "dbms": "http://www.openlinksw.com/ontology/dbms-app-ontology#",
  "tix": "http://toptix.com/2010/esro/",
  "spcm": "http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0#",
  "rdapmt": "http://rdaregistry.info/termList/prodTactile/",
  "bdr": "http://purl.bdrc.io/resource/",
  "eame": "http://www.semanticweb.org/ontologia_EA#",
  "mwapi": "https://www.mediawiki.org/ontology#API/",
  "efrbroo": "http://erlangen-crm.org/efrbroo/",
  "memento": "http://mementoweb.org/ns#",
  "erce": "http://xxefe.de/",
  "oplli": "http://www.openlinksw.com/schemas/linkedin#",
  "rdacarx": "http://rdaregistry.info/termList/RDACarrierEU/",
  "traffic": "http://www.sensormeasurement.appspot.com/ont/transport/traffic#",
  "escom": "http://vocab.linkeddata.es/datosabiertos/def/comercio/tejidoComercial#",
  "oplres": "http://www.openlinksw.com/ontology/restrictions#",
  "physics": "http://www.astro.umd.edu/~eshaya/astro-onto/owl/physics.owl#",
  "conll": "http://ufal.mff.cuni.cz/conll2009-st/task-description.html#",
  "sdt": "http://statisticaldata.linkedwidgets.org/terms/",
  "gbol": "http://gbol.life/0.1#",
  "eccpubsub": "https://vocab.eccenca.com/pubsub/",
  "vogd": "http://ogd.ifs.tuwien.ac.at/vienna/geo/",
  "eol": "http://purl.org/biodiversity/eol/",
  "planet": "http://dbpedia.org/",
  "w3cgeo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "summa": "http://purl.org/voc/summa/",
  "voidex": "http://www.swi-prolog.org/rdf/library/",
  "yaco": "https://www.irit.fr/recherches/MELODI/ontologies/cinema#",
  "ensembl": "http://rdf.ebi.ac.uk/resource/ensembl/",
  "qkdv": "http://qudt.org/vocab/dimensionvector/",
  "llont": "http://www.linklion.org/ontology#",
  "rdabf": "http://rdaregistry.info/termList/bookFormat/",
  "biml": "http://schemas.varigence.com/biml.xsd#",
  "sgg": "http://www.springernature.com/scigraph/graphs/",
  "rdabs": "http://rdaregistry.info/termList/broadcastStand/",
  "foaffff": "http://gogl.com/",
  "lemonuby": "http://lemon-model.net/lexica/uby/",
  "gnm": "http://www.geonames.org/ontology/mappings/",
  "rdaz": "http://rdaregistry.info/Elements/z/",
  "gont": "https://gont.ch/",
  "literature": "http://purl.org/net/cnyt-literature#",
  "geod": "http://vocab.lenka.no/geo-deling#",
  "rdaemm": "http://rdaregistry.info/termList/emulsionMicro/",
  "system": "http://www.univalle.edu.co/ontologies/System#",
  "semiot": "http://w3id.org/semiot/ontologies/semiot#",
  "swrc2": "https://www.cs.vu.nl/~mcaklein/onto/swrc_ext/2005/05#",
  "oplwebsrv": "http://www.openlinksw.com/ontology/webservices#",
  "fdbp": "http://fr.dbpedia.org/property/",
  "ecoll": "http://purl.org/ceu/eco/1.0#",
  "frgeo": "http://rdf.insee.fr/geo/",
  "travel": "http://www.co-ode.org/roberts/travel.owl#",
  "km4c": "http://www.disit.org/km4city/schema#",
  "cpov": "http://data.europa.eu/m8g/",
  "sgfn": "http://w3id.org/sparql-generate/fn/",
  "vidont": "http://vidont.org/",
  "lmu": "https://w3id.org/laas-iot/lmu#",
  "eccdi": "https://vocab.eccenca.com/di/",
  "persee": "http://data.persee.fr/ontology/persee_ontology/",
  "otl": "https://w3id.org/opentrafficlights#",
  "vehma": "http://deductions.github.io/vehicule-management.owl.ttl#",
  "pmo": "http://premon.fbk.eu/ontology/core#",
  "oplacl": "http://www.openlinksw.com/ontology/acl#",
  "nno": "https://w3id.org/nno/ontology#",
  "rgml": "http://purl.org/puninj/2001/05/rgml-schema#",
  "duv": "http://www.w3.org/ns/duv#",
  "spvqa": "https://bmake.th-brandenburg.de/spv#",
  "lfov": "https://w3id.org/legal_form#",
  "rdfp": "https://w3id.org/rdfp/",
  "oplstocks": "http://www.openlinksw.com/ontology/stocks#",
  "oplweb": "http://www.openlinksw.com/schemas/oplweb#",
  "rofin": "http://rdaregistry.info/termList/rofin/",
  "h2o": "http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic#",
  "newsevents": "http://www.aifb.uni-karlsruhe.de/WBS/uhe/ontologies#",
  "besluit": "http://data.vlaanderen.be/ns/besluit#",
  "minim": "http://purl.org/minim/minim#",
  "rdaar": "http://rdaregistry.info/termList/AspectRatio/",
  "s4syst": "https://saref.etsi.org/saref4syst/",
  "url": "http://schema.org/",
  "dsw": "http://purl.org/dsw/",
  "ims": "http://www.imsglobal.org/xsd/imsmd_v1p2/",
  "oplbenefit": "http://www.openlinksw.com/ontology/benefits#",
  "dbug": "http://ontologi.es/doap-bugs#",
  "dcap": "http://purl.org/ws-mmi-dc/terms/",
  "provinsi": "http://provinsi.com/",
  "pcdm": "http://pcdm.org/models#",
  "mem": "http://mementoweb.org/ns#",
  "espresup": "http://vocab.linkeddata.es/datosabiertos/def/hacienda/presupuestos#",
  "ca": "http://complyadvantage.com/",
  "aml": "https://w3id.org/i40/aml#",
  "cubeont": "http://ontology.cube.global/",
  "ntag": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "iter": "http://w3id.org/sparql-generate/iter/",
  "nkos": "http://w3id.org/nkos#",
  "ido": "http://purl.obolibrary.org/obo/ido.owl#",
  "rdapm": "http://rdaregistry.info/termList/RDAproductionMethod/",
  "rdag1": "http://rdvocab.info/Elements/",
  "uby": "http://purl.org/olia/ubyCat.owl#",
  "ipsv": "http://id.esd.org.uk/list/",
  "sorg": "http://schema.org/",
  "cue": "http://www.clarin.eu/cmdi/cues/display/1.0#",
  "sfn": "http://semweb.datasciencelab.be/ns/sfn#",
  "onisep": "http://rdf.onisep.fr/resource/",
  "irsteaont": "http://ontology.irstea.fr/weather/ontology#",
  "meshv": "http://id.nlm.nih.gov/mesh/vocab#",
  "naval": "http://rdf.muninn-project.org/ontologies/naval#",
  "nih": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  "gns": "http://sws.geonames.org/",
  "rofit": "http://rdaregistry.info/termList/rofit/",
  "cpi": "http://www.ebusiness-unibw.org/ontologies/cpi/ns#",
  "ilap": "http://data.posccaesar.org/ilap/",
  "religion": "http://rdf.muninn-project.org/ontologies/religion#",
  "oup": "http://purl.org/ontology-use-patterns#",
  "odf": "http://docs.oasis-open.org/ns/office/1.2/meta/odf#",
  "tx": "http://swtmp.gitlab.io/vocabulary/templates.owl#",
  "tgm": "http://id.loc.gov/vocabulary/graphicMaterials/",
  "r4ta": "http://ns.inria.fr/ratio4ta/v1#",
  "fluidops": "http://www.fluidops.com/",
  "vacseen1": "http://www.semanticweb.org/parthasb/ontologies/2014/6/vacseen1/",
  "rdacdt": "http://rdaregistry.info/termList/RDACartoDT/",
  "lmf": "http://www.lexinfo.net/lmf#",
  "uneskos": "http://purl.org/voc/uneskos#",
  "dwciri": "http://rs.tdwg.org/dwc/iri/",
  "cff": "http://purl.oclc.org/NET/ssnx/cf/cf-feature#",
  "pmhb": "http://pmhb.org/",
  "uta": "http://uptheasset.org/ontology#",
  "s4ee": "https://w3id.org/saref4ee#",
  "beer": "http://beer.com/",
  "phy": "https://w3id.org/skgo/phy#",
  "rdafnv": "http://rdaregistry.info/termList/noteForm/",
  "odapps": "http://semweb.mmlab.be/ns/odapps#",
  "mexcore": "http://mex.aksw.org/mex-core#",
  "vplan": "http://www.ifs.tuwien.ac.at/~miksa/ontologies/VPlan.owl#",
  "esapar": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/aparcamiento#",
  "id": "http://identifiers.org/",
  "pcit": "http://public-contracts.nexacenter.org/id/propertiesRole/",
  "ioto": "http://www.irit.fr/recherches/MELODI/ontologies/IoT-O#",
  "swcomp": "https://github.com/ali1k/ld-reactor/blob/master/vocabulary/index.ttl#",
  "bsh": "https://brickschema.org/schema/1.1.0/BrickShape#",
  "beo": "https://w3id.org/beo#",
  "nature": "http://deductions.github.io/nature_observation.owl.ttl#",
  "geovoid": "http://purl.org/geovocamp/ontology/geovoid/",
  "glycan": "http://purl.jp/bio/12/glyco/glycan#",
  "brk": "http://brk.basisregistraties.overheid.nl/def/brk#",
  "escjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
  "dicera": "http://semweb.mmlab.be/ns/dicera#",
  "vcard2006": "http://www.w3.org/2006/vcard/ns#",
  "spv": "http://completeness.inf.unibz.it/sp-vocab#",
  "physo": "http://merlin.phys.uni.lodz.pl/onto/physo/physo.owl#",
  "esservicio": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/servicio#",
  "iiif": "http://iiif.io/api/image/2#",
  "wsdl": "http://www.w3.org/ns/wsdl-rdf#",
  "ifcowl": "http://www.buildingsmart-tech.org/ifcOWL/IFC4_ADD2#",
  "tarql": "http://tarql.github.io/tarql#",
  "aksw": "http://aksw.org/",
  "devuan": "https://devuan.net.br/",
  "itcat": "http://th-brandenburg.de/ns/itcat#",
  "veo": "http://linkeddata.finki.ukim.mk/lod/ontology/veo#",
  "rdare": "http://rdaregistry.info/termList/RDARegionalEncoding/",
  "xslopm": "http://purl.org/net/opmv/types/xslt#",
  "mmm": "http://www.mico-project.eu/ns/mmm/2.0/schema#",
  "ncicp": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  "modsci": "https://w3id.org/skgo/modsci#",
  "ogdl4m": "https://github.com/martynui/OGDL4M/",
  "sdmxm": "http://purl.org/linked-data/sdmx/2009/measure#",
  "alice": "http://example.org/",
  "atlasterms": "http://rdf.ebi.ac.uk/terms/atlas/",
  "dbfo": "http://dbpedia.org/facts/ontology#",
  "qbe": "http://citydata.wu.ac.at/qb-equations#",
  "bkb": "https://budayakb.cs.ui.ac.id/ns#",
  "hdo": "http://www.samos.gr/ontologies/helpdeskOnto.owl#",
  "literal": "http://www.essepuntato.it/2010/06/literalreification/",
  "cog": "http://purl.org/ontology/cco/core#",
  "esadm": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/territorio#",
  "dead": "http://utpl.edu.ec/sbc/data/",
  "ontoneo": "http://purl.obolibrary.org/obo/ontoneo/",
  "nobel": "http://data.nobelprize.org/terms/",
  "ldn": "https://www.w3.org/TR/ldn/#",
  "dby": "http://dbpedia.org/class/yago/",
  "da": "https://www.wowman.org/index.php?id=1&type=get#",
  "vocnet": "http://schema.vocnet.org/",
  "vam": "http://www.metmuseum.org/",
  "rm": "http://jazz.net/ns/rm#",
  "gg": "http://www.gemeentegeschiedenis.nl/gg-schema#",
  "ul": "http://underlay.mit.edu/ns/",
  "oop": "http://w3id.org/oop#",
  "number": "http://km.aifb.kit.edu/projects/numbers/number#",
  "roc": "https://w3id.org/ro/curate#",
  "rdacpc": "http://rdaregistry.info/termList/configPlayback/",
  "vocals": "http://w3id.org/rsp/vocals#",
  "wde": "http://www.wikidata.org/entity/",
  "ppr": "http://purl.org/datanode/ppr/ns/",
  "ldq": "http://www.linkeddata.es/ontology/ldq#",
  "rofsm": "http://rdaregistry.info/termList/rofsm/",
  "fp3": "http://vocab.fusepool.info/fp3#",
  "or": "http://openresearch.org/vocab/",
  "imjv": "https://data.imjv.omgeving.vlaanderen.be/ns/imjv#",
  "crmeh": "http://purl.org/crmeh#",
  "legal": "http://www.w3.org/ns/legal#",
  "mobivoc": "http://schema.mobivoc.org/",
  "semsur": "http://purl.org/SemSur/",
  "apb": "http://www.analysispartners.org/businessmodel/",
  "tosh": "http://topbraid.org/tosh#",
  "decprov": "http://promsns.org/def/decprov#",
  "mydb": "http://mydb.org/",
  "rdaspc": "http://rdaregistry.info/termList/specPlayback/",
  "rdag3": "http://rdvocab.info/ElementsGr3/",
  "input": "http://volt-name.space/vocab/input#",
  "gobierno": "http://www.gobierno.es/gobierno/",
  "edg": "http://edg.topbraid.solutions/model/",
  "halyard": "http://merck.github.io/Halyard/ns#",
  "mus": "http://data.doremus.org/ontology#",
  "geor": "http://www.opengis.net/def/rule/geosparql/",
  "rofrm": "http://rdaregistry.info/termList/rofrm/",
  "sgiter": "http://w3id.org/sparql-generate/iter/",
  "aozora": "http://purl.org/net/aozora/",
  "yso": "http://www.yso.fi/onto/yso/",
  "lgdt": "http://linkedgeodata.org/triplify/",
  "alethio": "http://aleth.io/",
  "l2sp": "http://www.linked2safety-project.eu/properties/",
  "gvoith": "http://assemblee-virtuelle.github.io/grands-voisins-v2/thesaurus.ttl#",
  "lgt": "http://linkedgadget.com/wiki/Property:",
  "isbdu": "http://iflastandards.info/ns/isbd/unc/elements/",
  "it": "http://www.influencetracker.com/ontology#",
  "sdterms": "http://statisticaldata.linkedwidgets.org/terms/",
  "mbgd": "http://mbgd.genome.ad.jp/owl/mbgd.owl#",
  "rofim": "http://rdaregistry.info/termList/rofim/",
  "ethc": "http://ethoinformatics.org/ethocore/",
  "tissue": "http://www.univalle.edu.co/ontologies/Tissue#",
  "ttla": "https://w3id.org/ttla/",
  "iotlite": "http://purl.oclc.org/NET/UNIS/fiware/iot-lite#",
  "dataid": "http://dataid.dbpedia.org/ns/core#",
  "nas": "https://data.nasa.gov/ontologies/atmonto/NAS#",
  "sdmxc": "http://purl.org/linked-data/sdmx/2009/concept#",
  "swa": "http://topbraid.org/swa#",
  "nosql": "http://purl.org/db/nosql#",
  "neotecbib": "http://neotec.rc.unesp.br/resource/NeotectonicsBibliography/",
  "sciprov": "http://sweetontology.net/reprSciProvenance/",
  "huto": "http://ns.inria.fr/huto/",
  "rdaft": "http://rdaregistry.info/termList/fileType/",
  "ucum": "http://purl.oclc.org/NET/muo/ucum/",
  "tadirah": "http://tadirah.dariah.eu/vocab/",
  "scholl": "http://menemeneml.com/school#",
  "dcodt": "http://info.deepcarbon.net/datatype/schema#",
  "geo7": "https://www.geo7.ch/",
  "srx": "http://www.w3.org/2005/sparql-results#",
  "cska": "http://pfclitex.com/",
  "loted": "http://loted.eu/ontology#",
  "juso": "http://rdfs.co/juso/",
  "rdapf": "http://rdaregistry.info/termList/presFormat/",
  "um": "http://intelleo.eu/ontologies/user-model/ns/",
  "ontop": "https://w3id.org/ontop/",
  "ocds": "http://purl.org/onto-ocds/ocds#",
  "rdax": "http://rdaregistry.info/Elements/x/",
  "geoloc": "http://deductions.github.io/geoloc.owl.ttl#",
  "lsq": "http://lsq.aksw.org/vocab#",
  "dnbt": "http://d-nb.info/standards/elementset/dnb#",
  "iso37120": "http://ontology.eil.utoronto.ca/ISO37120.owl#",
  "rvl": "http://purl.org/rvl/",
  "imind": "http://schema.intellimind.ns/symbology#",
  "idot": "http://identifiers.org/idot/",
  "koly": "http://www.ensias.ma/",
  "uri4uri": "http://uri4uri.net/vocab#",
  "pbody": "http://reference.data.gov.uk/def/public-body/",
  "ods": "http://lod.xdams.org/ontologies/ods/",
  "rfd": "http://com.intrinsec//ontology#",
  "smxm": "http://smxm.ga/",
  "esair": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/calidad-aire#",
  "edgarcik": "http://edgarwrap.ontologycentral.com/cik/",
  "tsnchange": "http://purl.org/net/tsnchange#",
  "ns2": "http://ogp.me/ns#video:",
  "alg": "http://drakon.su/ADF#",
  "eproc": "http://10.0.3.120/download/eproc_FORN_v02.owl#",
  "amsl": "http://vocab.ub.uni-leipzig.de/amsl/",
  "crminf": "http://www.cidoc-crm.org/cidoc-crm/CRMinf/",
  "sorepsf": "http://sweetontology.net/reprSciFunction/",
  "occ": "http://w3id.org/occ#",
  "neotec": "http://neotec.rc.unesp.br/resource/Neotectonics/",
  "dto": "http://www.datatourisme.fr/ontology/core/1.0#",
  "ondc": "http://www.semanticweb.org/ontologies/2012/1/Ontology1329913965202.owl#",
  "ldqm": "http://linkeddata.es/resource/ldqm/",
  "elod": "http://linkedeconomy.org/ontology#",
  "edac": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl#",
  "maeco": "http://edg.topbraid.solutions/maeco/",
  "piero": "http://reactionontology.org/piero/",
  "pmonb": "http://premon.fbk.eu/ontology/nb#",
  "pop": "http://wiki.dbpedia.org/",
  "docker": "http://www.w3.org/ns/bde/docker/",
  "b3kat": "http://lod.b3kat.de/title/",
  "undata": "http://citydata.wu.ac.at/Linked-UNData/data/",
  "xbrll": "https://w3id.org/vocab/xbrll#",
  "datacron": "http://www.datacron-project.eu/datAcron#",
  "connard": "https://mail.google.com/mail/u/1/#",
  "remetca": "http://www.purl.org/net/remetca#",
  "rofhf": "http://rdaregistry.info/termList/rofhf/",
  "efd": "http://data.foodanddrinkeurope.eu/ontology#",
  "kmgeo": "http://km.aifb.kit.edu/services/geo/ontology#",
  "wail": "http://www.eyrie.org/~zednenem/2002/wail/",
  "geofabric": "http://linked.data.gov.au/def/geofabric#",
  "sohukd": "http://sweetontology.net/humanKnowledgeDomain/",
  "seo": "http://sda.tech/SEOontology/SEO/",
  "globalcube": "http://kalmar32.fzi.de/triples/global-cube.ttl#",
  "wab": "http://wab.uib.no/cost-a32_philospace/wittgenstein.owl#",
  "dcodata": "http://info.deepcarbon.net/data/schema#",
  "loci": "http://linked.data.gov.au/def/loci#",
  "pand": "http://bag.basisregistraties.overheid.nl/bag/id/pand/",
  "rico": "https://www.ica.org/standards/RiC/ontology#",
  "imas": "https://sparql.crssnky.xyz/imasrdf/URIs/imas-schema.ttl#",
  "metadata": "http://purl.oreilly.com/ns/meta/",
  "pmofn": "http://premon.fbk.eu/ontology/fn#",
  "ii": "http://sparql.cwrc.ca/ontologies/ii#",
  "ncbigene": "http://identifiers.org/ncbigene/",
  "dm2e": "http://onto.dm2e.eu/schemas/dm2e/",
  "d3s": "http://vocbench.solidaridad.cloud/taxonomies#",
  "soproptg": "http://sweetontology.net/propTemperatureGradient/",
  "gdprov": "https://w3id.org/GDPRov#",
  "iab": "https://www.iab.com/guidelines/taxonomy/",
  "unspsc": "http://ontoview.org/schema/unspsc/1#",
  "sophatmow": "http://sweetontology.net/phenAtmoWind/",
  "esproc": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/procedimientos#",
  "bci": "https://w3id.org/BCI-ontology#",
  "s4bldg": "https://w3id.org/def/saref4bldg#",
  "pmovn": "http://premon.fbk.eu/ontology/vn#",
  "sopropsdis": "http://sweetontology.net/propSpaceDistance/",
  "scra": "http://purl.org/net/schemarama#",
  "manto": "http://com.vortic3.MANTO/",
  "biolink": "https://w3id.org/biolink/vocab/",
  "marcrole": "http://id.loc.gov/vocabulary/relators/",
  "sophatmowm": "https://sweetontology.net/phenAtmoWindMesoscale/",
  "m3lite": "http://purl.org/iot/vocab/m3-lite#",
  "eustd": "http://eurostat.linked-statistics.org/data#",
  "soma": "http://sweetontology.net/matr/",
  "sopropp": "http://sweetontology.net/propPressure/",
  "vsearch": "http://vocab.sti2.at/vsearch#",
  "s3n": "http://w3id.org/s3n/",
  "olac11": "http://www.language-archives.org/OLAC/1.1/",
  "tikag": "https://www.tikag.com/",
  "soprocsc": "http://sweetontology.net/procStateChange/",
  "m3": "http://sensormeasurement.appspot.com/m3#",
  "sorepsrs": "http://sweetontology.net/reprSpaceReferenceSystem/",
  "isidore": "http://www.rechercheisidore.fr/class/",
  "rdaill": "http://rdaregistry.info/termList/IllusContent/",
  "sorepmo": "http://sweetontology.net/reprMathOperation/",
  "brt": "http://brt.basisregistraties.overheid.nl/def/top10nl#",
  "estatwrap": "http://ontologycentral.com/2009/01/eurostat/ns#",
  "rofsf": "http://rdaregistry.info/termList/rofsf/",
  "gdprtext": "https://w3id.org/GDPRtEXT#",
  "soproptf": "http://sweetontology.net/propTimeFrequency/",
  "llr": "http://lodlaundromat.org/resource/",
  "clapit": "http://dati.gov.it/onto/clapit/",
  "master1": "http://idl.u-grenoble3.fr/",
  "pm": "http://premon.fbk.eu/resource/",
  "valueflows": "https://w3id.org/valueflows/",
  "hosp": "http://health.data.gov/def/hospital/",
  "gdpr": "https://vocab.eccenca.com/gdpr/",
  "smartapi": "http://smart-api.io/ontology/1.0/smartapi#",
  "fnml": "http://semweb.mmlab.be/ns/fnml#",
  "rdavf": "http://rdaregistry.info/termList/videoFormat/",
  "llalg": "http://www.linklion.org/algorithm/",
  "vss": "http://automotive.eurecom.fr/vsso#",
  "sopropsl": "http://sweetontology.net/propSpaceLocation/",
  "bioentity": "http://bioentity.io/vocab/",
  "rami": "http://iais.fraunhofer.de/vocabs/rami#",
  "dgfr": "http://colin.maudry.com/ontologies/dgfr#",
  "irstea": "http://ontology.irstea.fr/",
  "ctxdesc": "http://www.demcare.eu/ontologies/contextdescriptor.owl#",
  "ispra": "http://dati.isprambiente.it/ontology/core#",
  "rdfdata": "http://rdf.data-vocabulary.org/rdf.xml#",
  "tavprov": "http://ns.taverna.org.uk/2012/tavernaprov/",
  "rimmf": "http://rimmf.com/vocab/",
  "fel": "http://w3id.org/vcb/fel#",
  "rsctx": "http://softeng.polito.it/rsctx#",
  "osys": "http://purl.org/olia/system.owl#",
  "emergel": "http://purl.org/emergel/core#",
  "asawoo": "http://liris.cnrs.fr/asawoo/",
  "qk": "http://qudt.org/vocab/quantitykind/",
  "sohuecons": "http://sweetontology.net/humanEnvirConservation/",
  "bibrm": "http://vocab.ub.uni-leipzig.de/bibrm/",
  "psv": "http://www.wikidata.org/prop/statement/value/",
  "refexo": "http://purl.jp/bio/01/refexo#",
  "sostc": "http://sweetontology.net/stateChemical/",
  "stencila": "http://schema.stenci.la/",
  "cbb": "https://data.cbb.omgeving.vlaanderen.be/ns/cbb#",
  "sopropcat": "http://sweetontology.net/propCategorical/",
  "rdagen": "http://rdaregistry.info/termList/RDAGeneration/",
  "isoadr": "http://reference.data.gov.au/def/ont/iso19160-1-address#",
  "wn30": "http://purl.org/vocabularies/princeton/wn30/",
  "pq": "http://www.wikidata.org/prop/qualifier/",
  "maet": "http://edg.topbraid.solutions/taxonomy/macroeconomics/",
  "dsfv": "http://sws.ifi.uio.no/vocab/dsf/henriwi/dsf#",
  "oplp": "http://www.openlinksw.com/ontology/purchases#",
  "ksam": "http://kulturarvsdata.se/ksamsok#",
  "chemsci": "https://w3id.org/skgo/chemsci#",
  "dpla": "http://dp.la/info/developers/map/",
  "linkrel": "https://www.w3.org/ns/iana/link-relations/relation#",
  "eqp": "https://data.nasa.gov/ontologies/atmonto/equipment#",
  "goaf": "http://goaf.fr/goaf#",
  "changeset": "http://purl.org/vocab/changeset/schema#",
  "gnaf": "http://linked.data.gov.au/def/gnaf#",
  "bitl": "http://lib.bit.edu.cn/ontology/1.0/",
  "pham": "https://w3id.org/skgo/pham#",
  "oplangel": "http://www.openlinksw.com/schemas/angel#",
  "gcon": "https://w3id.org/GConsent#",
  "pplan": "http://purl.org/net/p-plan#",
  "noise": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/contaminacion-acustica#",
  "rdaad": "http://rdaregistry.info/Elements/a/datatype/",
  "sophatmofo": "http://sweetontology.net/phenAtmoFog/",
  "wild": "http://purl.org/wild/vocab#",
  "sorepmso": "http://sweetontology.net/reprMathSolution/",
  "sopropsh": "http://sweetontology.net/propSpaceHeight/",
  "prohow": "https://w3id.org/prohow#",
  "omnlc": "http://open-multinet.info/ontology/omn-lifecycle#",
  "ermrk": "http://www.essepuntato.it/2008/12/earmark#",
  "losp": "http://sparql.sstu.ru:3030/speciality/",
  "sorepsu": "http://sweetontology.net/reprSciUnits/",
  "soproc": "http://sweetontology.net/proc/",
  "skosthes": "http://purl.org/iso25964/skos-thes#",
  "mdont": "http://ont.matchdeck.com/",
  "capes": "http://vocab.capes.gov.br/def/vcav#",
  "dmp": "http://www.sysresearch.org/rda-common-dmp#",
  "terms": "http://purl.org/dc/terms/",
  "snac": "http://socialarchive.iath.virginia.edu/",
  "sorepsc": "http://sweetontology.net/reprSciComponent/",
  "pmopb": "http://premon.fbk.eu/ontology/pb#",
  "cwlgit": "https://w3id.org/cwl/view/git/",
  "aseonto": "http://requirement.ase.ru/requirements_ontology#",
  "dm": "http://datamusee.givingsense.eu/onto/",
  "ordo": "http://www.orpha.net/ORDO/",
  "sorepmfo": "http://sweetontology.net/reprMathFunctionOrthogonal/",
  "soprocp": "http://sweetontology.net/procPhysical/",
  "somaoc": "http://sweetontology.net/matrOrganicCompound/",
  "sopropsp": "http://sweetontology.net/propSpeed/",
  "country": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
  "provoc": "http://ns.inria.fr/provoc/",
  "extech": "https://w3id.org/executionTechnique/ontology/",
  "sostv": "http://sweetontology.net/stateVisibility/",
  "lesa": "http://hadatac.org/ont/lesa#",
  "sorepdsa": "http://sweetontology.net/reprDataServiceAnalysis/",
  "sorepscd": "http://sweetontology.net/reprSpaceCoordinate/",
  "sosttf": "http://sweetontology.net/stateTimeFrequency/",
  "jsonschema": "https://www.w3.org/2019/wot/json-schema#",
  "sorepdf": "http://sweetontology.net/reprDataFormat/",
  "sorepsme": "http://sweetontology.net/reprSciMethodology/",
  "eproc2": "http://10.0.3.120/download/eproc_FORN_v04.owl#",
  "sophec": "http://sweetontology.net/phenEcology/",
  "soreaofl": "http://sweetontology.net/realmOceanFloor/",
  "sopropsdir": "http://sweetontology.net/propSpaceDirection/",
  "theme": "http://voc.odw.tw/theme/",
  "sorepmst": "http://sweetontology.net/reprMathStatistics/",
  "powla": "http://purl.org/powla/powla.owl#",
  "sopropef": "http://sweetontology.net/propEnergyFlux/",
  "sophoc": "http://sweetontology.net/phenOceanCoastal/",
  "esagen": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
  "sohut": "http://sweetontology.net/humanTransportation/",
  "dqc": "http://semwebquality.org/ontologies/dq-constraints#",
  "epplan": "https://w3id.org/ep-plan#",
  "daap": "http://daap.dsi.universite-paris-saclay.fr/wiki/",
  "sorept": "http://sweetontology.net/reprTime/",
  "rofet": "http://rdaregistry.info/termList/rofet/",
  "atts": "https://data.nasa.gov/ontologies/atmonto/general#",
  "sopropcha": "http://sweetontology.net/propCharge/",
  "earth": "http://linked.earth/ontology#",
  "r4r": "http://guava.iis.sinica.edu.tw/r4r/",
  "sorepdp": "http://sweetontology.net/reprDataProduct/",
  "wdv": "http://www.wikidata.org/value/",
  "sophatmopc": "http://sweetontology.net/phenAtmoPrecipitation/",
  "soprops": "http://sweetontology.net/propSpace/",
  "cwmo": "http://purl.org/cwmo/#",
  "sorelm": "http://sweetontology.net/relaMath/",
  "obws": "http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl#",
  "lcsh": "http://id.loc.gov/authorities/subjects/",
  "constant": "http://qudt.org/vocab/constant/",
  "bs": "https://w3id.org/bs#",
  "dentsci": "https://w3id.org/skgo/dentsci#",
  "sophso": "http://sweetontology.net/phenSolid/",
  "sopropti": "http://sweetontology.net/propTime/",
  "gmo": "http://purl.jp/bio/10/gmo/",
  "orgesv2": "http://datos.gob.es/sites/default/files/OntologiaDIR3/orges.owl#",
  "sophsy": "http://sweetontology.net/phenSystem/",
  "dcatnl": "http://standaarden.overheid.nl/dcatnl/terms/",
  "hctl": "https://www.w3.org/2019/wot/hypermedia#",
  "sopropmf": "http://sweetontology.net/propMassFlux/",
  "sorealc": "http://sweetontology.net/realmLandCoastal/",
  "sweet": "http://sweetontology.net/",
  "soreaa": "http://sweetontology.net/realmAtmo/",
  "shema": "http://schema.org/",
  "esgs": "https://w3id.org/edwin/ontology/",
  "wikimedia": "http://upload.wikimedia.org/wikipedia/commons/f/f6/",
  "sorepmf": "http://sweetontology.net/reprMathFunction/",
  "sorepdsv": "http://sweetontology.net/reprDataServiceValidation/",
  "voidwh": "http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl#",
  "inchikey": "https://identifiers.org/inchikey:",
  "medred": "http://w3id.org/medred/medred#",
  "sostb": "http://sweetontology.net/stateBiological/",
  "sopropdifu": "http://sweetontology.net/propDiffusivity/",
  "nrv": "http://ns.inria.fr/nrv#",
  "fssp": "http://linkeddata.fssprus.ru/resource/",
  "sopropcap": "http://sweetontology.net/propCapacity/",
  "eppl": "https://w3id.org/ep-plan#",
  "sorelpr": "http://sweetontology.net/relaProvenance/",
  "sopropsm": "http://sweetontology.net/propSpaceMultidimensional/",
  "sorepdsr": "http://sweetontology.net/reprDataServiceReduction/",
  "stx": "http://purl.org/cyber/stix#",
  "iospress": "http://ld.iospress.nl/rdf/ontology/",
  "sorepsl": "http://sweetontology.net/reprSciLaw/",
  "soreahb": "http://sweetontology.net/realmHydroBody/",
  "jup": "http://w3id.org/charta77/jup/",
  "odw": "http://odw.tw/",
  "isaterms": "http://purl.org/isaterms/",
  "estatgph": "http://estatwrap.ontologycentral.com/id/nama_aux_gph#",
  "sopropb": "http://sweetontology.net/propBinary/",
  "sopropq": "http://sweetontology.net/propQuantity/",
  "dprov": "http://promsns.org/def/do#",
  "sorepsp": "http://sweetontology.net/reprSciProvenance/",
  "sopropcou": "http://sweetontology.net/propCount/",
  "mexperf": "http://mex.aksw.org/mex-perf#",
  "vehman": "http://deductions.github.io/vehicule-management.owl.ttl#",
  "sostri": "http://sweetontology.net/stateRoleImpact/",
  "somamin": "http://sweetontology.net/matrMineral/",
  "sopropdr": "http://sweetontology.net/propDimensionlessRatio/",
  "sostrr": "http://sweetontology.net/stateRoleRepresentative/",
  "sorepts": "http://sweetontology.net/reprTimeSeason/",
  "iaph": "http://www.juntadeandalucia.es/datosabiertos/portal/iaph/dataset/dataset/6c199ca2-8d2e-4c12-833c-f28",
  "sophatmoc": "http://sweetontology.net/phenAtmoCloud/",
  "gvoi": "http://assemblee-virtuelle.github.io/grands-voisins-v2/gv.owl.ttl#",
  "lblodlg": "http://data.lblod.info/vocabularies/leidinggevenden/",
  "sorelcl": "http://sweetontology.net/relaClimate/",
  "sophfd": "http://sweetontology.net/phenFluidDynamics/",
  "somanr": "http://sweetontology.net/matrNaturalResource/",
  "ldc": "https://tac.nist.gov/tracks/SM-KBP/2018/ontologies/SeedlingOntology#",
  "sorepmg": "http://sweetontology.net/reprMathGraph/",
  "sopropm": "http://sweetontology.net/propMass/",
  "estrf": "http://vocab.linkeddata.es/datosabiertos/def/transporte/trafico#",
  "w3id": "https://w3id.org/",
  "pineapple": "http://hexananas.com/pineapple#",
  "ingredient": "http://www.owl-ontologies.com/test.owl/ingredient/",
  "soprope": "http://sweetontology.net/propEnergy/",
  "soreps": "http://sweetontology.net/reprSpace/",
  "sopropcon": "http://sweetontology.net/propConductivity/",
  "skoslex": "https://bp4mc2.org/def/skos-lex#",
  "sorep": "http://sweetontology.net/repr/",
  "wotsec": "https://www.w3.org/2019/wot/security#",
  "sorelh": "http://sweetontology.net/relaHuman/",
  "sopropo": "http://sweetontology.net/propOrdinal/",
  "sosto": "http://sweetontology.net/stateOrdinal/",
  "sostth": "http://sweetontology.net/stateThermodynamic/",
  "foio": "https://w3id.org/seas/FeatureOfInterestOntology/",
  "ideotalex": "http://www.ideotalex.eu/datos/recurso/",
  "cci": "http://cookingbigdata.com/linkeddata/ccinstances#",
  "sohutr": "http://sweetontology.net/humanTechReadiness/",
  "soreaas": "http://sweetontology.net/realmAstroStar/",
  "soreacz": "http://sweetontology.net/realmClimateZone/",
  "sfl": "http://data.finlex.fi/schema/sfl/",
  "esdbpr": "http://es.dbpedia.org/resource/",
  "soreao": "http://sweetontology.net/realmOcean/",
  "sorealo": "http://sweetontology.net/realmLandOrographic/",
  "sophatmos": "http://sweetontology.net/phenAtmoSky/",
  "sorepm": "http://sweetontology.net/reprMath/",
  "vort": "http://rockets.topbraid.solutions/vort/",
  "sophatmofr": "http://sweetontology.net/phenAtmoFront/",
  "sopropche": "http://sweetontology.net/propChemical/",
  "trek": "https://w3id.org/trek/",
  "sosttg": "http://sweetontology.net/stateTimeGeologic/",
  "loupe": "http://ont-loupe.linkeddata.es/def/core/",
  "sophpc": "http://sweetontology.net/phenPlanetClimate/",
  "sopropr": "http://sweetontology.net/propRotation/",
  "sopropfr": "http://sweetontology.net/propFraction/",
  "sophatmops": "http://sweetontology.net/phenAtmoPressure/",
  "sorepsd": "http://sweetontology.net/reprSpaceDirection/",
  "sopropi": "http://sweetontology.net/propIndex/",
  "proton": "http://www.ontotext.com/proton/",
  "lprov": "http://id.learning-provider.data.ac.uk/terms#",
  "sophatmol": "http://sweetontology.net/phenAtmoLightning/",
  "sophst": "http://sweetontology.net/phenStar/",
  "yandex": "http://yandex.ru/",
  "dave": "http://theme-e.adaptcentre.ie/dave#",
  "sorelsc": "http://sweetontology.net/relaSci/",
  "d2s": "https://w3id.org/d2s/",
  "frbroo": "http://iflastandards.info/ns/fr/frbr/frbroo/",
  "cfrl": "http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#",
  "sohues": "http://sweetontology.net/humanEnvirStandards/",
  "somains": "http://sweetontology.net/matrInstrument/",
  "sopropdife": "http://sweetontology.net/propDifference/",
  "sohuj": "http://sweetontology.net/humanJurisdiction/",
  "ddb": "http://www.deutsche-digitale-bibliothek.de/edm/",
  "taxref": "http://taxref.mnhn.fr/lod/taxon/",
  "eccf": "http://data.europa.eu/54i/",
  "sophcr": "http://sweetontology.net/phenCryo/",
  "sorear": "http://sweetontology.net/realmRegion/",
  "sostrg": "http://sweetontology.net/stateRoleGeographic/",
  "somac": "http://sweetontology.net/matrCompound/",
  "sophwn": "http://sweetontology.net/phenWaveNoise/",
  "bldont": "http://ont.biglinkeddata.com/",
  "somaae": "http://sweetontology.net/matrAerosol/",
  "sopropfu": "http://sweetontology.net/propFunction/",
  "sostso": "http://sweetontology.net/stateSolid/",
  "esagm": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
  "ecowlim": "http://ecowlim.tfri.gov.tw/lode/resource/",
  "sohur": "http://sweetontology.net/humanResearch/",
  "somaf": "http://sweetontology.net/matrFacility/",
  "sost": "http://sweetontology.net/state/",
  "soreas": "http://sweetontology.net/realmSoil/",
  "somab": "http://sweetontology.net/matrBiomass/",
  "sorelph": "http://sweetontology.net/relaPhysical/",
  "soreaaw": "http://sweetontology.net/realmAtmoWeather/",
  "sophatmo": "http://sweetontology.net/phenAtmo/",
  "somapl": "http://sweetontology.net/matrPlant/",
  "hdgi": "https://w3id.org/hdgi#",
  "osmm": "https://www.openstreetmap.org/meta/",
  "sorepdm": "http://sweetontology.net/reprDataModel/",
  "sophcm": "http://sweetontology.net/phenCycleMaterial/",
  "soprocw": "http://sweetontology.net/procWave/",
  "sostrt": "http://sweetontology.net/stateRoleTrust/",
  "sophm": "http://sweetontology.net/phenMixing/",
  "gx": "https://w3id.org/gaia-x/development#",
  "sorepsg3": "http://sweetontology.net/reprSpaceGeometry3D/",
  "sorealp": "http://sweetontology.net/realmLandProtected/",
  "sorelt": "http://sweetontology.net/relaTime/",
  "mbkeys": "https://pastebin.com/ThBfphb8#",
  "sohu": "http://sweetontology.net/human/",
  "soreaer": "http://sweetontology.net/realmEarthReference/",
  "sostrc": "http://sweetontology.net/stateRoleChemical/",
  "pcdmuse": "http://pcdm.org/use#",
  "biogrid": "http://thebiogrid.org/",
  "sosttc": "http://sweetontology.net/stateTimeCycle/",
  "sorepdsg": "http://sweetontology.net/reprDataServiceGeospatial/",
  "somaem": "http://sweetontology.net/matrElementalMolecule/",
  "somarock": "http://sweetontology.net/matrRock/",
  "somaen": "http://sweetontology.net/matrEnergy/",
  "sopropst": "http://sweetontology.net/propSpaceThickness/",
  "donto": "http://reference.data.gov.au/def/ont/dataset#",
  "phto": "http://rhizomik.net/ontologies/PlantHealthThreats.owl.ttl#",
  "ggbn": "http://data.ggbn.org/schemas/ggbn/terms/",
  "sophel": "http://sweetontology.net/phenElecMag/",
  "pnv": "https://w3id.org/pnv#",
  "asgs": "http://linked.data.gov.au/def/asgs#",
  "sorel": "http://sweetontology.net/rela/",
  "misp": "http://purl.org/cyber/misp#",
  "soreaabl": "http://sweetontology.net/realmAtmoBoundaryLayer/",
  "sophr": "http://sweetontology.net/phenReaction/",
  "sophcy": "http://sweetontology.net/phenCycle/",
  "somaind": "http://sweetontology.net/matrIndustrial/",
  "somarocki": "http://sweetontology.net/matrRockIgneous/",
  "sophft": "http://sweetontology.net/phenFluidTransport/",
  "trak": "https://purl.org/trak/metamodel/vocab#",
  "sostsy": "http://sweetontology.net/stateSystem/",
  "sopropt": "http://sweetontology.net/propTemperature/",
  "soreal": "http://sweetontology.net/realmLandform/",
  "sorelch": "http://sweetontology.net/relaChemical/",
  "soph": "http://sweetontology.net/phen/",
  "sophatmot": "http://sweetontology.net/phenAtmoTransport/",
  "probont": "http://www.probonto.org/ontology#",
  "dbm": "http://purl.org/net/dbm/ontology#",
  "sostdp": "http://sweetontology.net/stateDataProcessing/",
  "soreaofe": "http://sweetontology.net/realmOceanFeature/",
  "osmt": "https://wiki.openstreetmap.org/wiki/Key:",
  "sostsp": "http://sweetontology.net/stateSpace/",
  "soreaah": "http://sweetontology.net/realmAstroHelio/",
  "soreac": "http://sweetontology.net/realmCryo/",
  "soall": "http://sweetontology.net/sweetAll/",
  "somais": "http://sweetontology.net/matrIsotope/",
  "soreptd": "http://sweetontology.net/reprTimeDay/",
  "lv2": "http://lv2plug.in/ns/lv2core/",
  "omop": "http://api.ohdsi.org/WebAPI/vocabulary/concept/",
  "sohuc": "http://sweetontology.net/humanCommerce/",
  "cto": "https://w3id.org/cto#",
  "compub": "https://sireneld.io/vocab/compub#",
  "mmms": "http://ldf.fi/schema/mmm/",
  "sorepsmo": "http://sweetontology.net/reprSciModel/",
  "she": "http://shacleditor.org/",
  "soprocc": "http://sweetontology.net/procChemical/",
  "s4agri": "https://saref.etsi.org/saref4agri/",
  "sorepds": "http://sweetontology.net/reprDataService/",
  "sophod": "http://sweetontology.net/phenOceanDynamics/",
  "mccv": "http://purl.jp/bio/10/mccv#",
  "sophsyc": "http://sweetontology.net/phenSystemComplexity/",
  "sophhy": "http://sweetontology.net/phenHydro/",
  "sorelsp": "http://sweetontology.net/relaSpace/",
  "snomedct": "http://purl.bioontology.org/ontology/SNOMEDCT/",
  "idsc": "https://w3id.org/idsa/code/",
  "sophb": "http://sweetontology.net/phenBiol/",
  "sophei": "http://sweetontology.net/phenEnvirImpact/",
  "somaw": "http://sweetontology.net/matrWater/",
  "somas": "http://sweetontology.net/matrSediment/",
  "twitter": "http://stocktwits.com/",
  "soprop": "http://sweetontology.net/prop/",
  "s4city": "https://saref.etsi.org/saref4city/",
  "sostsb": "http://sweetontology.net/stateSpectralBand/",
  "sostrb": "http://sweetontology.net/stateRoleBiological/",
  "somaeq": "http://sweetontology.net/matrEquipment/",
  "soreabb": "http://sweetontology.net/realmBiolBiome/",
  "sophgt": "http://sweetontology.net/phenGeolTectonic/",
  "say": "https://say.data.gift/ns/",
  "somaio": "http://sweetontology.net/matrIon/",
  "sohueccont": "http://sweetontology.net/humanEnvirControl/",
  "rank": "http://www.ontotext.com/owlim/RDFRank#",
  "wds": "http://www.wikidata.org/entity/statement/",
  "sostro": "http://sweetontology.net/stateRole/",
  "sohuea": "http://sweetontology.net/humanEnvirAssessment/",
  "oco": "https://w3id.org/oc/ontology/",
  "esbici": "http://vocab.ciudadesabiertas.es/def/transporte/bicicleta-publica#",
  "omim": "http://purl.bioontology.org/ontology/OMIM/",
  "sorealt": "http://sweetontology.net/realmLandTectonic/",
  "sostef": "http://sweetontology.net/stateEnergyFlux/",
  "ccomid": "http://www.ontologyrepository.com/CommonCoreOntologies/Mid/",
  "sophen": "http://sweetontology.net/phenEnergy/",
  "oplsoft": "http://www.openlinksw.com/ontology/software#",
  "edupro": "http://ns.inria.fr/semed/eduprogression#",
  "ldes": "https://w3id.org/ldes#",
  "schoi": "https://w3id.org/scholarlydata/ontology/indicators-ontology.owl#",
  "dfc": "http://datafoodconsortium.org/ontologies/DFC_FullModel.owl#",
  "osmrel": "https://www.openstreetmap.org/relation/",
  "cbs": "http://betalinkeddata.cbs.nl/def/cbs#",
  "sophw": "http://sweetontology.net/phenWave/",
  "brot": "https://w3id.org/brot#",
  "sostf": "http://sweetontology.net/stateFluid/",
  "ocsw": "http://data.diekb.org/def/ocsw#",
  "sophgs": "http://sweetontology.net/phenGeolSeismicity/",
  "sostp": "http://sweetontology.net/statePhysical/",
  "asio": "http://purl.org/hercules/asio/core#",
  "atd": "https://data.nasa.gov/ontologies/atmonto/data#",
  "gas": "http://www.bigdata.com/rdf/gas#",
  "sorealf": "http://sweetontology.net/realmLandFluvial/",
  "taxrefprop": "http://taxref.mnhn.fr/lod/property/",
  "gleio": "http://lei.info/gleio/",
  "sostti": "http://sweetontology.net/stateTime/",
  "sophgg": "http://sweetontology.net/phenGeolGeomorphology/",
  "ciao": "http://ciao.it/",
  "eupont": "http://elite.polito.it/ontologies/eupont.owl#",
  "atm": "https://data.nasa.gov/ontologies/atmonto/ATM#",
  "sorealg": "http://sweetontology.net/realmLandGlacial/",
  "somael": "http://sweetontology.net/matrElement/",
  "soreala": "http://sweetontology.net/realmLandAeolian/",
  "sostre": "http://sweetontology.net/stateRealm/",
  "birthdate": "http://schema.org/birthDate/",
  "dd": "http://example.org/dummydata/",
  "sophfi": "http://sweetontology.net/phenFluidInstability/",
  "soman": "http://sweetontology.net/matrAnimal/",
  "sostss": "http://sweetontology.net/stateSpaceScale/",
  "matvoc": "http://stream-ontology.com/matvoc/",
  "somamic": "http://sweetontology.net/matrMicrobiota/",
  "place": "http://purl.org/ontology/places/",
  "persoon": "http://data.vlaanderen.be/ns/persoon#",
  "docam": "https://www.docam.ca/glossaurus/",
  "io": "https://iaco.me/",
  "wasa": "http://vocab.sti2.at/wasa/",
  "sophhe": "http://sweetontology.net/phenHelio/",
  "sohud": "http://sweetontology.net/humanDecision/",
  "soreaab": "http://sweetontology.net/realmAstroBody/",
  "sostsc": "http://sweetontology.net/stateSpaceConfiguration/",
  "istex": "https://data.istex.fr/ontology/istex#",
  "ci": "https://privatealpha.com/ontology/content-inventory/1#",
  "sopho": "http://sweetontology.net/phenOcean/",
  "mobiliteit": "https://data.vlaanderen.be/ns/mobiliteit#",
  "fibo": "https://spec.edmcouncil.org/fibo/ontology/master/latest/",
  "somapa": "http://sweetontology.net/matrParticle/",
  "malaka": "http://george.gr/",
  "iaco": "https://iaco.me/",
  "osmnode": "https://www.openstreetmap.org/node/",
  "ogura": "https://sparql.crssnky.xyz/Ogura_Hyakunin_Isshu_LinkedRDF/URIs/Ogura_Hyakunin_Isshu_schema.ttl#",
  "ccr": "http://cookingbigdata.com/linkeddata/ccregions#",
  "ccsla": "http://cookingbigdata.com/linkeddata/ccsla#",
  "sophgv": "http://sweetontology.net/phenGeolVolcano/",
  "sostsl": "http://sweetontology.net/stateSpectralLine/",
  "sostst": "http://sweetontology.net/stateStorm/",
  "s4ener": "https://saref.etsi.org/saref4ener/",
  "waa": "http://purl.oclc.org/NET/WebApiAuthentication#",
  "toaru": "https://metadata.moe/toaru-sparql/elements/",
  "rl": "http://rl.com/resources/",
  "sophg": "http://sweetontology.net/phenGeol/",
  "sohua": "http://sweetontology.net/humanAgriculture/",
  "dbonto": "http://dbepedia.org/ontology/",
  "oplfeat": "http://www.openlinksw.com/ontology/features#",
  "knows": "http://semantic.komc/usu/2020/knows#",
  "eppo": "https://gd.eppo.int/taxon/",
  "dfcb": "http://datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl#",
  "sophgf": "http://sweetontology.net/phenGeolFault/",
  "osmway": "https://www.openstreetmap.org/way/",
  "sorealv": "http://sweetontology.net/realmLandVolcanic/",
  "fx": "http://sparql.xyz/facade-x/ns/",
  "kko": "http://kbpedia.org/kko/rc/",
  "fernanda": "http://fernanda.nl/",
  "arp": "http://www.arpenteur.org/ontology/Arpenteur.owl#",
  "vlueprint": "https://vlueprint.org/schema/",
  "uimo": "http://vocab.sti2.at/uimo/",
  "lexicog": "http://www.w3.org/ns/lemon/lexicog#",
  "jur": "http://sweet.jpl.nasa.gov/2.3/humanJurisdiction.owl#",
  "karstlink": "https://ontology.uis-speleo.org/ontology/#",
  "rdasource": "http://rdaregistry.info/termList/RDARecordingSources/",
  "cts": "http://rdf.cdisc.org/ct/schema#",
  "mr": "http://marineregions.org/ns/ontology#",
  "bperson": "http://data.vlaanderen.be/ns/persoon#",
  "wotc": "http://purl.org/wot-catalogue#",
  "movieo": "http://movie.com/ontology/",
  "ebg": "http://data.businessgraph.io/ontology#",
  "ei2a": "http://opendata.aragon.es/def/ei2a#",
  "prismdb": "https://prismdb.takanakahiko.me/prism-schema.ttl#",
  "sorea": "http://sweetontology.net/realm/",
  "rdapol": "http://rdaregistry.info/termList/RDAPolarity/",
  "bao": "http://www.bioassayontology.org/bao#",
  "epcis": "https://ns.gs1.org/epcis/",
  "srv": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
  "saref4envi": "https://saref.etsi.org/saref4envi/",
  "ams": "http://data.amadeus.com/",
  "mgv": "http://mangaview.fr/mgv#",
  "ld": "http://linkeddata.ru/",
  "textgrid": "https://textgridrep.org/",
  "ble": "http://vocab.rapidthings.eu/ns/ble.ttl#",
  "gco": "http://purl.jp/bio/12/glyco/conjugate#",
  "gom": "https://w3id.org/gom#",
  "mpg123": "https://devuan.net.br/wiki/mpg123/",
  "i18n": "https://www.w3.org/ns/i18n#",
  "ibeacon": "http://vocab.rapidthings.eu/ns/apple/ibeacon.ttl#",
  "xyz": "http://sparql.xyz/facade-x/data/",
  "contry": "http://dbpedia.org/resource/Lyon#",
  "hpont": "https://w3id.org/hpont#",
  "freq": "http://purl.org/cld/freq/",
  "bop": "https://w3id.org/bop#",
  "tso": "https://w3id.org/tso#",
  "cso": "http://cso.kmi.open.ac.uk/schema/cso/",
  "bcom": "https://w3id.org/bcom#",
  "mag": "https://makg.org/property/",
  "marcgt": "https://id.loc.gov/vocabulary/marcgt/",
  "srr": "https://w3id.org/srr#",
  "rdat": "http://rdaregistry.info/Elements/t/",
  "quran": "http://khalidaloufi.sa/quran#",
  "pgxo": "http://ns.inria.fr/pgxo/",
  "motogp": "http://www.motogp.com/",
  "estraf": "http://vocab.ciudadesabiertas.es/def/transporte/trafico#",
  "accid": "http://pid.accurids.com/",
  "rofchrda": "http://rdaregistry.info/termList/rofchrda/",
  "oeso": "http://www.opensilex.org/vocabularies/oeso#",
  "seasd": "https://w3id.org/seas/",
  "vr": "https://www.w3.org/2018/credentials/v1/",
  "maroc": "http://fr.dbpedia.org/page/Maroc/",
  "w3geo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "mltd": "https://mltd.pikopikopla.net/mltd-schema#",
  "hops": "https://rdf.ag/o/hops#",
  "cbv": "https://ns.gs1.org/cbv/",
  "contax": "https://w3id.org/con-tax#",
  "univ": "http://univ.io/",
  "rdaut": "http://rdaregistry.info/termList/RDAUnitOfTime/",
  "la": "https://linked.art/ns/terms/",
  "hola": "https://moodle.insa-lyon.fr/course/view.php?id=",
  "vph": "http://purl.org/ozo/vph.owl#",
  "bleadapter": "http://vocab.rapidthings.eu/ns/ble/adapter.ttl#",
  "smithy": "https://awslabs.github.io/smithy/rdf-1.0#",
  "bdg": "http://data.bigdatagrapes.eu/resource/ontology/",
  "samian": "http://lod.archaeology.link/data/samian/",
  "esconv": "http://vocab.ciudadesabiertas.es/def/sector-publico/convenio#",
  "dom": "https://html.spec.whatwg.org/#",
  "rdaep": "http://rdaregistry.info/termList/RDAExtensionPlan/",
  "mesh2021": "http://id.nlm.nih.gov/mesh/2021/",
  "mdcs": "https://mdcs.monumentenkennis.nl/damageatlas/ontology#",
  "stax": "https://w3id.org/stax/ontology#",
  "aspect": "http://purl.org/aspect/",
  "check": "http://pornhub.com/",
  "ssnx": "http://purl.oclc.org/NET/ssnx/ssn#",
  "kpd": "http://purl.org/kpd/",
  "geodcat": "http://data.europa.eu/930/",
  "rdano": "http://rdaregistry.info/Elements/n/object/",
  "rpg": "http://rpg.data.is4.site/",
  "sty": "http://purl.bioontology.org/ontology/STY/",
  "nsg": "https://neuroshapes.org/",
  "slm": "http://urn.fi/URN:NBN:fi:au:slm:",
  "rdaio": "http://rdaregistry.info/Elements/i/object/",
  "rdamd": "http://rdaregistry.info/Elements/m/datatype/",
  "faas": "http://semantic-faas.com/ontology#",
  "citedcat": "https://w3id.org/citedcat-ap/",
  "rdaxd": "http://rdaregistry.info/Elements/x/datatype/",
  "mnx": "https://rdf.metanetx.org/schema/",
  "lado": "http://archaeology.link/ontology#",
  "melding": "http://lblod.data.gift/vocabularies/automatische-melding/",
  "rdaao": "http://rdaregistry.info/Elements/a/object/",
  "signify": "http://purl.org/signify/ns#",
  "esautob": "http://vocab.ciudadesabiertas.es/def/transporte/autobus#",
  "rdatb": "http://rdaregistry.info/termList/RDATypeOfBinding/",
  "roffgrda": "http://rdaregistry.info/termList/roffgrda/",
  "folio": "http://IBCNServices.github.io/Folio-Ontology/Folio.owl#",
  "idpo": "https://w3id.org/idpo#",
  "rdaid": "http://rdaregistry.info/Elements/i/datatype/",
  "ch": "https://ld.admin.ch/",
  "rdato": "http://rdaregistry.info/Elements/t/object/",
  "spec": "http://www.w3.org/ns/spec#",
  "datagc": "https://data.grottocenter.org/ldp/",
  "cerealstoo": "http://rdf.ag/o/cerealstoo#",
  "itops": "https://vocab.eccenca.com/itops/",
  "rdatask": "http://rdaregistry.info/termList/RDATasks/",
  "oidc": "http://www.w3.org/ns/solid/oidc#",
  "comp": "http://semweb.mmlab.be/ns/rml-compression#",
  "cinema": "http://www.semanticweb.org/julien/morgann/cinema#",
  "ofn": "http://www.ontotext.com/sparql/functions/",
  "rdatd": "http://rdaregistry.info/Elements/t/datatype/",
  "sou": "http://qudt.org/vocab/sou/",
  "oeo": "https://openenergyplatform.org/ontology/oeo/",
  "mrk": "http://www.mydomain.org/Mrk-ns#",
  "rofitrda": "http://rdaregistry.info/termList/rofitrda/",
  "arena": "https://solid.ti.rw.fau.de/public/ns/arena#",
  "rdan": "http://rdaregistry.info/Elements/n/",
  "esempleo": "http://vocab.ciudadesabiertas.es/def/sector-publico/empleo#",
  "rdaed": "http://rdaregistry.info/Elements/e/datatype/",
  "magmauser": "http://www.semanticweb.org/magma-core/user#",
  "rdamo": "http://rdaregistry.info/Elements/m/object/",
  "hqdmontol": "http://www.semanticweb.org/magma-core/ontologies/hqdm#",
  "tci": "https://w3id.org/lbs/tci#",
  "react": "https://w3id.org/react#",
  "rdapd": "http://rdaregistry.info/Elements/p/datatype/",
  "luigiusai": "https://www.luigiusai.it/wp#",
  "oghamonto": "http://ontology.ogham.link/",
  "rdamat": "http://rdaregistry.info/termList/RDAMaterial/",
  "nanopub": "http://www.nanopub.org/nschema#",
  "rdawo": "http://rdaregistry.info/Elements/w/object/",
  "memorix": "http://memorix.io/ontology#",
  "matrycs": "http://matrycs.com/",
  "mrt": "http://marineregions.org/ns/placetypes#",
  "rdaim": "http://rdaregistry.info/termList/RDAInteractivityMode/",
  "m8g": "http://data.europa.eu/m8g/",
  "feed": "https://www.feedipedia.org/",
  "rdaxo": "http://rdaregistry.info/Elements/x/object/",
  "rofsfrda": "http://rdaregistry.info/termList/rofsfrda/",
  "cpc": "https://data.epo.org/linked-data/def/cpc/",
  "encargado": "http://semRAT.edu/",
  "xmlns": "http://www.w3.org/2021/XMLSchema#",
  "eep": "https://w3id.org/eep#",
  "ogham": "http://lod.ogham.link/data/",
  "rdasca": "http://rdaregistry.info/termList/scale/",
  "m4i": "http://w3id.org/nfdi4ing/metadata4ing#",
  "nbo": "http://data.bioontology.org/ontologies/NBO/",
  "edu": "https://schema.edu.ee/",
  "poke": "https://pokemonkg.org/ontology#",
  "rdand": "http://rdaregistry.info/Elements/n/datatype/",
  "bcfowl": "http://lbd.arch.rwth-aachen.de/bcfOWL#",
  "paf": "https://paf.link/",
  "caso": "http://www.w3id.org/def/caso#",
  "aff": "https://w3id.org/affectedBy#",
  "rdap": "http://rdaregistry.info/Elements/p/",
  "cpg": "http://modellingdh.github.io/ont/odp/pgc/",
  "interop": "http://www.w3.org/ns/solid/interop#",
  "eurio": "http://data.europa.eu/s66#",
  "s223": "http://data.ashrae.org/standard223#",
  "sds": "https://w3id.org/sds#",
  "ewg": "http://ethoinformatics.org/",
  "uberon": "http://purl.obolibrary.org/obo/UBERON_",
  "nsd": "https://w3id.org/nsd#",
  "cgo": "https://www.tno.nl/agrifood/ontology/common-greenhouse-ontology#",
  "biocrm": "http://ldf.fi/schema/bioc/",
  "srt": "http://w3id.org/srt#",
  "rc": "https://w3id.org/rc#",
  "lds": "https://solid.ti.rw.fau.de/public/ns/linked-data-structures#",
  "djo": "http://purl.org/datajourneys/",
  "srmo": "https://w3id.org/srmo#",
  "esc": "https://solid.ti.rw.fau.de/public/ns/event-sourcing-containers#",
  "dsd": "https://w3id.org/dsd#",
  "rdapath": "http://rdaregistry.info/termList/RDARecordingMethods/",
  "godaddy": "https://sso.godaddy.com/",
  "tro": "https://w3id.org/TRO/",
  "eb": "https://w3id.org/eb#",
  "kdsf": "https://kerndatensatz-forschung.de/version1/technisches_datenmodell/owl/kdsf.owl#",
  "olias": "http://purl.org/olia/system.owl#",
  "asf": "https://www.stm-assoc.org/asf/",
  "rdawd": "http://rdaregistry.info/Elements/w/datatype/",
  "bau": "https://terminology.fraunhofer.de/voc/bau#",
  "ghga": "http://w3id.org/ghga/",
  "quid": "https://w3id.org/quid/",
  "bdsubj": "https://purl.org/fidbaudigital/subjects#",
  "gax": "http://w3id.org/gaia-x/core#",
  "meat": "http://example.com/",
  "chameo": "https://w3id.org/emmo/domain/characterisation-methodology/chameo#",
  "srtun": "https://www.inf.bi.rub.de/srtun#",
  "ldpsc": "https://solid.ti.rw.fau.de/public/ns/stream-containers#",
  "ea": "http://eaontology.protect.linkeddata.es/def/",
  "lbds": "https://w3id.org/lbdserver#",
  "rsx": "http://rdf4j.org/shacl-extensions#",
  "walmart": "https://www.amazon.de/",
  "tern": "https://w3id.org/tern/ontologies/tern/",
  "wfont": "https://w3id.org/wfont#",
  "ontobras": "http://www.semanticweb.org/fefar/ontologies/ontobras#",
  "rto": "https://w3id.org/rail/topo#",
  "conllu": "https://universaldependencies.org/format.html#",
  "lbdserver": "https://w3id.org/lbdserver#",
  "archivo": "https://archivo.dbpedia.org/onto#",
  "ofo": "https://w3id.org/ofo#",
  "ppeer": "http://parliament.uk/ontologies/peerage/",
  "stirdata": "https://w3id.org/stirdata/vocabulary/",
  "magmardl": "http://www.semanticweb.org/magma-core/rdl#",
  "osdu": "https://w3id.org/OSDU#",
  "generiek": "https://data.vlaanderen.be/ns/generiek#",
  "wdno": "http://www.wikidata.org/prop/novalue/",
  "experts": "http://emmo.info/emmo/application/maeo/experts#",
  "stix": "http://purl.org/cyber/stix#",
  "bag2": "http://bag.basisregistraties.overheid.nl/def/bag#",
  "hqdm": "http://www.semanticweb.org/hqdm#",
  "dmo": "https://w3id.org/dmo#",
  "linkml": "https://w3id.org/linkml/",
  "opltw": "http://www.openlinksw.com/schemas/twitter#",
  "setl": "http://purl.org/twc/vocab/setl/",
  "diso": "https://purls.helmholtz-metadaten.de/diso#",
  "nprl": "http://data.nobelprize.org/resource/laureate/",
  "fso": "https://w3id.org/fso#",
  "marc": "http://www.loc.gov/MARC21/slim/",
  "crmsci": "http://www.cidoc-crm.org/extensions/crmsci/",
  "fpr": "http://www.filmstandards.org/schemas/filmportal_relations#",
  "rmlt": "http://semweb.mmlab.be/ns/rml-target#",
  "express": "https://w3id.org/express#",
  "paam": "https://lod.mediathek-tanz-theater.de/schema/paam/",
  "nomo": "https://nomenclature.info/nom/ontology/",
  "covido": "https://w3id.org/CovidO#",
  "rsp": "http://www.researchspace.org/resource/",
  "jsonld": "http://www.w3.org/ns/json-ld#",
  "itcrdf": "http://www.w3.org/2005/11/its/rdf#",
  "rro": "http://semanticweb.org/patricia/ontologies/rro#",
  "rdaeo": "http://rdaregistry.info/Elements/e/object/",
  "lsqr": "http://lsq.aksw.org/",
  "roh": "http://w3id.org/roh#",
  "hni": "https://collectiedata.hetnieuweinstituut.nl/",
  "raum": "https://terminology.fraunhofer.de/voc/raum#",
  "pgo": "http://ii.uwb.edu.pl/pgo#",
  "weki": "https://en.wikipedia.org/wiki/",
  "rism": "http://rism.online/",
  "ultragaz": "https://ultragaz24horas.com/",
  "value": "http://gfgfd.vs/",
  "kgi": "http://ns.inria.fr/kg/index#",
  "lrcommon": "http://landregistry.data.gov.uk/def/common/",
  "rnce": "https://data.cultureelerfgoed.nl/id/rnce#",
  "besluitvor": "https://data.vlaanderen.be/ns/besluitvorming#",
  "linkedart": "https://linked.art/ns/terms/",
  "chemrof": "https://w3id.org/chemrof/",
  "tempo": "http://purl.org/tempo/",
  "respond": "https://w3id.org/respond#",
  "cido": "http://purl.obolibrary.org/obo/cido.owl/",
  "gufo": "http://purl.org/nemo/gufo#",
  "chess": "http://purl.org/NET/rdfchess/ontology/",
  "vl": "https://version.link/",
  "iddo": "https://w3id.org/iddo#",
  "consolid": "https://w3id.org/consolid#",
  "nom": "https://nomenclature.info/nom/",
  "dsi": "https://data.dsi.omgeving.vlaanderen.be/ns/dsi#",
  "osmo": "https://purl.org/vimmp/osmo#",
  "icon": "https://w3id.org/icon/ontology/",
  "film": "http://semantics.id/ns/example/film/",
  "bp3": "http://www.biopax.org/release/biopax-level3.owl#",
  "vntourism": "http://www.semanticweb.org/minhn/ontologies/2021/0/vntourism#",
  "rtedurp": "http://purl.org/eduo/rtedurp/",
  "grscicoll": "https://www.gbif.org/grscicoll/collection/",
  "peco": "https://w3id.org/peco#",
  "ttrpg": "https://w3id.org/TTRpg#",
  "gql": "http://www.openlinksw.com/schemas/graphql#",
  "rcgs": "https://collection.rcgs.jp/terms/",
  "robotarm": "https://solid.ti.rw.fau.de/public/ns/robotArm#",
  "cvb": "http://rdfs.org/resume-rdf/base.rdfs#",
  "relation": "http://www.iana.org/assignments/relation/",
  "mondo": "http://purl.obolibrary.org/obo/MONDO_",
  "apods": "http://activitypods.org/ns/core#",
  "spatialf": "http://jena.apache.org/function/spatial#",
  "veelana": "http://onlyfans.com/veelana/",
  "aec3po": "https://w3id.org/lbd/aec3po/",
  "pubchem": "https://pubchem.ncbi.nlm.nih.gov/",
  "perscido": "https://perscido.univ-grenoble-alpes.fr/",
  "dbd": "http://dbpedia.org/datatype/",
  "nen2660": "https://w3id.org/nen2660/def#",
  "raad": "https://raadzaam.nl/schema/",
  "kokot": "http://www.koko.t/",
  "fdp": "https://w3id.org/fdp/fdp-o#",
  "dqvno": "https://data.norge.no/vocabulary/dqvno#",
  "vhbieo": "https://w3id.org/vhbieo#",
  "version": "https://version.link/",
  "yanice": "http://yanice-boady.webflow.io/",
  "era": "http://data.europa.eu/949/",
  "iottta": "https://w3id.org/iot-tta#",
  "bmp": "http://w3id.org/bmp#",
  "nalt": "https://lod.nal.usda.gov/nalt/",
  "lis": "http://rds.posccaesar.org/ontology/lis14/rdl/",
  "coy": "https://schema.coypu.org/global#",
  "dcb": "http://dbpedia.org/resource/Category:",
  "ufo": "http://ufo.com/#",
  "skosm": "http://www.w3.org/2004/02/skos/mapping#",
  "lol": "https://sbalot.github.io/lol/",
  "docbook": "http://docbook.org/ns/docbook/",
  "epo": "http://data.europa.eu/a4g/ontology#",
  "bto": "http://w3id.org/emmo-bto/bto#",
  "plant": "http://example.org/plant/",
  "fdof": "https://w3id.org/fdof/ontology#",
  "thub": "http://vocabularis.crai.ub.edu/thub/",
  "bcgo": "http://purl.obolibrary.org/obo/ZP_",
  "emmo": "https://w3id.org/emmo#",
  "dcatap": "http://data.europa.eu/r5r/",
  "ecfo": "https://w3id.org/ecfo#",
  "dick": "http://pornhub.com/",
  "dcatno": "https://data.norge.no/vocabulary/dcatno#",
  "nutscode": "http://data.europa.eu/nuts/code/",
  "fs": "https://www.compliancequest.com/training-management-software-system-solutions/",
  "hmas": "https://purl.org/hmas/",
  "mi": "http://www.marineinfo.org/ns/ontology#",
  "vcs": "https://data.vlaanderen.be/ns/chemische_stof#",
  "dbpg": "http://dbpedia.org/page/",
  "ontouml": "https://w3id.org/ontouml#",
  "to": "http://purl.obolibrary.org/obo/TO_",
  "asb": "https://w3id.org/asbingowl/core#",
  "ags": "https://id.agschemas.org/",
  "wrroc": "https://w3id.org/ro/terms/workflow-run#",
  "hyr": "https://w3id.org/simulation/data/",
  "ammo": "http://ldf.fi/schema/ammo/",
  "threat": "https://cve.mitre.org/",
  "acp": "http://www.w3.org/ns/solid/acp#",
  "coreo": "http://purl.org/coreo#",
  "goavoc": "http://bio2rdf.org/goa_vocabulary:",
  "atcc": "https://www.atcc.org/products/",
  "baf": "https://w3id.org/baf#",
  "cur": "http://qudt.org/2.1/vocab/currency/",
  "ntp": "https://schema.finto.fi/ntp#",
  "matmine": "http://materialsmine.org/ns/",
  "pico": "https://personsincontext.org/model#",
  "risk": "https://www.w3id.org/risk#",
  "iop": "https://w3id.org/iadopt/ont/",
  "imbor": "https://data.crow.nl/imbor/def/",
  "coos": "http://id.unece.org/def/coos#",
  "lcnaf": "http://id.loc.gov/authorities/names/",
  "egdo": "http://example.org/",
  "mibc": "http://marineinfo.org/ns/library/bibcodes#",
  "databus": "https://dataid.dbpedia.org/databus#",
  "sense": "https://w3id.org/sense#",
  "ksamsok": "http://kulturarvsdata.se/ksamsok#",
  "p2po": "https://purl.org/p2p-o#",
  "ind": "https://w3id.org/inesdata#",
  "bacnet": "http://data.ashrae.org/bacnet/2020#",
  "uio": "https://www.mitre.org/mparmelee/ontologies/2023/6/UserIntentOntology/",
  "tsso": "https://scch.org/technical_standards#",
  "hu": "https://mail.google.com/",
  "rb": "https://w3id.org/riverbench/schema/metadata#",
  "quest": "https://rb.gy/ntg7l/",
  "ceox": "https://linkeddata.cultureelerfgoed.nl/def/ceox#",
  "coswot": "https://w3id.org/coswot/",
  "mindat": "https://www.mindat.org/",
  "fisa": "https://ifitkau.github.io/fisa/",
  "keyon": "http://keyelements.ltd/ontologies/keyon/#",
  "ogcf": "http://www.opengis.net/def/function/geosparql/",
  "coda": "http://art.uniroma2.it/coda/contracts/",
  "ocmv": "https://w3id.org/ontouml-models/vocabulary#",
  "exekg": "https://raw.githubusercontent.com/nsai-uio/ExeKGOntology/main/ds_exeKGOntology.ttl#",
  "mibt": "https://marineinfo.org/ns/library/bibtypes#",
  "bsdd": "http://bsdd.buildingsmart.org/def#",
  "pit": "http://data.elsevier.com/vocabulary/ElsevierPubItemTypes/",
  "rbdoc": "https://w3id.org/riverbench/schema/documentation#",
  "into": "https://app.korfin.de/ontology/into/",
  "bioschemas": "https://bioschemas.org/",
  "koko": "https://seznam.cz/",
  "cpsvno": "http://data.norge.no/vocabulary/cpsvno#",
  "doce": "http://purl.org/nemo/doce#",
  "hy": "https://api.hyprdia.com/",
  "notify": "http://www.w3.org/ns/solid/notifications#",
  "sssom": "https://w3id.org/sssom/",
  "lpwcc": "https://linkedpaperswithcode.com/class/",
  "mifesto": "https://w3id.org/mifesto#",
  "ncbi": "https://www.ncbi.nlm.nih.gov/",
  "cercabib": "https://cercabib.ub.edu/",
  "battery": "https://w3id.org/emmo/domain/battery/battery#",
  "plasma": "https://w3id.org/plasma#",
  "semapv": "https://w3id.org/semapv/vocab/",
  "mpio": "http://purl.obolibrary.org/obo/ZP_",
  "pbac": "https://w3id.org/pbac#",
  "cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties/",
  "w3": "http://www.w3.org/",
  "dde": "https://www.ddeworld.org/",
  "doam": "http://emmo.info/doam#",
  "pdumdv": "http://purl.obolibrary.org/obo/PdumDv_",
  "ontologia": "http://ub.edu/dades/ontologia/Cinema#Cinemes#",
  "quit": "http://quit.aksw.org/vocab/",
  "ontohgis": "https://onto.kul.pl/ontohgis/",
  "skosno": "http://data.norge.no/skosno#",
  "ioc": "http://w3id.org/ioc#",
  "isoprops": "https://w3id.org/isoprops#",
  "hsapdv": "http://purl.obolibrary.org/obo/HsapDv_",
  "top": "http://w3id.org/topologicpy#",
  "nmr": "https://www.ebi.ac.uk/ols4/ontologies/nmrcv/terms?short_form=NMR:",
  "sri": "https://w3id.org/sri#",
  "mfo": "http://purl.obolibrary.org/obo/ZP_",
  "oplben": "http://www.openlinksw.com/ontology/benefits#",
  "batmanont": "http://emmo.info/emmo/application/bmo#",
  "pcp": "https://pcp-on-web.de/ontology/0.2/index-en.html#",
  "loggerhead": "http://purl.obolibrary.org/obo/LOGGERHEAD_",
  "interpro": "https://www.ebi.ac.uk/interpro/entry/InterPro/",
  "ohd": "http://purl.obolibrary.org/obo/ZP_",
  "chpaf": "https://ch.paf.link/",
  "sure": "http://ns.inria.fr/sure#",
  "ies": "http://ies.data.gov.uk/ontology/ies4#",
  "ornaseq": "http://purl.obolibrary.org/obo/ORNASEQ_",
  "gramene": "http://www.gramene.org/db/ontology/search?id=GRO:",
  "mir": "http://marineinfo.org/ns/person/roles#",
  "lpwc": "https://linkedpaperswithcode.com/property/",
  "oav": "http://lod.openaire.eu/vocab/",
  "ies4": "http://ies.data.gov.uk/ontology/ies4#",
  "clyh": "http://purl.obolibrary.org/obo/ZP_",
  "hom": "http://purl.obolibrary.org/obo/HOM_",
  "upheno": "http://purl.obolibrary.org/obo/UPHENO_",
  "apollosv": "http://purl.obolibrary.org/obo/APOLLO_SV_",
  "ddpheno": "http://purl.obolibrary.org/obo/DDPHENO_",
  "sbo": "https://paul.ti.rw.fau.de/~jo00defe/ble/sbo#",
  "eurovoc": "http://eurovoc.europa.eu/",
  "fro": "https://foundry.ai.mil/ontology/nas/fro/",
  "maeo": "http://w3id.org/emmo-maeo/maeo#",
  "proco": "http://purl.obolibrary.org/obo/PROCO_",
  "htn": "http://purl.obolibrary.org/obo/ZP_",
  "openwemi": "https://ns.dublincore.org/openwemi/",
  "przecieki": "http://onlyfans.com/emiliaszymanska/",
  "cred": "https://www.w3.org/2018/credentials#",
  "fovt": "http://purl.obolibrary.org/obo/FOVT_",
  "nyon": "https://w3id.org/def/nyon#",
  "sopharm": "http://purl.obolibrary.org/obo/SOPHARM_",
  "iig": "https://w3id.org/iicongraph/data/",
  "imdb": "http://m.imdb.com/",
  "sep": "http://purl.obolibrary.org/obo/ZP_",
  "tdm": "http://www.w3.org/ns/tdmrep#",
  "msl": "https://w3id.org/msl#",
  "cergy": "https://dbpedia.org/page/Cergy/",
  "kbmarc": "https://id.kb.se/marc/",
  "loinc": "https://loinc.org/",
  "wbls": "http://purl.obolibrary.org/obo/WBls_",
  "cob": "http://purl.obolibrary.org/obo/COB_",
  "mao": "https://domestic-beethoven.eu/ontology/1.0/music-annotation-ontology.ttl#",
  "htv": "http://www.w3.org/2011/http#",
  "olis": "http://olis.dev/",
  "iptc4xmpc": "http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/",
  "soa": "https://semopenalex.org/ontology/",
  "vt": "http://purl.obolibrary.org/obo/VT_",
  "jps": "https://jpsearch.go.jp/term/property#",
  "capdata": "https://ontologie.capdataculture.fr/v1/owl/#",
  "gallont": "http://purl.obolibrary.org/obo/GALLONT_",
  "lpto": "http://w3id.org/lpto#",
  "mro": "http://purl.obolibrary.org/obo/MRO_",
  "oplmarket": "http://www.openlinksw.com/ontology/market#",
  "occupation": "http://nikunj.org/ontology/occupatioin#",
  "deonta": "https://deonta.linkedmodel.org/deonta/",
  "credit": "https://credit.niso.org/",
  "osh": "https://w3id.org/oseg/ont/osh#",
  "echem": "https://w3id.org/emmo/domain/electrochemistry#",
  "iceo": "http://purl.obolibrary.org/obo/ICEO_",
  "taxrank": "http://purl.obolibrary.org/obo/TAXRANK_",
  "mee": "http://www.w3.org/ns/pim/meeting#",
  "shsh": "http://www.w3.org/ns/shacl-shacl#",
  "chems": "https://w3id.org/emmo/domain/chemical-substance#",
  "dgaterms": "https://w3id.org/dgaterms#",
  "geolink": "http://schema.geolink.org/1.0/base/main#",
  "doid": "http://purl.obolibrary.org/obo/DOID_",
  "fbdv": "http://purl.obolibrary.org/obo/FBdv_",
  "crmgeo": "http://www.ics.forth.gr/isl/CRMgeo/",
  "planp": "http://purl.obolibrary.org/obo/PLANP_",
  "mop": "http://purl.obolibrary.org/obo/MOP_",
  "gecko": "http://purl.obolibrary.org/obo/ZP_",
  "hao": "http://purl.obolibrary.org/obo/HAO_",
  "tops": "http://www.topbraid.org/tops#",
  "okh": "https://w3id.org/oseg/ont/okh#",
  "clao": "http://purl.obolibrary.org/obo/CLAO_",
  "obi": "http://purl.obolibrary.org/obo/OBI_",
  "emap": "http://purl.obolibrary.org/obo/EMAP_",
  "dcid": "https://datacommons.org/browser/",
  "liph": "https://gallosiciliani.unict.it/ns/lpont#",
  "mco": "http://purl.obolibrary.org/obo/MCO_",
  "vhog": "http://purl.obolibrary.org/obo/VHOG_",
  "aao": "http://purl.obolibrary.org/obo/AAO_",
  "spd": "http://purl.obolibrary.org/obo/SPD_",
  "mbl": "https://w3id.org/mbl#",
  "sibo": "http://purl.obolibrary.org/obo/ZP_",
  "propreo": "http://purl.obolibrary.org/obo/PROPREO_",
  "maid": "https://mutual-aid.app/ns/core#",
  "schemas": "https://schema.org/",
  "cmf": "http://purl.obolibrary.org/obo/CMF_",
  "lrm": "https://iflastandards.info/ns/lrm/lrmoo/",
  "fbbt": "http://purl.obolibrary.org/obo/FBbt_",
  "omo": "http://purl.obolibrary.org/obo/OMO_",
  "firebim": "http://w3id.org/firebim#",
  "fbcv": "http://purl.obolibrary.org/obo/FBcv_",
  "apmwg": "http://apmwg.ovh/",
  "qualityze": "https://www.qualityze.com/document-management/",
  "hpo": "http://w3id.org/emmo-hpo/hpo#",
  "foaa": "https://kibanshoe.com/",
  "uo": "http://purl.obolibrary.org/obo/UO_",
  "meas": "https://graph.interoptx.org/meas/",
  "tsdcreq": "https://w3id.org/oseg/ont/tsdc/req#",
  "idomal": "http://purl.obolibrary.org/obo/IDOMAL_",
  "ovae": "http://purl.obolibrary.org/obo/OVAE_",
  "ecp": "http://www.ebu.ch/metadata/ontologies/ebucoreplus#",
  "oio": "http://www.geneontology.org/formats/oboInOwl#",
  "sepio": "http://purl.obolibrary.org/obo/SEPIO_",
  "fiaf": "https://ontology.fiafcore.org/",
  "spo": "https://w3id.org/steel/ProcessOntology/",
  "ons": "http://purl.obolibrary.org/obo/ONS_",
  "cvdo": "http://purl.obolibrary.org/obo/CVDO_",
  "ecocore": "http://purl.obolibrary.org/obo/ECOCORE_",
  "dpo": "http://purl.obolibrary.org/obo/FBcv_",
  "ogsf": "http://purl.obolibrary.org/obo/OGSF_",
  "pao": "http://purl.obolibrary.org/obo/PAO_",
  "rxno": "http://purl.obolibrary.org/obo/ZP_",
  "foodon": "http://purl.obolibrary.org/obo/FOODON_",
  "gtm": "https://www.goudatijdmachine.nl/def#",
  "aimaix": "https://w3id.org/aimaix#",
  "ontoavida": "http://purl.obolibrary.org/obo/ONTOAVIDA_",
  "imr": "http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IMR&id=",
  "edtf": "http://id.loc.gov/datatypes/EDTFScheme/",
  "tto": "http://purl.obolibrary.org/obo/TTO_",
  "clo": "http://purl.obolibrary.org/obo/ZP_",
  "mfoem": "http://purl.obolibrary.org/obo/MFOEM_",
  "cacax": "http://cacax.fun/",
  "cwo": "http://kcoyle.net/cwo/",
  "dictionary": "https://standards.buildingsmart.org/DataDictionary/",
  "uiot": "http://www.w3id.org/urban-iot/core#",
  "duo": "http://purl.obolibrary.org/obo/DUO_",
  "pgdso": "http://purl.obolibrary.org/obo/PGDSO_",
  "multionto": "http://purl.org/net/multionto/",
  "bootstrep": "http://purl.obolibrary.org/obo/BOOTSTREP_",
  "vair": "https://w3id.org/vair#",
  "mat": "http://purl.obolibrary.org/obo/MAT_",
  "bcnres": "http://datos.bcn.cl/ontologies/bcn-resources#",
  "stroke": "https://mre.zcu.cz/ontology/stroke.owl#",
  "miprog": "https://marineinfo.org/ns/progress#",
  "hht": "https://w3id.org/HHT#",
  "obom": "https://w3id.org/open-bom/ont/open-bom#",
  "xco": "http://purl.obolibrary.org/obo/XCO_",
  "crcr": "https://credit.niso.org/contributor-roles/",
  "xao": "http://purl.obolibrary.org/obo/XAO_",
  "guez": "http://guez.fr/",
  "mmusdv": "http://purl.obolibrary.org/obo/MmusDv_",
  "bspo": "http://purl.obolibrary.org/obo/BSPO_",
  "pwkso": "http://ns.inria.fr/pwkso/",
  "ncro": "http://purl.obolibrary.org/obo/NCRO_",
  "tgma": "http://purl.obolibrary.org/obo/TGMA_",
  "symp": "http://purl.obolibrary.org/obo/SYMP_",
  "after": "http://rds.posccaesar.org/ontology/plm/ds/",
  "libeas": "https://w3id.org/libeas#",
  "geogeo": "http://purl.obolibrary.org/obo/GEO_",
  "emobon": "http://www.embrc.eu/emobon/EmoBonOntology#",
  "amv": "https://w3id.org/amv/",
  "oba": "http://purl.obolibrary.org/obo/OBA_",
  "eupath": "http://purl.obolibrary.org/obo/EUPATH_",
  "joe": "http://example.org/joe/",
  "tsdc": "https://w3id.org/oseg/ont/tsdc/core#",
  "labo": "http://purl.obolibrary.org/obo/LABO_",
  "mfomd": "http://purl.obolibrary.org/obo/MFOMD_",
  "mpath": "http://purl.obolibrary.org/obo/MPATH_",
  "ohpi": "http://purl.obolibrary.org/obo/OHPI_",
  "ehdaa": "http://purl.obolibrary.org/obo/EHDAA_",
  "pa": "http://vtw.elsevier.com/data/ns/properties/PromotionalAccess-1/",
  "cams": "https://graph.interoptx.org/cams/schema/",
  "duodrl": "https://w3id.org/duodrl#",
  "ypc": "http://www.semanticweb.org/sunsr/ontologies/2024/ypc#",
  "did": "https://w3id.org/dob/id/",
  "zea": "http://purl.obolibrary.org/obo/ZEA_",
  "gsso": "http://purl.obolibrary.org/obo/GSSO_",
  "luffy": "http://google.com/",
  "qcy": "https://qaecy.com/dev/ont#",
  "otrl": "https://w3id.org/oseg/ont/otrl#",
  "termdat": "https://register.ld.admin.ch/termdat/",
  "nihss": "https://mre.zcu.cz/ontology/nihss.owl#",
  "biomodels": "http://purl.obolibrary.org/obo/KISAO_",
  "pdro": "http://purl.obolibrary.org/obo/PDRO_",
  "apo": "http://purl.obolibrary.org/obo/APO_",
  "edo": "http://semanticweb.org/edo#",
  "lipro": "http://purl.obolibrary.org/obo/LIPRO_",
  "chmo": "http://purl.obolibrary.org/obo/CHMO_",
  "moont": "https://w3id.org/moont/",
  "opmi": "http://purl.obolibrary.org/obo/OPMI_",
  "disdriv": "http://purl.obolibrary.org/obo/DISDRIV_",
  "dideo": "http://purl.obolibrary.org/obo/DIDEO_",
  "ckg": "http://example.org/ckg#",
  "ogg": "http://purl.obolibrary.org/obo/OGG_",
  "pes": "https://semanticweb.inesctec.pt/ontologies/pes/",
  "cr": "http://mlcommons.org/croissant/",
  "dop": "https://w3id.org/dob/voc/prop#",
  "nyanneko": "https://nyanneko.com/",
  "txpo": "http://purl.obolibrary.org/obo/ZP_",
  "cteno": "http://purl.obolibrary.org/obo/CTENO_",
  "adw": "https://animaldiversity.org/accounts/",
  "amphx": "http://purl.obolibrary.org/obo/AMPHX_",
  "dprod": "https://ekgf.github.io/dprod/",
  "ogms": "http://purl.obolibrary.org/obo/OGMS_",
  "pcl": "http://purl.obolibrary.org/obo/PCL_",
  "ico": "http://purl.obolibrary.org/obo/ICO_",
  "flopo": "http://purl.obolibrary.org/obo/FLOPO_",
  "chiro": "http://purl.obolibrary.org/obo/CHIRO_",
  "rdfl": "https://w3id.org/rdf-lens/ontology#",
  "hancestro": "http://purl.obolibrary.org/obo/HANCESTRO_",
  "ceph": "http://purl.obolibrary.org/obo/CEPH_",
  "pw": "http://purl.obolibrary.org/obo/PW_",
  "norse": "https://w3id.org/aksw/norse#",
  "spa": "https://paul.ti.rw.fau.de/~jo00defe/voc/spa#",
  "oplmark": "http://www.openlinksw.com/ontology/market#",
  "lepao": "http://purl.obolibrary.org/obo/LEPAO_",
  "vbo": "http://purl.obolibrary.org/obo/VBO_",
  "psdo": "http://purl.obolibrary.org/obo/PSDO_",
  "aio": "https://paul.ti.rw.fau.de/~jo00defe/SemWoT/aio#",
  "vario": "http://purl.obolibrary.org/obo/VariO_",
  "cmso": "http://purls.helmholtz-metadaten.de/cmso/",
  "crdt": "https://vocab.noeldemartin.com/crdt/",
  "flu": "http://purl.obolibrary.org/obo/FLU_",
  "psn": "https://purl.org/psn/vocab#",
  "fbbi": "http://purl.obolibrary.org/obo/FBbi_",
  "oarcs": "http://purl.obolibrary.org/obo/OARCS_",
  "makeup": "http://example.org/makeup#",
  "whyis": "http://vocab.rpi.edu/whyis/",
  "airo": "https://w3id.org/airo#",
  "oplgit": "http://www.openlinksw.com/schemas/github#",
  "aix": "https://w3id.org/aix#",
  "oostt": "http://purl.obolibrary.org/obo/OOSTT_",
  "bila": "http://4dx.embl.de/4DXpress/reg/all/cview/gene.do?geneID=",
  "ado": "http://purl.obolibrary.org/obo/ADO_",
  "nomen": "http://purl.obolibrary.org/obo/NOMEN_",
  "fix": "http://purl.obolibrary.org/obo/FIX_",
  "omit": "http://purl.obolibrary.org/obo/OMIT_",
  "ehdaa2": "http://purl.obolibrary.org/obo/EHDAA2_",
  "tahe": "http://purl.obolibrary.org/obo/TAHE_",
  "slso": "http://purl.obolibrary.org/obo/SLSO_",
  "omrse": "http://purl.obolibrary.org/obo/OMRSE_",
  "dob": "https://w3id.org/dob/voc#",
  "olatdv": "http://purl.obolibrary.org/obo/OlatDv_",
  "occo": "http://purl.obolibrary.org/obo/OCCO_",
  "ypo": "http://purl.obolibrary.org/obo/YPO_",
  "loin": "http://w3id.org/loin#",
  "musi": "http://i-na-reg.musikinstrumentenbau.eu/ns/musi/",
  "lrmer": "http://iflastandards.info/ns/lrm/lrmer/",
  "oplog": "http://www.openlinksw.com/schemas/opengraph#",
  "tahh": "http://purl.obolibrary.org/obo/TAHH_",
  "tads": "http://purl.obolibrary.org/obo/TADS_",
  "dinto": "http://purl.obolibrary.org/obo/ZP_",
  "ror": "https://ror.org/",
  "ceosp": "https://linkeddata.cultureelerfgoed.nl/def/ceosp/",
  "zeco": "http://purl.obolibrary.org/obo/ZECO_",
  "cdno": "http://purl.obolibrary.org/obo/CDNO_",
  "mcro": "https://www.ebi.ac.uk/ols4/ontologies/mcro/classes?obo_id=MCRO:",
  "envo": "http://purl.obolibrary.org/obo/ENVO_",
  "vsao": "http://purl.obolibrary.org/obo/VSAO_",
  "rmle": "https://w3id.org/imec/rml/ns/extensions#",
  "ogi": "http://purl.obolibrary.org/obo/OGI_",
  "ohmi": "http://purl.obolibrary.org/obo/OHMI_",
  "plana": "http://purl.obolibrary.org/obo/PLANA_",
  "reloc": "https://w3id.org/reloc#",
  "wbbt": "http://purl.obolibrary.org/obo/WBbt_",
  "eo": "http://purl.obolibrary.org/obo/EO_",
  "zfa": "http://purl.obolibrary.org/obo/ZFA_",
  "afpo": "http://purl.obolibrary.org/obo/AfPO_",
  "graphql": "https://graphql.org/",
  "dblpdocu": "https://dblp.org/rdf/docu/#",
  "ehda": "http://purl.obolibrary.org/obo/EHDA_",
  "geno": "http://purl.obolibrary.org/obo/GENO_",
  "npc": "https://purl.org/npc#",
  "hso": "http://purl.obolibrary.org/obo/HSO_",
  "womo": "https://w3id.org/womo#",
  "vto": "http://purl.obolibrary.org/obo/VTO_",
  "oip": "http://www.exemple.org/ontologia/",
  "ssv": "https://w3id.org/ssv/",
  "t4fs": "http://purl.obolibrary.org/obo/T4FS_",
  "miron": "https://stgermain.ebsi.umontreal.ca/miron/",
  "upa": "http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=",
  "vwlid": "https://vwgroup.leanix.net/Volkswagen/external/leanixId/",
  "epio": "http://purl.obolibrary.org/obo/EPIO_",
  "omiabis": "http://purl.obolibrary.org/obo/OMIABIS_",
  "scdo": "http://purl.obolibrary.org/obo/SCDO_",
  "cfg": "http://server.topbraidlive.org/web/2009/config#",
  "kvasir": "https://kvasir.discover.ilabt.imec.be/vocab#",
  "cio": "http://purl.obolibrary.org/obo/CIO_",
  "fbsp": "http://purl.obolibrary.org/obo/FBSP_",
  "oplic": "http://www.openlinksw.com/ontology/licenses#",
  "colao": "http://purl.obolibrary.org/obo/COLAO_",
  "geosrs": "https://w3id.org/geosrs#",
  "fobi": "http://purl.obolibrary.org/obo/FOBI_",
  "vo": "http://purl.obolibrary.org/obo/VO_",
  "mfmo": "http://purl.obolibrary.org/obo/MFMO_",
  "freespins": "https://bohoaff.com/a34fd6fba/",
  "psm": "https://paul.ti.rw.fau.de/~jo00defe/ont/psm#",
  "zp": "http://purl.obolibrary.org/obo/ZP_",
  "gaz": "http://purl.obolibrary.org/obo/GAZ_",
  "maxo": "http://purl.obolibrary.org/obo/MAXO_",
  "gno": "http://purl.obolibrary.org/obo/GNO_",
  "ato": "http://purl.obolibrary.org/obo/ATO_",
  "genepio": "http://purl.obolibrary.org/obo/GENEPIO_",
  "fypo": "http://purl.obolibrary.org/obo/FYPO_",
  "miapa": "http://purl.obolibrary.org/obo/MIAPA_",
  "dtkt": "https://data.wikitrek.org/prop/direct/",
  "obcs": "http://purl.obolibrary.org/obo/OBCS_",
  "jabel54303": "https://softwarehorsepower.com/product/brand24/",
  "trans": "http://purl.obolibrary.org/obo/TRANS_",
  "zfs": "http://purl.obolibrary.org/obo/ZFS_",
  "resid": "https://proteininformationresource.org/cgi-bin/resid?id=",
  "volipi": "http://data.sparna.fr/ontologies/volipi#",
  "rex": "http://purl.obolibrary.org/obo/REX_",
  "mpbv": "http://meta-pfarrerbuch.evangelische-archive.de/vocabulary#",
  "jav": "https://www.niso.org/schemas/jav/1.0/",
  "iev": "http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IEV&id=",
  "oplgp": "http://www.openlinksw.com/schemas/googleplus#",
  "cdi": "http://ddialliance.org/Specification/DDI-CDI/1.0/RDF/",
  "xpo": "http://purl.obolibrary.org/obo/XPO_",
  "aism": "http://purl.obolibrary.org/obo/AISM_",
  "dron": "http://purl.obolibrary.org/obo/DRON_",
  "micro": "http://purl.obolibrary.org/obo/MICRO_",
  "ftr": "https://w3id.org/ftr#",
  "aschema": "https://schema.ld.admin.ch/",
  "hhtchange": "https://w3id.org/HHT/Change#",
  "aero": "http://purl.obolibrary.org/obo/AERO_",
  "fair4ml": "https://w3id.org/fair4ml#",
  "poro": "http://purl.obolibrary.org/obo/PORO_",
  "miro": "http://purl.obolibrary.org/obo/MIRO_",
  "myv": "http://www.example.com/myvData/",
  "ecao": "http://purl.obolibrary.org/obo/ECAO_",
  "checks": "https://data.digichecks.eu/def/",
  "tsdcr": "http://w3id.org/oseg/ont/tsdc/requirements#",
  "oix": "http://www.exemple.org/ontologia/",
  "ddanat": "http://purl.obolibrary.org/obo/DDANAT_",
  "ino": "http://purl.obolibrary.org/obo/INO_",
  "codemeta": "https://codemeta.github.io/terms/",
  "ngbo": "http://purl.obolibrary.org/obo/NGBO_",
  "fideo": "http://purl.obolibrary.org/obo/FIDEO_",
  "emapa": "http://purl.obolibrary.org/obo/EMAPA_",
  "rnao": "http://purl.obolibrary.org/obo/RNAO_",
  "ce": "https://purl.org/cityexplorer#",
  "gsn": "https://w3id.org/OntoGSN/ontology#",
  "sn": "https://purl.org/supply-network/onto#",
  "stato": "http://purl.obolibrary.org/obo/STATO_",
  "phipo": "http://purl.obolibrary.org/obo/PHIPO_",
  "caro": "http://purl.obolibrary.org/obo/CARO_",
  "aicat": "http://w3id.org/aicat#",
  "xlmod": "http://purl.obolibrary.org/obo/XLMOD_",
  "zo": "https://linkeddata.cultureelerfgoed.nl/def/zo/",
  "aiup": "http://w3id.org/aiup#",
  "obib": "http://purl.obolibrary.org/obo/OBIB_",
  "bng": "https://w3id.org/dob/voc/epsg-27700#",
  "ceon": "http://w3id.org/CEON/",
  "creon": "http://purl.org/creon/",
  "dtk": "https://data.wikitrek.org/entity/",
  "azo": "https://linkeddata.cultureelerfgoed.nl/def/azo/",
  "nace2": "http://data.europa.eu/ux2/nace2/",
  "onlyfans": "https://cutt.ly/3ry8LMcK/",
  "frac": "http://www.w3.org/ns/lemon/frac#",
  "podio": "http://w3id.org/podio#",
  "ecto": "http://purl.obolibrary.org/obo/ECTO_",
  "encom": "https://semanticweb.inesctec.pt/ontologies/encom/",
  "northwind": "http://demo.openlinksw.com/schemas/Northwind/",
  "mirnao": "http://purl.obolibrary.org/obo/MIRNAO_",
  "vwlpr": "https://vwgroup.leanix.net/Volkswagen/factsheet/Process/",
  "fugas": "https://onlyfans.com/sammuwuu/",
  "passport": "https://nepalpassport.gov.np/",
  "aro": "http://purl.obolibrary.org/obo/ARO_",
  "nsprov": "http://www.w3.org/ns/prov#",
  "vrti": "https://www.w3id.org/virtual-treasury/ontology#",
  "tgc": "http://www.hds.utc.fr/tg#",
  "aeo": "http://purl.obolibrary.org/obo/AEO_",
  "fti": "http://franz.com/ns/allegrograph/2.2/textindex/",
  "regcomp": "https://regulacomp.unige.ch/ns/regcomp#",
  "spot": "https://w3id.org/spot#",
  "bam": "http://vtw.elsevier.com/data/voc/ns/bam-vtw-1/",
  "arco": "https://w3id.org/arco/ontology/arco/",
  "pur": "http://prismstandard.org/namespaces/prismusagerights/2.1/",
  "unesco": "http://vocabularies.unesco.org/thesaurus/",
  "ishi": "https://w3id.org/ishikawa-diagram-ontology#",
  "tgfm": "http://purl.org/terminology-guide-for-move/testvocab/",
  "oqs": "http://purl.org/nsoluti/oqs#",
  "vwlap": "https://vwgroup.leanix.net/Volkswagen/factsheet/Application/",
  "ncl": "https://w3id.org/NCL/ontology/",
  "och": "http://w3id.org/def/och/",
  "fwo": "https://w3id.org/foodwaste/ontology#",
  "drammar": "http://www.purl.org/drammar#",
  "scdt": "http://w3id.org/awslabs/neptune/SPARQL-CDTs/",
  "bambara": "http://example.org/bambara#",
  "jats": "http://jats.nlm.nih.gov/",
  "picom": "https://personsincontext.org/model#",
  "debias": "http://data.europa.eu/c4p/data/",
  "lindas": "https://ld.admin.ch/",
  "npo": "https://w3id.org/NPO/ontology/",
  "turism": "http://turism.com/",
  "itandrec": "http://www.semanticweb.org/pedri/ontologies/2025/3/IntelligentTourismAndRecommendations#",
  "libro": "https://www.librorum.fr/ontology/",
  "know": "https://know.dev/",
  "ppm": "https://mestergruppen.no/ontologies/projectproductionmanagement/",
  "dsio": "https://ptb.de/si#",
  "datmm": "http://id.nlm.nih.gov/datmm/",
  "rbo": "http://purl.obolibrary.org/obo/RBO_",
  "dbpde": "http://de.dbpedia.org/property/",
  "ris": "http://research-info-systems.com/schema/ris/",
  "icd": "http://purl.bioontology.org/ontology/ICD9CM/",
  "sip": "https://purl.semanticip.org/linked-data/",
  "vwgw": "https://group-wiki.wob.vw.vwg/wikis/pages/viewpage.action?pageId=",
  "iirds": "http://iirds.tekom.de/iirds#",
  "eliasempre": "https://eliasempresas.com/",
  "sis": "https://ptb.de/sis/",
  "elsst": "https://elsst.cessda.eu/id/",
  "riskman": "https://w3id.org/riskman/ontology#",
  "reno": "https://w3id.org/reno#",
  "vwdms": "https://vwdmsweb.wob.vw.vwg/groupdms/?docbase=vwdms&locateId=",
  "sulo": "https://w3id.org/sulo/",
  "vm": "http://visual-meaning.com/rdf/",
  "golem": "https://w3id.org/golem/ontology#",
  "muno": "https://purl.org/muno/onto/",
  "bu": "http://borhan-onto.ir/ontology/upper#",
  "whu": "http://bdi.whu.edu.cn/",
  "genex": "http://purl.org/genex#",
  "semts": "https://w3id.org/semts/ontology#",
  "rdb": "http://www.dbs.cs.uni-duesseldorf.de/RDF/relational#",
  "dqa": "https://w3id.org/DQA#",
  "coso": "http://w3id.org/coso/v1/contaminoso#",
  "pmw": "http://ponymusic.wiki/ns#",
  "ubbont": "http://data.ub.uib.no/ontology/",
  "gro": "http://www.bootstrep.eu/ontology/GRO#",
  "evorao": "http://w3id.org/evorao/",
  "tribont": "https://w3id.org/tribont/core#",
  "coar": "http://purl.org/coar/resource_type/",
  "piveau": "https://piveau.eu/ns/voc#",
  "akco": "https://purl.archive.org/akco#",
  "exmo": "http://purl.obolibrary.org/obo/EXMO_",
  "csro": "https://w3id.org/csro/ontology#",
  "elm": "http://data.europa.eu/snb/model/elm/",
  "rdfc": "https://w3id.org/rdf-connect#",
  "csr": "http://purl.org/org/iode/po/voc/cruise-summary-reports#",
  "dtool": "https://devtoolkit.space/ontology#",
  "afy": "https://w3id.org/afy#",
  "dcatde": "http://dcat-ap.de/def/dcatde/",
  "a11y": "http://idpf.org/epub/vocab/package/a11y/#",
  "sz": "https://github.com/senzing-garage/sz-semantics/wiki/ns#",
  "bmont": "http://purl.obolibrary.org/obo/BMONT_",
  "bodi": "http://w3id.org/bodi#",
  "sdn": "https://ontology.seadatanet.org/#",
  "pghdprovo": "https://w3id.org/pghdprovo#",
  "homoit": "https://homosaurus.org/v4/",
  "bno": "https://data.banenor.no/ontology/",
  "modsrdf": "http://www.loc.gov/mods/rdf/v1#",
  "mdcat": "https://w3id.org/mobilitydcat-ap#",
  "tbs": "http://topbraid.org/tbs#",
  "bnd": "https://data.banenor.no/data/",
  "tensor": "https://w3id.org/rdf-tensor/vocab#",
  "tfn": "https://w3id.org/time-fn#",
  "lib": "http://purl.org/library/",
  "rtm": "http://ontology.railml.org/railtopomodel#",
  "railml3": "http://ontology.railml.org/railml3#",
  "dccs": "https://ptb.de/dccs/",
  "ard": "https://www.stratcom.mil/ontologies/electromagnetic-spectrum/adversary-radar-detection-ontology/",
  "omekas": "http://omeka.org/s/vocabs/o#",
  "dpp": "https://ns.verisav.fr/dpp#",
  "lubm": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
  "rdm": "https://terms.codata.org/rdmt/",
  "geodcatap": "http://data.europa.eu/930/",
  "aaao": "https://ontology.swissartresearch.net/aaao/",
  "let": "http://uispin.org/let#",
  "submit": "https://ns.verisav.fr/dpp#",
  "dpvpd": "https://w3id.org/dpv/pd#",
  "iut": "https://cours.iut-orsay.fr/",
  "vlaanderen": "https://data.vlaanderen.be/ns/",
  "osmkey": "https://www.openstreetmap.org/wiki/Key:",
  "idtype": "https://data.elsevier.com/e/identifier/",
  "whg": "https://w3id.org/whg/id/",
  "mdo": "http://w3id.org/mdo/",
  "plato": "https://w3id.org/plato#",
  "med": "http://data.esante.gouv.fr/ansm/medicament/",
  "tf": "https://takumifujimoto.com/schema/",
  "animl": "http://www.w3id.org/animl/ontology/",
  "mlca": "https://w3id.org/mlca/",
  "mdr": "https://w3id.org/mdr#",
  "coord": "http://qudt.org/vocab/coordinate/",
  "gid": "https://inspirewrap.ontologycentral.com/adv/gid/7.1#",
  "dbn": "https://www.darrinbaines.org/ns/identity#",
  "riepr": "https://data.riepr.omgeving.vlaanderen.be/ns/riepr#",
  "lth": "https://vocab.lifetidy.com/",
  "gwn": "https://globalwordnet.github.io/schemas/wn#",
  "i40fd": "http://w3id.org/iaam/i40fd#",
  "puv": "http://data.elsevier.com/publishing/schema/puv/",
  "lack": "https://purl.net/climatesense/lack/ns#",
  "mqto": "https://w3id.org/mqto#",
  "statdcatap": "http://data.europa.eu/s1n/",
  "norma": "https://w3id.org/def/norma-o#",
  "aic": "https://w3id.org/aic#",
  "spectra": "https://w3id.org/spectra#",
  "tal": "http://xml.zope.org/namespaces/tal/",
  "bcore": "https://w3id.org/bcore/",
  "multi": "https://semanticweb.tools/ont/multi#",
  "vwag": "https://devstack.vwgroup.com/",
  "lbco": "https://w3id.org/batcat#",
  "ontodic": "http://tecnolettra.uji.es/ontodic#",
  "tfo": "http://opendata.inrae.fr/PO2/Ontology/TransformON/",
  "bedo": "https://w3id.org/bedo/",
  "haishutsu": "https://wik.jp/haishutsu/",
  "faptica": "https://faptica.com/",
  "kasen": "https://wik.jp/kasen/",
  "odic": "http://tecnolettra.uji.es/ontodic#",
  "sstim": "https://w3id.org/sstim#",
  "vwcds": "https://devstack.vwgroup.com/confluence/rest/api/content/",
  "copi": "https://www.inf.ufrgs.br/ontologies/copi/",
  "bedro": "https://w3id.org/bedro/",
  "denchi": "https://wik.jp/denchi/",
  "aeovis": "https://prismdiscovery.ai/ontology/aeo#",
  "dengen": "https://wik.jp/dengen/",
  "fract": "https://w3id.org/refract#",
  "idsa": "https://w3id.org/idsa/core/",
  "kobutsu": "https://wik.jp/kobutsu/",
  "laosez": "https://laos.world/ns/khetsetthakit/",
  "smart": "https://w3id.org/standards/smart/ontologies/core/",
  "fairo": "https://w3id.org/fair-o#",
  "uogto": "https://w3id.org/uogto/core#",
  "bousai": "https://wik.jp/bousai/",
  "wjl": "https://wik.jp/law/ns#",
  "uogtox": "https://w3id.org/uogto/extensions#",
  "eau": "https://w3id.org/eautonome/",
  "laokhoueng": "https://laos.world/ns/khoueng/",
  "tokutei": "https://wik.jp/tokutei/",
  "gakkou": "https://wik.jp/gakkou/",
  "hon": "https://honoria.co.uk/id/honours#",
  "laomuang": "https://laos.world/ns/muang/",
  "gijutsu": "https://wik.jp/gijutsu/",
  "laopasa": "https://laos.world/ns/pasa/",
  "sdc": "https://w3id.org/statbarnsdc#",
  "jgs": "https://wik.jp/jgs/",
  "shokugyo": "https://wik.jp/shokugyo/",
  "mnf": "https://w3id.org/imo/manufacturing#",
  "mim": "http://modellen.mim-standaard.nl/def/mim#",
  "houki": "https://wik.jp/houki/",
  "kunishitei": "https://wik.jp/kunishitei/",
  "hojin": "https://wik.jp/hojin/",
  "campop": "https://w3id.org/campop/",
  "todofuken": "https://wik.jp/todofuken/",
  "laomoladok": "https://laos.world/ns/moladok/",
  "laoboun": "https://laos.world/ns/boun/",
  "laosonphao": "https://laos.world/ns/sonphao/",
  "hinmoku": "https://wik.jp/hinmoku/",
  "sangyo": "https://wik.jp/sangyo/",
  "bsdo": "https://w3id.org/bsdo#",
  "hinshi": "https://wik.jp/hinshi/",
  "kikaku": "https://wik.jp/kikaku/",
  "rcl": "https://realcharacterlanguage.world/",
  "tani": "https://wik.jp/tani/",
  "koyomi": "https://wik.jp/koyomi/",
  "cbam": "https://wik.jp/cbam/",
  "pd": "https://w3id.org/dpv/pd#",
  "rewt": "https://w3id.org/rewt/",
  "gsoc": "https://w3id.org/gso/1.0/common/",
  "gsel": "https://w3id.org/gso/1.0/element/",
  "kagaku": "https://wik.jp/kagaku/",
  "didl": "https://w3id.org/didl#",
  "smartsh": "https://w3id.org/standards/smart/schema/data/",
  "gsrm": "https://w3id.org/gso/1.0/rockmaterial/",
  "gsmin": "https://w3id.org/gso/1.0/mineral/",
  "sb": "https://purl.org/supplybench#",
  "gsev": "https://w3id.org/gso/1.0/geologicevent/",
  "gscn": "https://w3id.org/gso/1.0/geologiccontact/",
  "gsfa": "https://w3id.org/gso/1.0/geologicfault/",
  "oso": "https://w3id.org/earthsemantics/OSO/",
  "hanami": "https://hanami.app/ontology#",
  "xwkont": "https://w3id.org/xwkont/core#",
  "g1": "https://portejunes.com/ns/core#",
  "ocp": "https://w3id.org/cmod/ocp#",
  "gum": "http://www.ontospace.uni-bremen.de/ontology/stable/GUM-3.owl#",
  "spdx3": "https://spdx.org/rdf/3/terms/",
  "cenova": "http://data.cenova.org/ontology/",
  "dedl": "https://w3id.org/dedl#",
  "iobc": "http://purl.jp/bio/4/id/",
  "wsem": "https://w3id.org/websemantic/ns#",
  "hcm": "https://w3id.org/hcmo/ontology/hcm#",
  "martialis": "https://w3id.org/martialis/ontology#",
  "aug": "https://w3id.org/augmanitai/lexicon/"
}
